{
    "type": "featureCollection",
    "features": [
      {
        "type": "Feature",
        "properties": {
          "ADMIN": "UK",
          "ISO_A3": "GBR",
          "ISO_A2": "GB"
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -6.287505662999905,
                  49.914007880000057
                ],
                [
                  -6.297271287999934,
                  49.909613348000065
                ],
                [
                  -6.30915279899989,
                  49.913641669000029
                ],
                [
                  -6.307443813999896,
                  49.927435614000146
                ],
                [
                  -6.298817511999886,
                  49.935492255000085
                ],
                [
                  -6.292225714999916,
                  49.932074286000059
                ],
                [
                  -6.28416907499988,
                  49.922756252000127
                ],
                [
                  -6.287505662999905,
                  49.914007880000057
                ]
              ]
            ],
            [
              [
                [
                  -6.326486782999893,
                  49.949204820000105
                ],
                [
                  -6.332508917999888,
                  49.941717841000056
                ],
                [
                  -6.341216600999871,
                  49.944769598000121
                ],
                [
                  -6.348052537999905,
                  49.956203518000095
                ],
                [
                  -6.348947719999899,
                  49.964341539000102
                ],
                [
                  -6.341786261999857,
                  49.96360911699999
                ],
                [
                  -6.336822068999908,
                  49.96092357
                ],
                [
                  -6.333648240999935,
                  49.95970286699999
                ],
                [
                  -6.328033006999931,
                  49.956610419000086
                ],
                [
                  -6.326486782999893,
                  49.949204820000105
                ]
              ]
            ],
            [
              [
                [
                  -1.295765753999916,
                  50.773179429000109
                ],
                [
                  -1.14427649599989,
                  50.73379140800013
                ],
                [
                  -1.119536912999905,
                  50.734198309000035
                ],
                [
                  -1.109120245999918,
                  50.732855536000059
                ],
                [
                  -1.097035285999908,
                  50.726955471000039
                ],
                [
                  -1.096424933999856,
                  50.724432684000092
                ],
                [
                  -1.097645636999857,
                  50.716009833000058
                ],
                [
                  -1.097035285999908,
                  50.713324286000088
                ],
                [
                  -1.09422766799986,
                  50.712632554000137
                ],
                [
                  -1.085560675999943,
                  50.714016018
                ],
                [
                  -1.082753058999913,
                  50.713324286000088
                ],
                [
                  -1.062326626999948,
                  50.692816473000121
                ],
                [
                  -1.062326626999948,
                  50.685288804000052
                ],
                [
                  -1.066965298999946,
                  50.685248114000061
                ],
                [
                  -1.069650844999927,
                  50.683498440000065
                ],
                [
                  -1.071888800999915,
                  50.680975653000147
                ],
                [
                  -1.075306769999941,
                  50.67853424700003
                ],
                [
                  -1.112700975999871,
                  50.671454169000143
                ],
                [
                  -1.12865149599989,
                  50.666449286000116
                ],
                [
                  -1.156361456999889,
                  50.650783596000153
                ],
                [
                  -1.162220831999917,
                  50.645982164000074
                ],
                [
                  -1.16470292899993,
                  50.640936591000028
                ],
                [
                  -1.164133266999983,
                  50.619370835000112
                ],
                [
                  -1.16502844999988,
                  50.608221747000087
                ],
                [
                  -1.168446417999888,
                  50.603461005
                ],
                [
                  -1.279204881999931,
                  50.582505601000051
                ],
                [
                  -1.315541144999941,
                  50.58917877800009
                ],
                [
                  -1.445952928999873,
                  50.648138739000061
                ],
                [
                  -1.452788865999878,
                  50.654282945000134
                ],
                [
                  -1.485951300999915,
                  50.669338283000158
                ],
                [
                  -1.497425910999937,
                  50.672308661000059
                ],
                [
                  -1.535145636999914,
                  50.66937897300015
                ],
                [
                  -1.551503058999941,
                  50.665106512000037
                ],
                [
                  -1.569488084999875,
                  50.658026434000149
                ],
                [
                  -1.545318162999877,
                  50.686102606000176
                ],
                [
                  -1.505930141999983,
                  50.707709052000084
                ],
                [
                  -1.418690558999884,
                  50.73379140800013
                ],
                [
                  -1.420887824999852,
                  50.730454820000105
                ],
                [
                  -1.423451300999972,
                  50.72370026200015
                ],
                [
                  -1.425363735999923,
                  50.720119533000101
                ],
                [
                  -1.400868292999888,
                  50.721991278000147
                ],
                [
                  -1.377552863999881,
                  50.734198309000035
                ],
                [
                  -1.343495245999861,
                  50.761053778000033
                ],
                [
                  -1.31851152299987,
                  50.772162177000055
                ],
                [
                  -1.295765753999916,
                  50.773179429000109
                ]
              ]
            ],
            [
              [
                [
                  -0.938832160999908,
                  50.78839752800009
                ],
                [
                  -0.938832160999908,
                  50.780951239000117
                ],
                [
                  -1.020741339999859,
                  50.78839752800009
                ],
                [
                  -1.020741339999859,
                  50.79515208500014
                ],
                [
                  -0.998687303999873,
                  50.801011460000083
                ],
                [
                  -0.972564256999902,
                  50.829779364000117
                ],
                [
                  -0.959868943999936,
                  50.829331773000135
                ],
                [
                  -0.950306769999969,
                  50.823797919000114
                ],
                [
                  -0.947824673999946,
                  50.817816473000093
                ],
                [
                  -0.95140540299991,
                  50.812445380000142
                ],
                [
                  -0.959868943999936,
                  50.808254299000012
                ],
                [
                  -0.959868943999936,
                  50.802069403000033
                ],
                [
                  -0.954579230999883,
                  50.79881419499999
                ],
                [
                  -0.94562740799995,
                  50.791815497000115
                ],
                [
                  -0.938832160999908,
                  50.78839752800009
                ]
              ]
            ],
            [
              [
                [
                  -4.663482225999928,
                  51.164862372000172
                ],
                [
                  -4.670480923999918,
                  51.160101630000085
                ],
                [
                  -4.678537563999953,
                  51.16705963700015
                ],
                [
                  -4.679798956999974,
                  51.180568752000127
                ],
                [
                  -4.676421678999958,
                  51.193101304000137
                ],
                [
                  -4.671213344999956,
                  51.195054429
                ],
                [
                  -4.666981574999852,
                  51.18768952
                ],
                [
                  -4.6654353509999,
                  51.183579820000048
                ],
                [
                  -4.663970506999931,
                  51.177069403000147
                ],
                [
                  -4.663482225999928,
                  51.164862372000172
                ]
              ]
            ],
            [
              [
                [
                  0.936371290000125,
                  51.371039130000057
                ],
                [
                  0.91146894600007,
                  51.364406643
                ],
                [
                  0.794769727000073,
                  51.370550848000065
                ],
                [
                  0.77507571700005,
                  51.37531159100017
                ],
                [
                  0.75757897200009,
                  51.386419989
                ],
                [
                  0.743500196000042,
                  51.400091864000146
                ],
                [
                  0.733897332000083,
                  51.41217682500006
                ],
                [
                  0.746836785000085,
                  51.439642645000092
                ],
                [
                  0.753916863000143,
                  51.445705471000096
                ],
                [
                  0.766937696000127,
                  51.447943427000055
                ],
                [
                  0.890798373000052,
                  51.421047268000095
                ],
                [
                  0.900563998000109,
                  51.417547919000086
                ],
                [
                  0.91146894600007,
                  51.41217682500006
                ],
                [
                  0.932465040000125,
                  51.39769114799999
                ],
                [
                  0.942149285000085,
                  51.38300202
                ],
                [
                  0.936371290000125,
                  51.371039130000057
                ]
              ]
            ],
            [
              [
                [
                  -4.655669725999871,
                  53.319769598000093
                ],
                [
                  -4.644195115999906,
                  53.319525458000143
                ],
                [
                  -4.626291469999956,
                  53.320868231000034
                ],
                [
                  -4.618885870999861,
                  53.317084052
                ],
                [
                  -4.60383053299995,
                  53.308172919000143
                ],
                [
                  -4.590443488999938,
                  53.297552802000112
                ],
                [
                  -4.580922003999945,
                  53.285467841000028
                ],
                [
                  -4.577259894999912,
                  53.272040106000034
                ],
                [
                  -4.57274329299986,
                  53.266506252000013
                ],
                [
                  -4.563954230999883,
                  53.260443427000112
                ],
                [
                  -4.558461066999939,
                  53.252752997000087
                ],
                [
                  -4.563628709999961,
                  53.241929429
                ],
                [
                  -4.571888800999943,
                  53.23948802300005
                ],
                [
                  -4.581898566999911,
                  53.242010809000178
                ],
                [
                  -4.602406378999888,
                  53.253078518
                ],
                [
                  -4.622792120999861,
                  53.275946356000119
                ],
                [
                  -4.63255774599989,
                  53.282945054000024
                ],
                [
                  -4.641346808999884,
                  53.284369208000086
                ],
                [
                  -4.67039954299986,
                  53.282945054000024
                ],
                [
                  -4.676665818999908,
                  53.28510163
                ],
                [
                  -4.693959113999881,
                  53.302801825000117
                ],
                [
                  -4.693959113999881,
                  53.309637762000122
                ],
                [
                  -4.667307094999956,
                  53.323919989000117
                ],
                [
                  -4.655669725999871,
                  53.319769598000093
                ]
              ]
            ],
            [
              [
                [
                  -4.203236456999946,
                  53.298488674000012
                ],
                [
                  -4.190581834999875,
                  53.296576239000146
                ],
                [
                  -4.177805141999926,
                  53.297552802000112
                ],
                [
                  -4.154896613999938,
                  53.301825262000037
                ],
                [
                  -4.142486131999903,
                  53.302801825000117
                ],
                [
                  -4.136626756999874,
                  53.305080471000068
                ],
                [
                  -4.127797003999916,
                  53.314846096000039
                ],
                [
                  -4.121978318999879,
                  53.317084052
                ],
                [
                  -4.115142381999931,
                  53.315904038999989
                ],
                [
                  -4.10252844999988,
                  53.310777085000055
                ],
                [
                  -4.098133917999888,
                  53.309637762000122
                ],
                [
                  -4.068918423999946,
                  53.310370184000149
                ],
                [
                  -4.055043097999942,
                  53.308539130000085
                ],
                [
                  -4.042876756999874,
                  53.302801825000117
                ],
                [
                  -4.063384568999908,
                  53.28929271000014
                ],
                [
                  -4.098052537999905,
                  53.2501488300001
                ],
                [
                  -4.121978318999879,
                  53.241929429
                ],
                [
                  -4.146717902999853,
                  53.239081122000144
                ],
                [
                  -4.171986456999889,
                  53.231390692000119
                ],
                [
                  -4.195546027999853,
                  53.220282294000114
                ],
                [
                  -4.214833136999886,
                  53.20722077000012
                ],
                [
                  -4.218495245999918,
                  53.204046942000062
                ],
                [
                  -4.220366990999906,
                  53.201483466000141
                ],
                [
                  -4.22101803299995,
                  53.197455145000092
                ],
                [
                  -4.22101803299995,
                  53.190130927000084
                ],
                [
                  -4.222035285999908,
                  53.182114976000136
                ],
                [
                  -4.225005662999905,
                  53.181219794000143
                ],
                [
                  -4.229359503999916,
                  53.182196356000119
                ],
                [
                  -4.264556443999879,
                  53.166937567000147
                ],
                [
                  -4.280140753999945,
                  53.154974677000112
                ],
                [
                  -4.343861456999917,
                  53.132066148000106
                ],
                [
                  -4.354359503999888,
                  53.129950262000094
                ],
                [
                  -4.36668860599994,
                  53.131415106000148
                ],
                [
                  -4.392404751999891,
                  53.138332424000069
                ],
                [
                  -4.392689581999917,
                  53.13605377800009
                ],
                [
                  -4.398671027999939,
                  53.132757880000057
                ],
                [
                  -4.406605597999885,
                  53.130601304000052
                ],
                [
                  -4.412831183999856,
                  53.132066148000106
                ],
                [
                  -4.41429602799991,
                  53.137844143000095
                ],
                [
                  -4.413685675999943,
                  53.147121486000131
                ],
                [
                  -4.411976691999939,
                  53.155585028000175
                ],
                [
                  -4.409738735999952,
                  53.15940989799999
                ],
                [
                  -4.40192623599998,
                  53.163723049000097
                ],
                [
                  -4.390370245999861,
                  53.173081773000135
                ],
                [
                  -4.38512122299997,
                  53.182440497000144
                ],
                [
                  -4.395741339999916,
                  53.186712958000086
                ],
                [
                  -4.410878058999913,
                  53.182196356000119
                ],
                [
                  -4.432850714999916,
                  53.162909247000172
                ],
                [
                  -4.447580532999922,
                  53.15940989799999
                ],
                [
                  -4.448557094999899,
                  53.162543036000059
                ],
                [
                  -4.481678839999916,
                  53.179877020000148
                ],
                [
                  -4.484486456999974,
                  53.18060944200009
                ],
                [
                  -4.492502407999922,
                  53.179348049000069
                ],
                [
                  -4.495350714999859,
                  53.179877020000148
                ],
                [
                  -4.496001756999903,
                  53.182562567000119
                ],
                [
                  -4.494699673999918,
                  53.190863348
                ],
                [
                  -4.495350714999859,
                  53.193548895000092
                ],
                [
                  -4.495106574999909,
                  53.196478583000115
                ],
                [
                  -4.496327277999939,
                  53.203802802000112
                ],
                [
                  -4.499623175999972,
                  53.211249091000084
                ],
                [
                  -4.519886847999885,
                  53.22284577
                ],
                [
                  -4.553089972999885,
                  53.261948960000055
                ],
                [
                  -4.571034308999856,
                  53.275458075000031
                ],
                [
                  -4.571034308999856,
                  53.282945054000024
                ],
                [
                  -4.565256313999981,
                  53.293036200000145
                ],
                [
                  -4.563221808999856,
                  53.308254299000126
                ],
                [
                  -4.563628709999961,
                  53.33006419500002
                ],
                [
                  -4.558664516999897,
                  53.363348700000088
                ],
                [
                  -4.560861782999893,
                  53.377834377000127
                ],
                [
                  -4.571034308999856,
                  53.392767645000092
                ],
                [
                  -4.553456183999913,
                  53.400580145000092
                ],
                [
                  -4.425363735999952,
                  53.426703192000119
                ],
                [
                  -4.412831183999856,
                  53.426947333000086
                ],
                [
                  -4.34349524599989,
                  53.420070705000072
                ],
                [
                  -4.32469641799986,
                  53.419501044000086
                ],
                [
                  -4.286529100999871,
                  53.40643952000012
                ],
                [
                  -4.276722785999937,
                  53.401027736000074
                ],
                [
                  -4.271880662999877,
                  53.389064846000124
                ],
                [
                  -4.269357876999948,
                  53.377101955000015
                ],
                [
                  -4.266021287999934,
                  53.371649481000176
                ],
                [
                  -4.266916469999927,
                  53.368963934000092
                ],
                [
                  -4.254505988999881,
                  53.363226630000113
                ],
                [
                  -4.240061001999919,
                  53.358343817000147
                ],
                [
                  -4.234730597999885,
                  53.358058986000017
                ],
                [
                  -4.233713344999899,
                  53.352972723
                ],
                [
                  -4.23485266799986,
                  53.346136786000088
                ],
                [
                  -4.235178188999953,
                  53.340073960000083
                ],
                [
                  -4.231556769999912,
                  53.337591864000061
                ],
                [
                  -4.230620897999927,
                  53.33527252800009
                ],
                [
                  -4.214833136999886,
                  53.323919989000117
                ],
                [
                  -4.209339972999942,
                  53.312404690000093
                ],
                [
                  -4.207427537999877,
                  53.303900458000058
                ],
                [
                  -4.203236456999946,
                  53.298488674000012
                ]
              ]
            ],
            
            [
              [
                [
                  -5.11778723899991,
                  55.439764716000141
                ],
                [
                  -5.163563605999912,
                  55.43488190300009
                ],
                [
                  -5.217355923999946,
                  55.437974351000079
                ],
                [
                  -5.263091600999871,
                  55.447211005000142
                ],
                [
                  -5.304676886999857,
                  55.46214427299999
                ],
                [
                  -5.345692511999857,
                  55.48265208500014
                ],
                [
                  -5.345692511999857,
                  55.489447333000058
                ],
                [
                  -5.34618079299986,
                  55.496039130000142
                ],
                [
                  -5.355336066999939,
                  55.522894598000121
                ],
                [
                  -5.359364386999914,
                  55.530462958000086
                ],
                [
                  -5.359364386999914,
                  55.537298895000092
                ],
                [
                  -5.354237433999884,
                  55.539780992000104
                ],
                [
                  -5.352284308999856,
                  55.542303778000033
                ],
                [
                  -5.350412563999953,
                  55.545477606000091
                ],
                [
                  -5.345692511999857,
                  55.550279038999989
                ],
                [
                  -5.370432094999927,
                  55.570257880000057
                ],
                [
                  -5.389068162999934,
                  55.590236721000124
                ],
                [
                  -5.3978572259999,
                  55.614203192
                ],
                [
                  -5.39289303299995,
                  55.646551825000117
                ],
                [
                  -5.37938391799986,
                  55.668117580000015
                ],
                [
                  -5.355213995999861,
                  55.689601955000128
                ],
                [
                  -5.324330206999917,
                  55.705023505000085
                ],
                [
                  -5.290516730999855,
                  55.708563544000143
                ],
                [
                  -5.292591925999943,
                  55.71198151200015
                ],
                [
                  -5.295155402999853,
                  55.719427802000141
                ],
                [
                  -5.29735266799986,
                  55.722845770000148
                ],
                [
                  -5.271351691999882,
                  55.723822333000115
                ],
                [
                  -5.263172980999855,
                  55.722845770000148
                ],
                [
                  -5.198312954999977,
                  55.704331773000135
                ],
                [
                  -5.180653449999852,
                  55.694891669000029
                ],
                [
                  -5.159982876999948,
                  55.676214911000145
                ],
                [
                  -5.145985480999883,
                  55.654974677000055
                ],
                [
                  -5.125965949999909,
                  55.605536200000088
                ],
                [
                  -5.137440558999856,
                  55.592027085000112
                ],
                [
                  -5.09422766799986,
                  55.566555080000015
                ],
                [
                  -5.091867641999897,
                  55.54413483300003
                ],
                [
                  -5.101673956999946,
                  55.540716864
                ],
                [
                  -5.116037563999925,
                  55.540432033000158
                ],
                [
                  -5.125233527999882,
                  55.536932684000178
                ],
                [
                  -5.119740363999938,
                  55.523627020000148
                ],
                [
                  -5.111561652999853,
                  55.519924221000011
                ],
                [
                  -5.070790167999888,
                  55.509344794000143
                ],
                [
                  -5.093006964999859,
                  55.500433661000116
                ],
                [
                  -5.091053839999887,
                  55.487290757000054
                ],
                [
                  -5.080799933999884,
                  55.471665757000082
                ],
                [
                  -5.078236456999946,
                  55.455308335000055
                ],
                [
                  -5.092030402999882,
                  55.446112372000087
                ],
                [
                  -5.11778723899991,
                  55.439764716000141
                ]
              ]
            ],
            [
              [
                [
                  -5.009388800999886,
                  55.729315497000144
                ],
                [
                  -5.016184048999918,
                  55.722845770000148
                ],
                [
                  -5.028797980999912,
                  55.723334052000141
                ],
                [
                  -5.038482225999871,
                  55.731878973000065
                ],
                [
                  -5.05028235599994,
                  55.749497788999989
                ],
                [
                  -5.115589972999914,
                  55.784369208000115
                ],
                [
                  -5.125965949999909,
                  55.801011460000055
                ],
                [
                  -5.137562628999916,
                  55.829046942000062
                ],
                [
                  -5.139637824999852,
                  55.841986395000092
                ],
                [
                  -5.174224412999934,
                  55.855373440000093
                ],
                [
                  -5.180653449999852,
                  55.862779039000074
                ],
                [
                  -5.188588019999912,
                  55.878119208000115
                ],
                [
                  -5.200795050999886,
                  55.895493882
                ],
                [
                  -5.199533657999893,
                  55.91107819200009
                ],
                [
                  -5.166900193999936,
                  55.920843817000119
                ],
                [
                  -5.135975714999887,
                  55.905951239000089
                ],
                [
                  -5.105539516999926,
                  55.886704820000134
                ],
                [
                  -5.096506313999925,
                  55.883530992000075
                ],
                [
                  -5.08763587099989,
                  55.882635809000149
                ],
                [
                  -5.080922003999945,
                  55.879584052000084
                ],
                [
                  -5.07518469999988,
                  55.856919664000131
                ],
                [
                  -5.068023240999935,
                  55.852118231000034
                ],
                [
                  -5.058827277999853,
                  55.850165106000176
                ],
                [
                  -5.05028235599994,
                  55.845770575000088
                ],
                [
                  -5.038075324999852,
                  55.832424221000096
                ],
                [
                  -5.028920050999886,
                  55.819281317000119
                ],
                [
                  -5.021839972999914,
                  55.805609442
                ],
                [
                  -5.011463995999918,
                  55.774481512000094
                ],
                [
                  -5.012766079999921,
                  55.768377997000115
                ],
                [
                  -5.019195115999935,
                  55.763169664000102
                ],
                [
                  -5.029774542999888,
                  55.749497788999989
                ],
                [
                  -5.019032355999855,
                  55.745306708000058
                ],
                [
                  -5.011341925999943,
                  55.737697658000016
                ],
                [
                  -5.009388800999886,
                  55.729315497000144
                ]
              ]
            ],
            [
              [
                [
                  -6.102365688999953,
                  55.831244208000058
                ],
                [
                  -6.099232550999886,
                  55.801011460000055
                ],
                [
                  -6.093088344999899,
                  55.791693427000112
                ],
                [
                  -6.079090949999852,
                  55.781480210000083
                ],
                [
                  -6.063954230999855,
                  55.773382880000057
                ],
                [
                  -6.054554816999911,
                  55.770005601000136
                ],
                [
                  -6.049794074999909,
                  55.76634349199999
                ],
                [
                  -6.052316860999923,
                  55.758042710000026
                ],
                [
                  -6.056874152999882,
                  55.74884674700003
                ],
                [
                  -6.058257615999878,
                  55.742743231000063
                ],
                [
                  -6.053212042999917,
                  55.73729075700011
                ],
                [
                  -6.046620245999861,
                  55.733547268000066
                ],
                [
                  -6.030384894999912,
                  55.729071356000119
                ],
                [
                  -6.032785610999952,
                  55.717678127000127
                ],
                [
                  -6.032338019999941,
                  55.706366278000147
                ],
                [
                  -6.029286261999857,
                  55.696234442
                ],
                [
                  -6.023508266999897,
                  55.688137111000074
                ],
                [
                  -6.023508266999897,
                  55.68187083500014
                ],
                [
                  -6.035389777999853,
                  55.678452867000132
                ],
                [
                  -6.045725063999953,
                  55.674261786
                ],
                [
                  -6.053618943999936,
                  55.668361721000153
                ],
                [
                  -6.058257615999878,
                  55.660142320000077
                ],
                [
                  -6.064442511999914,
                  55.667629299000126
                ],
                [
                  -6.082427537999877,
                  55.652085679000109
                ],
                [
                  -6.105458136999857,
                  55.640204169000171
                ],
                [
                  -6.131906704999921,
                  55.63182200700011
                ],
                [
                  -6.160023566999911,
                  55.626654364000032
                ],
                [
                  -6.202544725999871,
                  55.630560614
                ],
                [
                  -6.215321417999917,
                  55.626654364000032
                ],
                [
                  -6.222767706999889,
                  55.605536200000088
                ],
                [
                  -6.226958787999905,
                  55.601752020000063
                ],
                [
                  -6.23656165299991,
                  55.595607815
                ],
                [
                  -6.261870897999927,
                  55.583807684000035
                ],
                [
                  -6.287342902999853,
                  55.57843659100017
                ],
                [
                  -6.31118730399993,
                  55.58323802300005
                ],
                [
                  -6.32518469999988,
                  55.605536200000088
                ],
                [
                  -6.319243943999879,
                  55.628241278000061
                ],
                [
                  -6.29747473899991,
                  55.64248281500015
                ],
                [
                  -6.243234829999949,
                  55.660142320000077
                ],
                [
                  -6.264800584999875,
                  55.695502020000092
                ],
                [
                  -6.277088995999918,
                  55.704006252000013
                ],
                [
                  -6.316761847999942,
                  55.715073960000055
                ],
                [
                  -6.32518469999988,
                  55.715399481000176
                ],
                [
                  -6.320952928999873,
                  55.733465887000094
                ],
                [
                  -6.295521613999938,
                  55.751898505000113
                ],
                [
                  -6.249989386999886,
                  55.776841539000046
                ],
                [
                  -6.27179928299995,
                  55.783026434000121
                ],
                [
                  -6.300445115999906,
                  55.785793361000074
                ],
                [
                  -6.328724738999881,
                  55.783148505
                ],
                [
                  -6.349029100999871,
                  55.773423570000048
                ],
                [
                  -6.372547980999912,
                  55.738714911000088
                ],
                [
                  -6.386586066999882,
                  55.722316799000069
                ],
                [
                  -6.418568488999881,
                  55.709621486000017
                ],
                [
                  -6.450306769999941,
                  55.682562567000062
                ],
                [
                  -6.462961391999897,
                  55.674465236000131
                ],
                [
                  -6.490956183999913,
                  55.671820380000057
                ],
                [
                  -6.503529425999915,
                  55.681341864000061
                ],
                [
                  -6.50243079299986,
                  55.697658596000068
                ],
                [
                  -6.489654100999928,
                  55.715399481000176
                ],
                [
                  -6.494699673999946,
                  55.717230536000145
                ],
                [
                  -6.498605923999946,
                  55.721136786000145
                ],
                [
                  -6.503895636999914,
                  55.722845770000148
                ],
                [
                  -6.493234829999892,
                  55.739243882000054
                ],
                [
                  -6.448638475999928,
                  55.776841539000046
                ],
                [
                  -6.482167120999861,
                  55.790472723
                ],
                [
                  -6.469064907999893,
                  55.796942450000088
                ],
                [
                  -6.460804816999911,
                  55.803208726000051
                ],
                [
                  -6.456654425999943,
                  55.812648830000072
                ],
                [
                  -6.455474412999934,
                  55.82835521000014
                ],
                [
                  -6.452788865999963,
                  55.840887762000037
                ],
                [
                  -6.445220506999903,
                  55.848822333
                ],
                [
                  -6.409087693999879,
                  55.86359284100017
                ],
                [
                  -6.354481574999909,
                  55.877427476000079
                ],
                [
                  -6.342640753999945,
                  55.884914455000128
                ],
                [
                  -6.331369594999956,
                  55.889960028000175
                ],
                [
                  -6.318348761999886,
                  55.886704820000134
                ],
                [
                  -6.325917120999918,
                  55.880357164000102
                ],
                [
                  -6.338205532999979,
                  55.851996161000059
                ],
                [
                  -6.338205532999979,
                  55.845770575000088
                ],
                [
                  -6.330718553999901,
                  55.827826239000061
                ],
                [
                  -6.323231574999852,
                  55.820502020000148
                ],
                [
                  -6.310902472999885,
                  55.818426825000031
                ],
                [
                  -6.310902472999885,
                  55.825262762000065
                ],
                [
                  -6.318430141999954,
                  55.844916083
                ],
                [
                  -6.296986456999917,
                  55.867173570000048
                ],
                [
                  -6.264800584999875,
                  55.885402736000131
                ],
                [
                  -6.229074673999918,
                  55.897284247000172
                ],
                [
                  -6.204253709999875,
                  55.916571356000119
                ],
                [
                  -6.191395636999857,
                  55.920843817000119
                ],
                [
                  -6.177154100999928,
                  55.923081773000106
                ],
                [
                  -6.162220831999889,
                  55.928452867000075
                ],
                [
                  -6.14907792899993,
                  55.935207424000012
                ],
                [
                  -6.140126105999912,
                  55.941351630000085
                ],
                [
                  -6.130116339999916,
                  55.939398505000142
                ],
                [
                  -6.12368730399993,
                  55.935492255000142
                ],
                [
                  -6.120228644999912,
                  55.929429429000137
                ],
                [
                  -6.115956183999913,
                  55.886786200000117
                ],
                [
                  -6.102365688999953,
                  55.831244208000058
                ]
              ]
            ],
            [
              [
                [
                  -6.13337154899989,
                  56.112616278000147
                ],
                [
                  -6.165638800999915,
                  56.08148834800015
                ],
                [
                  -6.177154100999928,
                  56.06146881700009
                ],
                [
                  -6.174305792999917,
                  56.043768622000172
                ],
                [
                  -6.19432532499988,
                  56.035305080000128
                ],
                [
                  -6.221669074999852,
                  56.030829169000171
                ],
                [
                  -6.249175584999875,
                  56.031317450000145
                ],
                [
                  -6.269886847999885,
                  56.037543036000116
                ],
                [
                  -6.254302537999905,
                  56.044623114000089
                ],
                [
                  -6.246815558999913,
                  56.056138414000102
                ],
                [
                  -6.241688605999912,
                  56.069484768000123
                ],
                [
                  -6.23265540299991,
                  56.081610419000029
                ],
                [
                  -6.211740688999925,
                  56.096991278000147
                ],
                [
                  -6.20571855399993,
                  56.102728583000143
                ],
                [
                  -6.19823157499988,
                  56.106268622000115
                ],
                [
                  -6.18260657499988,
                  56.10260651200015
                ],
                [
                  -6.174305792999917,
                  56.106431382000082
                ],
                [
                  -6.177398240999878,
                  56.110256252000099
                ],
                [
                  -6.179025844999899,
                  56.112941799000069
                ],
                [
                  -6.18179277299987,
                  56.11945221600017
                ],
                [
                  -6.164947068999879,
                  56.120794989000061
                ],
                [
                  -6.14940344999988,
                  56.12494538
                ],
                [
                  -6.138010219999899,
                  56.124701239000146
                ],
                [
                  -6.13337154899989,
                  56.112616278000147
                ]
              ]
            ],
            [
              [
                [
                  -5.780181443999908,
                  56.020738023000106
                ],
                [
                  -5.864491339999916,
                  55.926743882000054
                ],
                [
                  -5.886341925999943,
                  55.886704820000134
                ],
                [
                  -5.896839972999914,
                  55.888902085000112
                ],
                [
                  -5.921538865999906,
                  55.87128327
                ],
                [
                  -5.938140428999873,
                  55.86627838700015
                ],
                [
                  -5.945423956999889,
                  55.858587958000143
                ],
                [
                  -5.95539303299995,
                  55.820054429000052
                ],
                [
                  -5.962066209999932,
                  55.804754950000088
                ],
                [
                  -5.987538214999916,
                  55.794623114000146
                ],
                [
                  -6.026600714999887,
                  55.796087958
                ],
                [
                  -6.062408006999903,
                  55.809475002000013
                ],
                [
                  -6.078114386999857,
                  55.834906317000119
                ],
                [
                  -6.086903449999852,
                  55.8829613300001
                ],
                [
                  -6.08495032499988,
                  55.900336005000085
                ],
                [
                  -6.075184699999852,
                  55.915961005000057
                ],
                [
                  -6.060170050999915,
                  55.922919012000065
                ],
                [
                  -6.04312089799987,
                  55.927964585000083
                ],
                [
                  -6.026966925999915,
                  55.937933661000088
                ],
                [
                  -5.997425910999937,
                  55.951727606000176
                ],
                [
                  -5.919056769999884,
                  55.960394598000065
                ],
                [
                  -5.886341925999943,
                  55.976141669000029
                ],
                [
                  -5.910023566999882,
                  55.976507880000142
                ],
                [
                  -5.946848110999952,
                  55.970648505
                ],
                [
                  -5.98070227799991,
                  55.969916083000086
                ],
                [
                  -5.995594855999855,
                  55.986029364000146
                ],
                [
                  -5.983265753999916,
                  56.00885651200015
                ],
                [
                  -5.955189581999917,
                  56.034735419000171
                ],
                [
                  -5.924427863999938,
                  56.055975653000147
                ],
                [
                  -5.903960740999878,
                  56.064846096000011
                ],
                [
                  -5.873687303999873,
                  56.070135809000178
                ],
                [
                  -5.797596808999884,
                  56.112616278000147
                ],
                [
                  -5.746490037999905,
                  56.141750393
                ],
                [
                  -5.715931769999884,
                  56.153143622000172
                ],
                [
                  -5.694488084999932,
                  56.147406317
                ],
                [
                  -5.6908259759999,
                  56.137844143
                ],
                [
                  -5.68797766799986,
                  56.124090887000094
                ],
                [
                  -5.689320441999939,
                  56.111761786000145
                ],
                [
                  -5.705067511999886,
                  56.103013414000074
                ],
                [
                  -5.7201228509999,
                  56.088120835000112
                ],
                [
                  -5.740223761999857,
                  56.076483466000113
                ],
                [
                  -5.780181443999908,
                  56.020738023000106
                ]
              ]
            ],
            [
              [
                [
                  -5.725209113999938,
                  56.162827867000132
                ],
                [
                  -5.749134894999912,
                  56.161078192000119
                ],
                [
                  -5.738352016999897,
                  56.177476304000137
                ],
                [
                  -5.722238735999923,
                  56.187079169000114
                ],
                [
                  -5.688303188999981,
                  56.202053127000156
                ],
                [
                  -5.680897589999887,
                  56.19456614799999
                ],
                [
                  -5.673654751999948,
                  56.178941148000021
                ],
                [
                  -5.694203253999916,
                  56.168605861000103
                ],
                [
                  -5.725209113999938,
                  56.162827867000132
                ]
              ]
            ],
            [
              [
                [
                  -5.612619594999899,
                  56.263495184000035
                ],
                [
                  -5.610585089999859,
                  56.249416408000101
                ],
                [
                  -5.618153449999909,
                  56.235052802000112
                ],
                [
                  -5.628163214999887,
                  56.220526434000178
                ],
                [
                  -5.637440558999856,
                  56.189276434000092
                ],
                [
                  -5.647572394999912,
                  56.195379950000088
                ],
                [
                  -5.666656053999901,
                  56.222479559000121
                ],
                [
                  -5.65640214799987,
                  56.232001044000029
                ],
                [
                  -5.645334438999925,
                  56.255926825000174
                ],
                [
                  -5.63312740799995,
                  56.263495184000035
                ],
                [
                  -5.627837693999879,
                  56.25999583500014
                ],
                [
                  -5.622954881999903,
                  56.257635809000178
                ],
                [
                  -5.618031378999945,
                  56.25812409100017
                ],
                [
                  -5.612619594999899,
                  56.263495184000035
                ]
              ]
            ],
            [
              [
                [
                  -5.584624803999873,
                  56.325588283000158
                ],
                [
                  -5.59044348899991,
                  56.313625393000123
                ],
                [
                  -5.599964972999914,
                  56.305487372000115
                ],
                [
                  -5.605336066999882,
                  56.296942450000088
                ],
                [
                  -5.598988410999937,
                  56.283921617000104
                ],
                [
                  -5.621693488999881,
                  56.276068427000112
                ],
                [
                  -5.640288865999878,
                  56.282782294000171
                ],
                [
                  -5.64671790299991,
                  56.298773505000057
                ],
                [
                  -5.63312740799995,
                  56.318752346000124
                ],
                [
                  -5.620757615999906,
                  56.32420482
                ],
                [
                  -5.59788977799991,
                  56.321844794000029
                ],
                [
                  -5.584624803999873,
                  56.325588283000158
                ]
              ]
            ],
            [
              [
                [
                  -5.502756313999925,
                  56.42112864800005
                ],
                [
                  -5.518055792999888,
                  56.403876044000143
                ],
                [
                  -5.536203579999892,
                  56.392238674000126
                ],
                [
                  -5.557972785999937,
                  56.386460679000081
                ],
                [
                  -5.584624803999873,
                  56.387030341000141
                ],
                [
                  -5.57982337099989,
                  56.396429755000057
                ],
                [
                  -5.573963995999947,
                  56.402899481000148
                ],
                [
                  -5.557972785999937,
                  56.41429271000014
                ],
                [
                  -5.526519334999904,
                  56.413560289000102
                ],
                [
                  -5.512359178999901,
                  56.415432033000073
                ],
                [
                  -5.502756313999925,
                  56.42112864800005
                ]
              ]
            ],
            [
              [
                [
                  -6.160023566999911,
                  56.469549872000144
                ],
                [
                  -6.212473110999952,
                  56.467840887000037
                ],
                [
                  -6.237456834999904,
                  56.470038153000033
                ],
                [
                  -6.263661261999914,
                  56.483221747000172
                ],
                [
                  -6.253244594999927,
                  56.492865302000055
                ],
                [
                  -6.242054816999911,
                  56.499579169000086
                ],
                [
                  -6.229603644999912,
                  56.50332265800013
                ],
                [
                  -6.215321417999917,
                  56.503648179000052
                ],
                [
                  -6.200754360999895,
                  56.494940497000172
                ],
                [
                  -6.170562303999873,
                  56.481146552000055
                ],
                [
                  -6.160023566999911,
                  56.469549872000144
                ]
              ]
            ],
            [
              [
                [
                  -6.881581183999913,
                  56.444281317
                ],
                [
                  -6.902455206999889,
                  56.443752346000011
                ],
                [
                  -6.965199347999885,
                  56.459865627000099
                ],
                [
                  -6.973988410999937,
                  56.471502997000087
                ],
                [
                  -6.979725714999916,
                  56.487127997000172
                ],
                [
                  -6.989898240999963,
                  56.503648179000052
                ],
                [
                  -6.968129035999908,
                  56.510484117000075
                ],
                [
                  -6.900502081999946,
                  56.516669012000037
                ],
                [
                  -6.878081834999932,
                  56.521307684000149
                ],
                [
                  -6.841135219999899,
                  56.534735419000143
                ],
                [
                  -6.81859290299991,
                  56.537827867000047
                ],
                [
                  -6.767201300999886,
                  56.548570054000052
                ],
                [
                  -6.741851365999878,
                  56.54783763200011
                ],
                [
                  -6.729237433999884,
                  56.530340887000179
                ],
                [
                  -6.743316209999932,
                  56.517808335000083
                ],
                [
                  -6.803822394999912,
                  56.513617255000142
                ],
                [
                  -6.805572068999908,
                  56.496893622000115
                ],
                [
                  -6.825510219999899,
                  56.487290757000139
                ],
                [
                  -6.847727016999954,
                  56.484808661000116
                ],
                [
                  -6.86929277299987,
                  56.479641018
                ],
                [
                  -6.887521938999953,
                  56.462103583000058
                ],
                [
                  -6.881581183999913,
                  56.444281317
                ]
              ]
            ],
            [
              [
                [
                  -6.033518032999893,
                  56.618841864
                ],
                [
                  -6.008778449999909,
                  56.59870026200015
                ],
                [
                  -5.968251105999883,
                  56.544663804000052
                ],
                [
                  -5.965199347999885,
                  56.537665106000176
                ],
                [
                  -5.965158657999893,
                  56.531073309000092
                ],
                [
                  -5.962554490999906,
                  56.526109117000047
                ],
                [
                  -5.952137824999909,
                  56.524155992000104
                ],
                [
                  -5.85220292899993,
                  56.524155992000104
                ],
                [
                  -5.844146287999905,
                  56.520575262000037
                ],
                [
                  -5.83690344999988,
                  56.51463450700011
                ],
                [
                  -5.829457160999908,
                  56.510809637000094
                ],
                [
                  -5.814035610999895,
                  56.516669012000037
                ],
                [
                  -5.804188605999855,
                  56.517767645000092
                ],
                [
                  -5.794341600999928,
                  56.516669012000037
                ],
                [
                  -5.787342902999853,
                  56.513617255000142
                ],
                [
                  -5.765207485999895,
                  56.494208075000031
                ],
                [
                  -5.756662563999953,
                  56.490057684000092
                ],
                [
                  -5.746937628999916,
                  56.488430080000072
                ],
                [
                  -5.728423631999903,
                  56.490179755000085
                ],
                [
                  -5.721831834999904,
                  56.490057684000092
                ],
                [
                  -5.710357225999871,
                  56.484849351000108
                ],
                [
                  -5.696766730999912,
                  56.475653387000037
                ],
                [
                  -5.685536261999914,
                  56.464056708000115
                ],
                [
                  -5.680897589999887,
                  56.451849677000141
                ],
                [
                  -5.673451300999915,
                  56.449693101000136
                ],
                [
                  -5.658843553999901,
                  56.451727606000148
                ],
                [
                  -5.648426886999914,
                  56.447739975999987
                ],
                [
                  -5.653553839999916,
                  56.427964585000083
                ],
                [
                  -5.66185462099989,
                  56.431382554000081
                ],
                [
                  -5.670033331999917,
                  56.433091538999989
                ],
                [
                  -5.688303188999981,
                  56.43480052299999
                ],
                [
                  -5.679554816999911,
                  56.427964585000083
                ],
                [
                  -5.664947068999879,
                  56.413885809000035
                ],
                [
                  -5.657622850999871,
                  56.400091864000117
                ],
                [
                  -5.670318162999934,
                  56.39378489799999
                ],
                [
                  -5.703033006999874,
                  56.393377997000172
                ],
                [
                  -5.71743730399993,
                  56.397365627000156
                ],
                [
                  -5.715646938999953,
                  56.408107815000065
                ],
                [
                  -5.721669074999852,
                  56.412339585
                ],
                [
                  -5.727894660999908,
                  56.41429271000014
                ],
                [
                  -5.73468990799995,
                  56.414780992000104
                ],
                [
                  -5.74233964799987,
                  56.41429271000014
                ],
                [
                  -5.739084438999925,
                  56.401190497000144
                ],
                [
                  -5.751088019999941,
                  56.389390367000019
                ],
                [
                  -5.783924933999856,
                  56.373358466000113
                ],
                [
                  -5.783924933999856,
                  56.365912177000112
                ],
                [
                  -5.767974412999934,
                  56.372748114000146
                ],
                [
                  -5.749989386999914,
                  56.37714264500012
                ],
                [
                  -5.712228969999927,
                  56.380194403000033
                ],
                [
                  -5.695952928999901,
                  56.375433661000116
                ],
                [
                  -5.702707485999952,
                  56.364569403000033
                ],
                [
                  -5.719960089999859,
                  56.352769273000078
                ],
                [
                  -5.808705206999917,
                  56.318915106000091
                ],
                [
                  -5.848215298999975,
                  56.313625393000123
                ],
                [
                  -5.880116339999887,
                  56.325588283000158
                ],
                [
                  -5.873687303999873,
                  56.328558661000088
                ],
                [
                  -5.862700975999928,
                  56.335150458000143
                ],
                [
                  -5.853505011999857,
                  56.343695380000085
                ],
                [
                  -5.85220292899993,
                  56.352850653000147
                ],
                [
                  -5.860422329999949,
                  56.35834381700009
                ],
                [
                  -5.872670050999915,
                  56.357733466000028
                ],
                [
                  -5.897206183999941,
                  56.352850653000147
                ],
                [
                  -5.902333136999857,
                  56.349676825000088
                ],
                [
                  -5.907785610999895,
                  56.34259674700003
                ],
                [
                  -5.914784308999856,
                  56.335516669000143
                ],
                [
                  -5.924183722999885,
                  56.332342841000084
                ],
                [
                  -5.957875128999888,
                  56.32807038
                ],
                [
                  -6.037464972999885,
                  56.305243231000148
                ],
                [
                  -6.054554816999911,
                  56.294501044000143
                ],
                [
                  -6.065988735999952,
                  56.289211330000072
                ],
                [
                  -6.078521287999877,
                  56.291083075000145
                ],
                [
                  -6.090931769999912,
                  56.295721747000172
                ],
                [
                  -6.102365688999953,
                  56.298244533000101
                ],
                [
                  -6.112538214999887,
                  56.296210028000147
                ],
                [
                  -6.136301235999895,
                  56.286932684000092
                ],
                [
                  -6.146962042999917,
                  56.283921617000104
                ],
                [
                  -6.239816860999952,
                  56.283921617000104
                ],
                [
                  -6.245757615999878,
                  56.280747789000046
                ],
                [
                  -6.250355597999914,
                  56.273749091000141
                ],
                [
                  -6.256459113999881,
                  56.266669012000094
                ],
                [
                  -6.266835089999887,
                  56.263495184000035
                ],
                [
                  -6.279286261999914,
                  56.264105536
                ],
                [
                  -6.300038214999916,
                  56.268011786000088
                ],
                [
                  -6.327504035999937,
                  56.27724844000015
                ],
                [
                  -6.345611131999874,
                  56.28831614799999
                ],
                [
                  -6.360178188999896,
                  56.303615627000127
                ],
                [
                  -6.366118943999908,
                  56.32217031500015
                ],
                [
                  -6.357004360999923,
                  56.336330471000068
                ],
                [
                  -6.335438605999912,
                  56.344549872000172
                ],
                [
                  -6.310292120999918,
                  56.347357489000117
                ],
                [
                  -6.290394660999937,
                  56.345404364000089
                ],
                [
                  -6.274525519999912,
                  56.334865627000013
                ],
                [
                  -6.261219855999883,
                  56.32029857
                ],
                [
                  -6.247222459999932,
                  56.311672268000095
                ],
                [
                  -6.228911912999877,
                  56.318752346000124
                ],
                [
                  -6.228911912999877,
                  56.325588283000158
                ],
                [
                  -6.23680579299986,
                  56.326605536000116
                ],
                [
                  -6.241118943999936,
                  56.328273830000128
                ],
                [
                  -6.244536912999934,
                  56.330267645000092
                ],
                [
                  -6.249989386999886,
                  56.332342841000084
                ],
                [
                  -6.231760219999899,
                  56.336900132000139
                ],
                [
                  -6.186634894999941,
                  56.331244208000058
                ],
                [
                  -6.170887824999909,
                  56.335760809000092
                ],
                [
                  -6.153920050999915,
                  56.344794012000122
                ],
                [
                  -6.08495032499988,
                  56.352850653000147
                ],
                [
                  -6.039906378999916,
                  56.371039130000142
                ],
                [
                  -6.020822719999927,
                  56.382025458
                ],
                [
                  -6.026966925999915,
                  56.387030341000141
                ],
                [
                  -6.046945766999983,
                  56.383978583000143
                ],
                [
                  -6.105458136999857,
                  56.365912177000112
                ],
                [
                  -6.15404212099989,
                  56.358954169000057
                ],
                [
                  -6.178944464999916,
                  56.359930731000119
                ],
                [
                  -6.198557094999899,
                  56.369614976000079
                ],
                [
                  -6.203236456999917,
                  56.380316473
                ],
                [
                  -6.198841925999915,
                  56.390326239000089
                ],
                [
                  -6.189198370999861,
                  56.397772528000147
                ],
                [
                  -6.178049282999922,
                  56.400620835
                ],
                [
                  -6.164784308999913,
                  56.402533270000148
                ],
                [
                  -6.157215949999852,
                  56.407375393000123
                ],
                [
                  -6.142648891999926,
                  56.427964585000083
                ],
                [
                  -6.139637824999937,
                  56.435248114000089
                ],
                [
                  -6.135121222999885,
                  56.442328192000147
                ],
                [
                  -6.126535610999952,
                  56.448431708000115
                ],
                [
                  -6.11693274599989,
                  56.450384833000086
                ],
                [
                  -6.081532355999883,
                  56.448431708000115
                ],
                [
                  -6.021839972999885,
                  56.464097398000106
                ],
                [
                  -6.009836391999954,
                  56.469549872000144
                ],
                [
                  -6.004017706999917,
                  56.479681708
                ],
                [
                  -6.00328528599988,
                  56.489406643000152
                ],
                [
                  -6.007476365999906,
                  56.497626044000143
                ],
                [
                  -6.016672329999892,
                  56.503648179000052
                ],
                [
                  -6.081125454999949,
                  56.485052802000055
                ],
                [
                  -6.102365688999953,
                  56.483221747000172
                ],
                [
                  -6.109974738999881,
                  56.480698960000055
                ],
                [
                  -6.118478969999927,
                  56.476263739
                ],
                [
                  -6.12743079299986,
                  56.474351304000137
                ],
                [
                  -6.136789516999897,
                  56.479437567000062
                ],
                [
                  -6.153065558999913,
                  56.500067450000174
                ],
                [
                  -6.162098761999914,
                  56.509222723000065
                ],
                [
                  -6.174305792999917,
                  56.516669012000037
                ],
                [
                  -6.194935675999915,
                  56.52334219
                ],
                [
                  -6.288482225999871,
                  56.532294012000122
                ],
                [
                  -6.307728644999912,
                  56.537298895000063
                ],
                [
                  -6.324330206999889,
                  56.544256903000147
                ],
                [
                  -6.338205532999979,
                  56.552069403000147
                ],
                [
                  -6.290394660999937,
                  56.571966864000146
                ],
                [
                  -6.298695441999911,
                  56.581244208
                ],
                [
                  -6.319203253999888,
                  56.593980210000055
                ],
                [
                  -6.32518469999988,
                  56.606105861000131
                ],
                [
                  -6.28844153599988,
                  56.607977606000119
                ],
                [
                  -6.272124803999873,
                  56.612209377000127
                ],
                [
                  -6.256255662999934,
                  56.62034739800005
                ],
                [
                  -6.24742591099988,
                  56.612616278000033
                ],
                [
                  -6.238636847999914,
                  56.608587958000058
                ],
                [
                  -6.230213995999861,
                  56.608587958000058
                ],
                [
                  -6.222767706999889,
                  56.612941799000154
                ],
                [
                  -6.220285610999952,
                  56.632269598000093
                ],
                [
                  -6.190744594999899,
                  56.644924221000153
                ],
                [
                  -6.151275193999936,
                  56.651800848000065
                ],
                [
                  -6.119048631999903,
                  56.653876044000086
                ],
                [
                  -6.105336066999882,
                  56.648504950000031
                ],
                [
                  -6.058257615999878,
                  56.640204169000143
                ],
                [
                  -6.05992591099988,
                  56.635687567
                ],
                [
                  -6.062652147999927,
                  56.624823309000121
                ],
                [
                  -6.064442511999914,
                  56.62034739800005
                ],
                [
                  -6.033518032999893,
                  56.618841864
                ]
              ]
            ],
            [
              [
                [
                  -6.564116990999906,
                  56.59870026200015
                ],
                [
                  -6.616322394999912,
                  56.575181382
                ],
                [
                  -6.633046027999853,
                  56.571966864000146
                ],
                [
                  -6.657215949999852,
                  56.577826239000089
                ],
                [
                  -6.668934699999852,
                  56.577785549000097
                ],
                [
                  -6.67398027299987,
                  56.56854889500012
                ],
                [
                  -6.67788652299987,
                  56.558254299000012
                ],
                [
                  -6.686838344999899,
                  56.563788153000033
                ],
                [
                  -6.696278449999909,
                  56.575995184000121
                ],
                [
                  -6.701893683999913,
                  56.585638739000089
                ],
                [
                  -6.674468553999873,
                  56.588446356000034
                ],
                [
                  -6.648101365999963,
                  56.60285065300009
                ],
                [
                  -6.602894660999908,
                  56.64362213700015
                ],
                [
                  -6.591379360999895,
                  56.651841539000074
                ],
                [
                  -6.55923417899993,
                  56.66526927300005
                ],
                [
                  -6.535633917999888,
                  56.670843817000062
                ],
                [
                  -6.505848761999886,
                  56.685370184000092
                ],
                [
                  -6.489654100999928,
                  56.688666083000143
                ],
                [
                  -6.462310350999871,
                  56.691229559000035
                ],
                [
                  -6.4525447259999,
                  56.688421942
                ],
                [
                  -6.459217902999882,
                  56.678127346000068
                ],
                [
                  -6.468739386999857,
                  56.668158270000092
                ],
                [
                  -6.482533331999889,
                  56.647894598000065
                ],
                [
                  -6.489654100999928,
                  56.640204169000143
                ],
                [
                  -6.497222459999875,
                  56.634344794000114
                ],
                [
                  -6.504953579999892,
                  56.630072333
                ],
                [
                  -6.514271613999938,
                  56.627427476000108
                ],
                [
                  -6.527251756999931,
                  56.626532294000114
                ],
                [
                  -6.564116990999906,
                  56.59870026200015
                ]
              ]
            ],
            [
              [
                [
                  -7.381988084999904,
                  56.987534898000078
                ],
                [
                  -7.373524542999888,
                  56.982855536000059
                ],
                [
                  -7.402414516999897,
                  56.983384507000139
                ],
                [
                  -7.411040818999908,
                  56.97972239799999
                ],
                [
                  -7.419178839999916,
                  56.973334052000055
                ],
                [
                  -7.427235480999855,
                  56.968573309000149
                ],
                [
                  -7.435047980999855,
                  56.965277411000116
                ],
                [
                  -7.442372199999852,
                  56.962958075000145
                ],
                [
                  -7.436838344999927,
                  56.953680731000091
                ],
                [
                  -7.445301886999857,
                  56.947088934000035
                ],
                [
                  -7.460804816999882,
                  56.943182684000035
                ],
                [
                  -7.476551886999943,
                  56.941880601000136
                ],
                [
                  -7.541411912999934,
                  56.948716539000046
                ],
                [
                  -7.556752081999889,
                  56.953070380000142
                ],
                [
                  -7.556223110999895,
                  56.962632554000137
                ],
                [
                  -7.544911261999914,
                  56.972316799000097
                ],
                [
                  -7.528065558999913,
                  56.976629950000088
                ],
                [
                  -7.516509568999879,
                  56.981187242000047
                ],
                [
                  -7.511586066999911,
                  56.991644598000121
                ],
                [
                  -7.514027472999942,
                  57.00291575700011
                ],
                [
                  -7.524322068999879,
                  57.010199286000116
                ],
                [
                  -7.499908006999931,
                  57.020086981000034
                ],
                [
                  -7.475697394999941,
                  57.023016669000143
                ],
                [
                  -7.457102016999926,
                  57.031561591000084
                ],
                [
                  -7.449208136999857,
                  57.058579820000134
                ],
                [
                  -7.444691535999908,
                  57.058539130000142
                ],
                [
                  -7.441395636999886,
                  57.057196356000148
                ],
                [
                  -7.434966600999871,
                  57.05174388200011
                ],
                [
                  -7.428130662999934,
                  57.051336981000091
                ],
                [
                  -7.422963019999941,
                  57.05011627800009
                ],
                [
                  -7.418690558999913,
                  57.048041083000058
                ],
                [
                  -7.414418097999914,
                  57.04490794499999
                ],
                [
                  -7.428781704999892,
                  57.027736721000068
                ],
                [
                  -7.434966600999871,
                  57.023830471000068
                ],
                [
                  -7.402821417999888,
                  57.014634507
                ],
                [
                  -7.393950975999957,
                  57.010199286000116
                ],
                [
                  -7.389068162999877,
                  57.003607489000146
                ],
                [
                  -7.38609778599988,
                  56.995306708000086
                ],
                [
                  -7.381988084999904,
                  56.987534898000078
                ]
              ]
            ],
            [
              [
                [
                  -6.269886847999885,
                  57.017564195000105
                ],
                [
                  -6.269886847999885,
                  57.010199286000116
                ],
                [
                  -6.243234829999949,
                  57.010199286000116
                ],
                [
                  -6.256743943999936,
                  56.973781643000152
                ],
                [
                  -6.276031053999873,
                  56.953111070000134
                ],
                [
                  -6.303618943999879,
                  56.943996486000131
                ],
                [
                  -6.341867641999926,
                  56.941880601000136
                ],
                [
                  -6.359771287999877,
                  56.947333075000174
                ],
                [
                  -6.376128709999904,
                  56.971177476000051
                ],
                [
                  -6.390288865999906,
                  56.976629950000088
                ],
                [
                  -6.405384894999912,
                  56.980536200000088
                ],
                [
                  -6.436756964999859,
                  56.998480536000145
                ],
                [
                  -6.455474412999934,
                  57.003973700000145
                ],
                [
                  -6.395253058999884,
                  57.04193756700009
                ],
                [
                  -6.364247199999852,
                  57.05565013200011
                ],
                [
                  -6.32518469999988,
                  57.058579820000134
                ],
                [
                  -6.272938605999883,
                  57.040228583000086
                ],
                [
                  -6.25096594999988,
                  57.026556708000143
                ],
                [
                  -6.269886847999885,
                  57.017564195000105
                ]
              ]
            ],
            [
              [
                [
                  -6.51593990799995,
                  57.05068594000015
                ],
                [
                  -6.548247850999871,
                  57.047593492000075
                ],
                [
                  -6.580433722999914,
                  57.048407294000086
                ],
                [
                  -6.606353318999908,
                  57.05174388200011
                ],
                [
                  -6.590809699999909,
                  57.058986721000124
                ],
                [
                  -6.556304490999906,
                  57.070135809000149
                ],
                [
                  -6.537464972999942,
                  57.072821356000034
                ],
                [
                  -6.52586829299986,
                  57.067124742000047
                ],
                [
                  -6.50153561099998,
                  57.063666083000058
                ],
                [
                  -6.489654100999928,
                  57.058579820000134
                ],
                [
                  -6.51593990799995,
                  57.05068594000015
                ]
              ]
            ],
            [
              [
                [
                  -5.925445115999906,
                  57.291693427000084
                ],
                [
                  -5.958607550999915,
                  57.284491278000147
                ],
                [
                  -5.98485266799986,
                  57.290432033000073
                ],
                [
                  -6.007801886999857,
                  57.303615627000042
                ],
                [
                  -6.01390540299991,
                  57.317450262000122
                ],
                [
                  -5.989979620999861,
                  57.325506903000147
                ],
                [
                  -5.955718553999901,
                  57.321600653000147
                ],
                [
                  -5.929351365999906,
                  57.307196356000091
                ],
                [
                  -5.925445115999906,
                  57.291693427000084
                ]
              ]
            ],
            [
              [
                [
                  -7.353016730999912,
                  57.408026434000149
                ],
                [
                  -7.263579881999931,
                  57.373928127000156
                ],
                [
                  -7.272084113999938,
                  57.370266018
                ],
                [
                  -7.279123501999919,
                  57.369940497000172
                ],
                [
                  -7.298410610999952,
                  57.373928127000156
                ],
                [
                  -7.298410610999952,
                  57.367092190000122
                ],
                [
                  -7.27635657499988,
                  57.364732163999989
                ],
                [
                  -7.244862433999856,
                  57.348456122000144
                ],
                [
                  -7.222645636999886,
                  57.34658437700007
                ],
                [
                  -7.222645636999886,
                  57.339789130000057
                ],
                [
                  -7.250355597999885,
                  57.331854559000178
                ],
                [
                  -7.271799282999922,
                  57.337469794000086
                ],
                [
                  -7.290150519999884,
                  57.347398179
                ],
                [
                  -7.33161373599998,
                  57.360907294000143
                ],
                [
                  -7.351389126999891,
                  57.376695054000109
                ],
                [
                  -7.371083136999857,
                  57.387600002000099
                ],
                [
                  -7.393950975999957,
                  57.380764065000065
                ],
                [
                  -7.387766079999892,
                  57.377508856000119
                ],
                [
                  -7.38109290299991,
                  57.373032945000048
                ],
                [
                  -7.375721808999884,
                  57.368109442
                ],
                [
                  -7.373524542999888,
                  57.363592841000141
                ],
                [
                  -7.37047278599988,
                  57.355129299000012
                ],
                [
                  -7.363189256999874,
                  57.353216864000146
                ],
                [
                  -7.354156053999873,
                  57.353745835000112
                ],
                [
                  -7.346180792999917,
                  57.35276927300005
                ],
                [
                  -7.32201087099989,
                  57.34658437700007
                ],
                [
                  -7.317941860999923,
                  57.344468492000075
                ],
                [
                  -7.305287238999881,
                  57.33234284100017
                ],
                [
                  -7.290272589999859,
                  57.32831452
                ],
                [
                  -7.259388800999886,
                  57.328029690000065
                ],
                [
                  -7.243763800999915,
                  57.325506903000147
                ],
                [
                  -7.232004360999923,
                  57.318793036000031
                ],
                [
                  -7.222645636999886,
                  57.310614325000088
                ],
                [
                  -7.211822068999908,
                  57.30487702000012
                ],
                [
                  -7.195423956999889,
                  57.305609442000062
                ],
                [
                  -7.200347459999961,
                  57.290961005000057
                ],
                [
                  -7.209706183999884,
                  57.285467841000028
                ],
                [
                  -7.221424933999884,
                  57.282131252000099
                ],
                [
                  -7.233225063999953,
                  57.274318752000013
                ],
                [
                  -7.239165818999879,
                  57.265285549000097
                ],
                [
                  -7.249582485999952,
                  57.244696356000148
                ],
                [
                  -7.256743943999908,
                  57.236721096000011
                ],
                [
                  -7.276112433999913,
                  57.231756903000147
                ],
                [
                  -7.353016730999912,
                  57.242905992000075
                ],
                [
                  -7.353016730999912,
                  57.236721096000011
                ],
                [
                  -7.28880774599989,
                  57.225897528000118
                ],
                [
                  -7.271066860999895,
                  57.216253973000121
                ],
                [
                  -7.26219641799986,
                  57.200873114
                ],
                [
                  -7.257720506999874,
                  57.179754950000088
                ],
                [
                  -7.25991777299987,
                  57.159816799000012
                ],
                [
                  -7.271066860999895,
                  57.147935289000046
                ],
                [
                  -7.28844153599988,
                  57.153998114000146
                ],
                [
                  -7.307606574999852,
                  57.155829169000029
                ],
                [
                  -7.346180792999917,
                  57.154771226000079
                ],
                [
                  -7.346180792999917,
                  57.147935289000046
                ],
                [
                  -7.328439907999922,
                  57.146185614000061
                ],
                [
                  -7.292469855999855,
                  57.148871161000116
                ],
                [
                  -7.277251756999874,
                  57.147935289000046
                ],
                [
                  -7.259999152999853,
                  57.140041408000073
                ],
                [
                  -7.248402472999942,
                  57.129461981000034
                ],
                [
                  -7.235951300999915,
                  57.121161200000145
                ],
                [
                  -7.215891079999949,
                  57.120062567
                ],
                [
                  -7.215891079999949,
                  57.113836981000034
                ],
                [
                  -7.239125128999888,
                  57.100531317000119
                ],
                [
                  -7.321685350999871,
                  57.109930731000063
                ],
                [
                  -7.353016730999912,
                  57.099554755000142
                ],
                [
                  -7.381988084999904,
                  57.118353583
                ],
                [
                  -7.390695766999897,
                  57.129055080000015
                ],
                [
                  -7.416656053999901,
                  57.181586005000057
                ],
                [
                  -7.420399542999917,
                  57.197739976000108
                ],
                [
                  -7.414418097999914,
                  57.209418036000116
                ],
                [
                  -7.414418097999914,
                  57.216253973000121
                ],
                [
                  -7.431467251999948,
                  57.22943756700009
                ],
                [
                  -7.442290818999879,
                  57.23460521
                ],
                [
                  -7.455433722999914,
                  57.236721096000011
                ],
                [
                  -7.442738410999965,
                  57.244777736000131
                ],
                [
                  -7.434966600999871,
                  57.251898505
                ],
                [
                  -7.421945766999954,
                  57.270900783000101
                ],
                [
                  -7.417307094999927,
                  57.281439520000148
                ],
                [
                  -7.414947068999879,
                  57.290106512000065
                ],
                [
                  -7.409982876999948,
                  57.295965887000094
                ],
                [
                  -7.39708411399991,
                  57.298163153000175
                ],
                [
                  -7.389719204999921,
                  57.311957098000093
                ],
                [
                  -7.401519334999904,
                  57.342352606000148
                ],
                [
                  -7.428130662999934,
                  57.387600002000099
                ],
                [
                  -7.40843665299991,
                  57.395575262000037
                ],
                [
                  -7.362863735999952,
                  57.407863674000097
                ],
                [
                  -7.353016730999912,
                  57.408026434000149
                ]
              ]
            ],
            [
              [
                [
                  -7.292469855999855,
                  57.48529694200009
                ],
                [
                  -7.284494594999984,
                  57.482855536000145
                ],
                [
                  -7.274728969999927,
                  57.482245184000178
                ],
                [
                  -7.263579881999931,
                  57.483099677
                ],
                [
                  -7.265288865999935,
                  57.478745835
                ],
                [
                  -7.265736456999917,
                  57.478013414000074
                ],
                [
                  -7.266997850999928,
                  57.478176174000126
                ],
                [
                  -7.271066860999895,
                  57.476263739000061
                ],
                [
                  -7.262521938999953,
                  57.472113348000121
                ],
                [
                  -7.254261847999885,
                  57.472845770000063
                ],
                [
                  -7.245757615999935,
                  57.475165106000119
                ],
                [
                  -7.236317511999914,
                  57.476263739000061
                ],
                [
                  -7.229481574999909,
                  57.474554755000057
                ],
                [
                  -7.202137824999852,
                  57.462632554000109
                ],
                [
                  -7.2084041009999,
                  57.456447658000158
                ],
                [
                  -7.222035285999937,
                  57.460923570000105
                ],
                [
                  -7.24469967399989,
                  57.449652411000116
                ],
                [
                  -7.263579881999931,
                  57.448960679
                ],
                [
                  -7.258208787999877,
                  57.439113674000069
                ],
                [
                  -7.249663865999935,
                  57.435248114000061
                ],
                [
                  -7.226429816999911,
                  57.435288804000052
                ],
                [
                  -7.212025519999941,
                  57.432196356000148
                ],
                [
                  -7.20409094999988,
                  57.425441799000126
                ],
                [
                  -7.205433722999885,
                  57.418605861000017
                ],
                [
                  -7.292062954999921,
                  57.404730536000116
                ],
                [
                  -7.318267381999874,
                  57.408026434000149
                ],
                [
                  -7.396148240999935,
                  57.433986721000153
                ],
                [
                  -7.4076228509999,
                  57.445624091000141
                ],
                [
                  -7.402699347999914,
                  57.464341539000131
                ],
                [
                  -7.389271613999938,
                  57.47988515800013
                ],
                [
                  -7.369618292999888,
                  57.489325262000037
                ],
                [
                  -7.346180792999917,
                  57.489935614
                ],
                [
                  -7.334462042999917,
                  57.485093492000132
                ],
                [
                  -7.322132941999882,
                  57.482896226000136
                ],
                [
                  -7.309803839999916,
                  57.484116929000052
                ],
                [
                  -7.298410610999952,
                  57.489935614
                ],
                [
                  -7.292469855999855,
                  57.48529694200009
                ]
              ]
            ],
            [
              [
                [
                  -5.982533331999889,
                  57.497463283000158
                ],
                [
                  -5.986724412999905,
                  57.482245184000178
                ],
                [
                  -6.003041144999941,
                  57.452826239
                ],
                [
                  -6.017648891999954,
                  57.418198960000026
                ],
                [
                  -6.016672329999892,
                  57.387600002000099
                ],
                [
                  -6.008900519999884,
                  57.38019440300009
                ],
                [
                  -5.99510657499988,
                  57.363714911000116
                ],
                [
                  -5.989491339999887,
                  57.347316799000012
                ],
                [
                  -6.006459113999938,
                  57.339789130000057
                ],
                [
                  -6.022857225999871,
                  57.33624909100017
                ],
                [
                  -6.038685675999886,
                  57.329779364000061
                ],
                [
                  -6.054798956999946,
                  57.326402085000055
                ],
                [
                  -6.071929490999906,
                  57.33234284100017
                ],
                [
                  -6.069243943999908,
                  57.339544989
                ],
                [
                  -6.067616339999887,
                  57.342474677000112
                ],
                [
                  -6.064442511999914,
                  57.34658437700007
                ],
                [
                  -6.075428839999887,
                  57.355047919000029
                ],
                [
                  -6.07713782499988,
                  57.371771552000055
                ],
                [
                  -6.069081183999856,
                  57.436102606000148
                ],
                [
                  -6.061634894999884,
                  57.452704169000029
                ],
                [
                  -6.04552161399991,
                  57.460638739000089
                ],
                [
                  -6.016672329999892,
                  57.462632554000109
                ],
                [
                  -6.016672329999892,
                  57.469427802000055
                ],
                [
                  -6.023589647999899,
                  57.474188544000143
                ],
                [
                  -6.029042120999918,
                  57.479396877000127
                ],
                [
                  -6.037098761999857,
                  57.489935614
                ],
                [
                  -6.02586829299986,
                  57.496242580000128
                ],
                [
                  -6.015858527999882,
                  57.496771552000112
                ],
                [
                  -5.995594855999855,
                  57.489935614
                ],
                [
                  -5.995594855999855,
                  57.497463283000158
                ],
                [
                  -6.009836391999954,
                  57.511053778000118
                ],
                [
                  -6.000884568999936,
                  57.509711005000113
                ],
                [
                  -5.993316209999904,
                  57.507025458000143
                ],
                [
                  -5.987212693999908,
                  57.502875067
                ],
                [
                  -5.982533331999889,
                  57.497463283000158
                ]
              ]
            ],
            [
              [
                [
                  -5.968006964999859,
                  57.533921617000132
                ],
                [
                  -5.968251105999883,
                  57.517889716000028
                ],
                [
                  -5.983713344999899,
                  57.522365627000099
                ],
                [
                  -5.989979620999861,
                  57.532945054000052
                ],
                [
                  -5.98729407499988,
                  57.546291408000158
                ],
                [
                  -5.975697394999884,
                  57.558823960000055
                ],
                [
                  -5.980091925999943,
                  57.561468817000147
                ],
                [
                  -5.980376756999874,
                  57.562445380000113
                ],
                [
                  -5.982533331999889,
                  57.566310940000122
                ],
                [
                  -5.975697394999884,
                  57.572333075000031
                ],
                [
                  -5.968658006999903,
                  57.576564846000153
                ],
                [
                  -5.961903449999852,
                  57.577297268000095
                ],
                [
                  -5.955189581999917,
                  57.572495835
                ],
                [
                  -5.968006964999859,
                  57.533921617000132
                ]
              ]
            ],
            [
              [
                [
                  -13.688588019999912,
                  57.596258856000091
                ],
                [
                  -13.690419074999909,
                  57.596258856000091
                ],
                [
                  -13.691314256999902,
                  57.596502997000059
                ],
                [
                  -13.691314256999902,
                  57.597154038999989
                ],
                [
                  -13.690419074999909,
                  57.597805080000128
                ],
                [
                  -13.688588019999912,
                  57.597805080000128
                ],
                [
                  -13.687652147999927,
                  57.597154038999989
                ],
                [
                  -13.687652147999927,
                  57.596869208000058
                ],
                [
                  -13.688588019999912,
                  57.596258856000091
                ]
              ]
            ],
            [
              [
                [
                  -7.189116990999935,
                  57.655096747000172
                ],
                [
                  -7.172840949999909,
                  57.649562893000066
                ],
                [
                  -7.142567511999914,
                  57.658107815000093
                ],
                [
                  -7.129383917999888,
                  57.652899481000091
                ],
                [
                  -7.114572719999899,
                  57.652329820000105
                ],
                [
                  -7.092600063999896,
                  57.652085679000081
                ],
                [
                  -7.074086066999882,
                  57.646389065
                ],
                [
                  -7.065052863999881,
                  57.633978583000058
                ],
                [
                  -7.075428839999859,
                  57.628363348000065
                ],
                [
                  -7.092355923999946,
                  57.611517645000063
                ],
                [
                  -7.099191860999952,
                  57.607326565000122
                ],
                [
                  -7.113107876999948,
                  57.608710028000118
                ],
                [
                  -7.123117641999926,
                  57.615708725999987
                ],
                [
                  -7.130767381999874,
                  57.623480536
                ],
                [
                  -7.137318488999938,
                  57.627142645000148
                ],
                [
                  -7.148426886999886,
                  57.629339911000145
                ],
                [
                  -7.171131964999916,
                  57.641424872000144
                ],
                [
                  -7.215891079999949,
                  57.641424872000144
                ],
                [
                  -7.215891079999949,
                  57.633978583000058
                ],
                [
                  -7.204253709999932,
                  57.633368231000119
                ],
                [
                  -7.197255011999886,
                  57.631252346000011
                ],
                [
                  -7.196156378999916,
                  57.62718333500014
                ],
                [
                  -7.202137824999852,
                  57.620917059000092
                ],
                [
                  -7.202137824999852,
                  57.613470770000035
                ],
                [
                  -7.173247850999928,
                  57.61465078300013
                ],
                [
                  -7.164418097999885,
                  57.609930731000034
                ],
                [
                  -7.161203579999921,
                  57.596380927000084
                ],
                [
                  -7.154286261999914,
                  57.587347723000065
                ],
                [
                  -7.13805091099988,
                  57.586981512000037
                ],
                [
                  -7.10602779899989,
                  57.592962958000058
                ],
                [
                  -7.125599738999938,
                  57.571112372000115
                ],
                [
                  -7.149973110999923,
                  57.561712958
                ],
                [
                  -7.2084041009999,
                  57.558823960000055
                ],
                [
                  -7.215728318999908,
                  57.557359117000104
                ],
                [
                  -7.230213995999861,
                  57.552394924000154
                ],
                [
                  -7.236317511999914,
                  57.552069403000033
                ],
                [
                  -7.243275519999912,
                  57.556097723000093
                ],
                [
                  -7.252064581999889,
                  57.569281317000147
                ],
                [
                  -7.256743943999908,
                  57.572495835
                ],
                [
                  -7.269886847999942,
                  57.570542710000055
                ],
                [
                  -7.312082485999895,
                  57.552069403000033
                ],
                [
                  -7.312082485999895,
                  57.544582424000154
                ],
                [
                  -7.240061001999948,
                  57.544582424000154
                ],
                [
                  -7.181304490999878,
                  57.553900458
                ],
                [
                  -7.161203579999921,
                  57.552069403000033
                ],
                [
                  -7.144154425999943,
                  57.548529364000146
                ],
                [
                  -7.137684699999852,
                  57.54511139500012
                ],
                [
                  -7.133900519999941,
                  57.53839752800009
                ],
                [
                  -7.137277798999946,
                  57.532131252000127
                ],
                [
                  -7.157541469999956,
                  57.511053778000118
                ],
                [
                  -7.199208136999914,
                  57.512681382000139
                ],
                [
                  -7.219838019999941,
                  57.51080963700015
                ],
                [
                  -7.236317511999914,
                  57.503607489000146
                ],
                [
                  -7.25251217399989,
                  57.510321356000176
                ],
                [
                  -7.287464972999885,
                  57.508775132000139
                ],
                [
                  -7.305287238999881,
                  57.511053778000118
                ],
                [
                  -7.314686652999882,
                  57.514593817
                ],
                [
                  -7.318470831999917,
                  57.517035223000121
                ],
                [
                  -7.329986131999959,
                  57.528876044000086
                ],
                [
                  -7.333485480999855,
                  57.534328518000123
                ],
                [
                  -7.338124152999882,
                  57.539740302000084
                ],
                [
                  -7.346180792999917,
                  57.544582424000154
                ],
                [
                  -7.337554490999906,
                  57.545070705000128
                ],
                [
                  -7.318267381999874,
                  57.552069403000033
                ],
                [
                  -7.351226365999935,
                  57.553697007000054
                ],
                [
                  -7.411610480999855,
                  57.57514069200009
                ],
                [
                  -7.442372199999852,
                  57.579291083000115
                ],
                [
                  -7.449208136999857,
                  57.572902736000103
                ],
                [
                  -7.455922003999916,
                  57.568426825000031
                ],
                [
                  -7.462880011999886,
                  57.566310940000122
                ],
                [
                  -7.47085527299987,
                  57.56720612200003
                ],
                [
                  -7.483265753999888,
                  57.571478583000115
                ],
                [
                  -7.499419725999928,
                  57.575018622000115
                ],
                [
                  -7.544829881999931,
                  57.592962958000058
                ],
                [
                  -7.544829881999931,
                  57.599798895000092
                ],
                [
                  -7.522206183999884,
                  57.608384507
                ],
                [
                  -7.506581183999884,
                  57.625555731000119
                ],
                [
                  -7.493031378999916,
                  57.645412502000042
                ],
                [
                  -7.476551886999943,
                  57.661932684000092
                ],
                [
                  -7.455311652999853,
                  57.655462958
                ],
                [
                  -7.387115037999934,
                  57.661932684000092
                ],
                [
                  -7.387115037999934,
                  57.655096747000172
                ],
                [
                  -7.394927537999934,
                  57.654445705000128
                ],
                [
                  -7.414418097999914,
                  57.648260809000149
                ],
                [
                  -7.396555141999954,
                  57.635321356000148
                ],
                [
                  -7.366851365999906,
                  57.651434637000037
                ],
                [
                  -7.3353572259999,
                  57.676092841000028
                ],
                [
                  -7.312082485999895,
                  57.688544012000037
                ],
                [
                  -7.312082485999895,
                  57.682359117000075
                ],
                [
                  -7.318186001999891,
                  57.678859768000095
                ],
                [
                  -7.32286536399991,
                  57.674750067000119
                ],
                [
                  -7.33250891799986,
                  57.661932684000092
                ],
                [
                  -7.277902798999918,
                  57.649562893000066
                ],
                [
                  -7.256743943999908,
                  57.648260809000149
                ],
                [
                  -7.256743943999908,
                  57.655096747000172
                ],
                [
                  -7.263417120999861,
                  57.655991929000081
                ],
                [
                  -7.277251756999874,
                  57.661932684000092
                ],
                [
                  -7.255970831999889,
                  57.666937567000147
                ],
                [
                  -7.209055141999926,
                  57.686021226000108
                ],
                [
                  -7.181711391999954,
                  57.688544012000037
                ],
                [
                  -7.169178839999859,
                  57.679185289000102
                ],
                [
                  -7.165394660999937,
                  57.669867255000057
                ],
                [
                  -7.171538865999906,
                  57.661525783000101
                ],
                [
                  -7.189116990999935,
                  57.655096747000172
                ]
              ]
            ],
            [
              [
                [
                  -6.310902472999885,
                  57.702826239000117
                ],
                [
                  -6.302235480999912,
                  57.692368882000054
                ],
                [
                  -6.293324347999942,
                  57.686021226000108
                ],
                [
                  -6.269886847999885,
                  57.675523179000052
                ],
                [
                  -6.260487433999856,
                  57.668646552000141
                ],
                [
                  -6.236073370999918,
                  57.646185614000146
                ],
                [
                  -6.23265540299991,
                  57.641424872000144
                ],
                [
                  -6.18797766799986,
                  57.620917059000092
                ],
                [
                  -6.168853318999879,
                  57.607611395000063
                ],
                [
                  -6.158355272999899,
                  57.59784577000012
                ],
                [
                  -6.153879360999923,
                  57.589544989000146
                ],
                [
                  -6.14468339799987,
                  57.520005601000051
                ],
                [
                  -6.135121222999885,
                  57.490057684000178
                ],
                [
                  -6.13337154899989,
                  57.476263739000061
                ],
                [
                  -6.136057094999956,
                  57.461330471000124
                ],
                [
                  -6.145090298999946,
                  57.438625393000066
                ],
                [
                  -6.146962042999917,
                  57.42511627800009
                ],
                [
                  -6.15249589799987,
                  57.417547919000143
                ],
                [
                  -6.178863084999932,
                  57.40355052299999
                ],
                [
                  -6.18797766799986,
                  57.394354559000121
                ],
                [
                  -6.175852016999954,
                  57.400824286000116
                ],
                [
                  -6.159250454999892,
                  57.407375393
                ],
                [
                  -6.14159094999988,
                  57.410793361000017
                ],
                [
                  -6.126535610999952,
                  57.408026434000149
                ],
                [
                  -6.117909308999856,
                  57.397772528000033
                ],
                [
                  -6.12352454299986,
                  57.388251044000029
                ],
                [
                  -6.134103969999899,
                  57.380031643000123
                ],
                [
                  -6.140126105999912,
                  57.373928127000156
                ],
                [
                  -6.13524329299986,
                  57.357367255000085
                ],
                [
                  -6.120757615999906,
                  57.347072658000158
                ],
                [
                  -6.105702277999882,
                  57.339667059000178
                ],
                [
                  -6.099232550999886,
                  57.33234284100017
                ],
                [
                  -6.106597459999875,
                  57.323472398000135
                ],
                [
                  -6.140288865999878,
                  57.312445380000085
                ],
                [
                  -6.153879360999923,
                  57.305609442000062
                ],
                [
                  -6.068186001999948,
                  57.311835028000118
                ],
                [
                  -6.045399542999945,
                  57.308294989000146
                ],
                [
                  -6.041086391999926,
                  57.300116278000033
                ],
                [
                  -6.052886522999899,
                  57.291001695000048
                ],
                [
                  -6.078114386999857,
                  57.284491278000147
                ],
                [
                  -6.078114386999857,
                  57.277655341000028
                ],
                [
                  -6.050852016999954,
                  57.279242255000057
                ],
                [
                  -6.028879360999952,
                  57.285345770000148
                ],
                [
                  -6.008452928999901,
                  57.286769924000041
                ],
                [
                  -5.986236131999931,
                  57.274318752000013
                ],
                [
                  -5.976673956999946,
                  57.27033112200003
                ],
                [
                  -5.96344967399989,
                  57.269476630000113
                ],
                [
                  -5.938140428999873,
                  57.270900783000101
                ],
                [
                  -5.9232478509999,
                  57.266913153000118
                ],
                [
                  -5.91380774599989,
                  57.257879950000117
                ],
                [
                  -5.907134568999936,
                  57.248480536000088
                ],
                [
                  -5.900624152999853,
                  57.242905992000075
                ],
                [
                  -5.886219855999883,
                  57.242092190000065
                ],
                [
                  -5.877308722999942,
                  57.246812242000075
                ],
                [
                  -5.87132727799991,
                  57.253241278000175
                ],
                [
                  -5.865834113999881,
                  57.257147528000175
                ],
                [
                  -5.824330206999889,
                  57.256170966000113
                ],
                [
                  -5.795806443999908,
                  57.271795966000084
                ],
                [
                  -5.76789303299995,
                  57.277411200000088
                ],
                [
                  -5.738514777999853,
                  57.277289130000113
                ],
                [
                  -5.721831834999904,
                  57.264634507000139
                ],
                [
                  -5.647368943999936,
                  57.264634507000139
                ],
                [
                  -5.663889126999919,
                  57.239813544000086
                ],
                [
                  -5.663482225999928,
                  57.233303127000099
                ],
                [
                  -5.659087693999936,
                  57.222479559000092
                ],
                [
                  -5.662953253999945,
                  57.212713934000149
                ],
                [
                  -5.670643683999856,
                  57.204657294000029
                ],
                [
                  -5.690907355999883,
                  57.189520575000031
                ],
                [
                  -5.727284308999856,
                  57.172796942
                ],
                [
                  -5.74233964799987,
                  57.168443101000108
                ],
                [
                  -5.782053188999896,
                  57.166245835000112
                ],
                [
                  -5.788970506999874,
                  57.159491278000175
                ],
                [
                  -5.790760870999861,
                  57.137396552
                ],
                [
                  -5.800363735999952,
                  57.123724677000055
                ],
                [
                  -5.821441209999875,
                  57.114447333
                ],
                [
                  -5.842640753999945,
                  57.107977606000091
                ],
                [
                  -5.85220292899993,
                  57.10297272300015
                ],
                [
                  -5.860096808999913,
                  57.095363674000012
                ],
                [
                  -5.918853318999908,
                  57.05011627800009
                ],
                [
                  -5.934925910999908,
                  57.041205145000148
                ],
                [
                  -5.953439907999922,
                  57.03412506700009
                ],
                [
                  -6.006743943999879,
                  57.028387762000122
                ],
                [
                  -6.020822719999927,
                  57.031887111000017
                ],
                [
                  -6.030384894999912,
                  57.04490794499999
                ],
                [
                  -6.027251756999931,
                  57.062160549000012
                ],
                [
                  -6.000233527999882,
                  57.083929755000057
                ],
                [
                  -6.003041144999941,
                  57.092718817000119
                ],
                [
                  -6.003041144999941,
                  57.099554755000142
                ],
                [
                  -5.997059699999909,
                  57.10175202000012
                ],
                [
                  -5.994211391999897,
                  57.104559637000179
                ],
                [
                  -5.989979620999861,
                  57.113836981000034
                ],
                [
                  -5.986927863999881,
                  57.118231512000122
                ],
                [
                  -5.980091925999943,
                  57.123114325000088
                ],
                [
                  -5.961822068999879,
                  57.142157294000086
                ],
                [
                  -5.952788865999878,
                  57.148830471000124
                ],
                [
                  -5.94155839799987,
                  57.154771226000079
                ],
                [
                  -5.845366990999935,
                  57.181463934000092
                ],
                [
                  -5.845366990999935,
                  57.188299872000115
                ],
                [
                  -5.872954881999931,
                  57.179999091000028
                ],
                [
                  -5.900868292999888,
                  57.175523179000081
                ],
                [
                  -5.986236131999931,
                  57.174627997000172
                ],
                [
                  -5.991688605999883,
                  57.177191473000093
                ],
                [
                  -5.993072068999936,
                  57.183172919000086
                ],
                [
                  -5.993316209999904,
                  57.19017161699999
                ],
                [
                  -5.995594855999855,
                  57.195746161000088
                ],
                [
                  -6.01927649599989,
                  57.21759674700003
                ],
                [
                  -6.03221594999988,
                  57.226507880000057
                ],
                [
                  -6.044016079999949,
                  57.229925848000065
                ],
                [
                  -6.039784308999856,
                  57.219387111000017
                ],
                [
                  -6.035389777999853,
                  57.211493231000034
                ],
                [
                  -6.023508266999897,
                  57.195746161000088
                ],
                [
                  -6.034087693999936,
                  57.181097723000065
                ],
                [
                  -6.040842251999891,
                  57.174139716000084
                ],
                [
                  -6.050852016999954,
                  57.168443101000108
                ],
                [
                  -6.044016079999949,
                  57.161037502000013
                ],
                [
                  -6.056263800999915,
                  57.152899481000091
                ],
                [
                  -6.064605272999899,
                  57.141750393000095
                ],
                [
                  -6.073841925999943,
                  57.13178131700009
                ],
                [
                  -6.088612433999856,
                  57.127427475999987
                ],
                [
                  -6.101429816999882,
                  57.135199286
                ],
                [
                  -6.107167120999861,
                  57.153021552000084
                ],
                [
                  -6.111195441999911,
                  57.173285223000093
                ],
                [
                  -6.112904425999915,
                  57.188299872000115
                ],
                [
                  -6.120961066999939,
                  57.193793036000145
                ],
                [
                  -6.126454230999883,
                  57.19521719
                ],
                [
                  -6.132069464999887,
                  57.193182684000178
                ],
                [
                  -6.140126105999912,
                  57.188299872000115
                ],
                [
                  -6.147450324999909,
                  57.194525458000058
                ],
                [
                  -6.155588344999927,
                  57.198879299000154
                ],
                [
                  -6.164458787999877,
                  57.201361395000092
                ],
                [
                  -6.174305792999917,
                  57.201971747000144
                ],
                [
                  -6.174305792999917,
                  57.195746161000088
                ],
                [
                  -6.159820115999963,
                  57.187648830000157
                ],
                [
                  -6.177154100999928,
                  57.181219794000143
                ],
                [
                  -6.318348761999886,
                  57.161037502000013
                ],
                [
                  -6.318348761999886,
                  57.168443101000108
                ],
                [
                  -6.306996222999885,
                  57.17389557500006
                ],
                [
                  -6.276722785999908,
                  57.195746161000088
                ],
                [
                  -6.276722785999908,
                  57.201971747000144
                ],
                [
                  -6.295318162999905,
                  57.20237864800005
                ],
                [
                  -6.313099738999881,
                  57.199896552000112
                ],
                [
                  -6.329986131999874,
                  57.195013739000061
                ],
                [
                  -6.345611131999874,
                  57.188299872000115
                ],
                [
                  -6.364735480999855,
                  57.20453522300015
                ],
                [
                  -6.379790818999936,
                  57.223089911000059
                ],
                [
                  -6.36888587099989,
                  57.225775458000143
                ],
                [
                  -6.359486456999946,
                  57.22943756700009
                ],
                [
                  -6.351714647999955,
                  57.234808661000145
                ],
                [
                  -6.345611131999874,
                  57.242905992000075
                ],
                [
                  -6.391428188999953,
                  57.240545966000028
                ],
                [
                  -6.408192511999886,
                  57.243353583000058
                ],
                [
                  -6.455474412999934,
                  57.277655341000028
                ],
                [
                  -6.457997199999852,
                  57.280991929000052
                ],
                [
                  -6.462961391999897,
                  57.290432033000073
                ],
                [
                  -6.466053839999887,
                  57.294745184000178
                ],
                [
                  -6.471180792999888,
                  57.299017645000092
                ],
                [
                  -6.47557532499988,
                  57.301418361000131
                ],
                [
                  -6.479156053999873,
                  57.304754950000145
                ],
                [
                  -6.482167120999861,
                  57.311835028000118
                ],
                [
                  -6.436187303999901,
                  57.329738674000069
                ],
                [
                  -6.416411912999877,
                  57.334540106000148
                ],
                [
                  -6.394032355999855,
                  57.33234284100017
                ],
                [
                  -6.376332160999937,
                  57.323797919000143
                ],
                [
                  -6.358509894999884,
                  57.311835028000118
                ],
                [
                  -6.337635870999918,
                  57.301499742000104
                ],
                [
                  -6.310902472999885,
                  57.298163153000175
                ],
                [
                  -6.323882615999878,
                  57.311428127000013
                ],
                [
                  -6.386586066999882,
                  57.339789130000057
                ],
                [
                  -6.399525519999884,
                  57.348456122000144
                ],
                [
                  -6.406158006999931,
                  57.351548570000134
                ],
                [
                  -6.417632615999906,
                  57.35276927300005
                ],
                [
                  -6.428822394999912,
                  57.351507880000142
                ],
                [
                  -6.45055091099988,
                  57.346502997000087
                ],
                [
                  -6.462961391999897,
                  57.34658437700007
                ],
                [
                  -6.448638475999928,
                  57.35276927300005
                ],
                [
                  -6.448638475999928,
                  57.360256252000013
                ],
                [
                  -6.456613735999952,
                  57.361151434000092
                ],
                [
                  -6.475941535999908,
                  57.367092190000122
                ],
                [
                  -6.468739386999857,
                  57.368557033000101
                ],
                [
                  -6.465809699999852,
                  57.370021877000156
                ],
                [
                  -6.462961391999897,
                  57.373928127000156
                ],
                [
                  -6.472157355999883,
                  57.376532294000143
                ],
                [
                  -6.478871222999914,
                  57.381903387000094
                ],
                [
                  -6.480824347999885,
                  57.390082098
                ],
                [
                  -6.475941535999908,
                  57.401190497000059
                ],
                [
                  -6.490834113999938,
                  57.398993231000148
                ],
                [
                  -6.510609503999888,
                  57.385565497000144
                ],
                [
                  -6.523793097999914,
                  57.380764065000065
                ],
                [
                  -6.518706834999904,
                  57.389553127000127
                ],
                [
                  -6.517648891999954,
                  57.398871161000088
                ],
                [
                  -6.521229620999918,
                  57.407863674000097
                ],
                [
                  -6.530629035999937,
                  57.415472723000121
                ],
                [
                  -6.538929816999911,
                  57.40232982
                ],
                [
                  -6.550404425999972,
                  57.398016669000171
                ],
                [
                  -6.562123175999943,
                  57.395453192000062
                ],
                [
                  -6.571522589999887,
                  57.387600002000099
                ],
                [
                  -6.573150193999908,
                  57.376125393000123
                ],
                [
                  -6.562123175999943,
                  57.357855536000059
                ],
                [
                  -6.564116990999906,
                  57.34658437700007
                ],
                [
                  -6.580555792999888,
                  57.33881256700009
                ],
                [
                  -6.67247473899991,
                  57.355943101000108
                ],
                [
                  -6.695952928999873,
                  57.364406643000152
                ],
                [
                  -6.714751756999931,
                  57.376613674000126
                ],
                [
                  -6.722401495999861,
                  57.390936591000113
                ],
                [
                  -6.731678839999916,
                  57.416978257
                ],
                [
                  -6.773182745999918,
                  57.434068101000136
                ],
                [
                  -6.78384355399993,
                  57.456447658000158
                ],
                [
                  -6.722401495999861,
                  57.456447658000158
                ],
                [
                  -6.736317511999857,
                  57.465155341000056
                ],
                [
                  -6.745228644999884,
                  57.475897528000147
                ],
                [
                  -6.747141079999921,
                  57.487941799000069
                ],
                [
                  -6.739735480999855,
                  57.500555731000063
                ],
                [
                  -6.726307745999861,
                  57.511419989000117
                ],
                [
                  -6.715931769999941,
                  57.514227606000176
                ],
                [
                  -6.706450975999871,
                  57.510931708000143
                ],
                [
                  -6.653553839999887,
                  57.468695380000113
                ],
                [
                  -6.647328253999945,
                  57.459540106000034
                ],
                [
                  -6.638091600999871,
                  57.4532738300001
                ],
                [
                  -6.620025193999936,
                  57.445502020000092
                ],
                [
                  -6.606800910999908,
                  57.443915106000148
                ],
                [
                  -6.612538214999887,
                  57.456447658000158
                ],
                [
                  -6.612538214999887,
                  57.462632554000109
                ],
                [
                  -6.608265753999888,
                  57.464585679000081
                ],
                [
                  -6.60415605399993,
                  57.467759507000139
                ],
                [
                  -6.599476691999911,
                  57.469427802000055
                ],
                [
                  -6.616688605999912,
                  57.480902411
                ],
                [
                  -6.61937415299991,
                  57.483099677
                ],
                [
                  -6.622222459999932,
                  57.486395575000031
                ],
                [
                  -6.631255662999962,
                  57.49359772300015
                ],
                [
                  -6.633046027999853,
                  57.497463283000158
                ],
                [
                  -6.630604620999918,
                  57.501776434000149
                ],
                [
                  -6.621408657999922,
                  57.503851630000085
                ],
                [
                  -6.61937415299991,
                  57.507310288999989
                ],
                [
                  -6.611439581999946,
                  57.512193101000051
                ],
                [
                  -6.593617316999882,
                  57.510972398000135
                ],
                [
                  -6.564116990999906,
                  57.503607489000146
                ],
                [
                  -6.573963995999918,
                  57.521714585000055
                ],
                [
                  -6.599354620999947,
                  57.537543036000088
                ],
                [
                  -6.62987219999988,
                  57.548529364000146
                ],
                [
                  -6.654774542999917,
                  57.552069403000033
                ],
                [
                  -6.64159094999988,
                  57.561957098000121
                ],
                [
                  -6.631011522999899,
                  57.576808986000103
                ],
                [
                  -6.628895636999914,
                  57.591131903000175
                ],
                [
                  -6.640451626999919,
                  57.599798895000092
                ],
                [
                  -6.640451626999919,
                  57.607326565000122
                ],
                [
                  -6.619781053999901,
                  57.607163804000081
                ],
                [
                  -6.605620897999899,
                  57.599554755000142
                ],
                [
                  -6.594309048999918,
                  57.590521552000112
                ],
                [
                  -6.572255011999914,
                  57.582505600999987
                ],
                [
                  -6.568430141999897,
                  57.574286200000174
                ],
                [
                  -6.56688391799986,
                  57.565090236000017
                ],
                [
                  -6.564116990999906,
                  57.558823960000055
                ],
                [
                  -6.554595506999903,
                  57.552476304000137
                ],
                [
                  -6.547759568999879,
                  57.549546617000104
                ],
                [
                  -6.501210089999859,
                  57.535549221000153
                ],
                [
                  -6.49038652299987,
                  57.530259507000082
                ],
                [
                  -6.47907467399989,
                  57.520982164000102
                ],
                [
                  -6.464914516999954,
                  57.512518622000172
                ],
                [
                  -6.451649542999917,
                  57.513332424000097
                ],
                [
                  -6.43765214799987,
                  57.517238674000097
                ],
                [
                  -6.420765753999973,
                  57.517889716000028
                ],
                [
                  -6.443470831999917,
                  57.488104559000035
                ],
                [
                  -6.433501756999931,
                  57.486476955000015
                ],
                [
                  -6.412098761999886,
                  57.501369533000158
                ],
                [
                  -6.400257941999911,
                  57.520982164000102
                ],
                [
                  -6.386952277999882,
                  57.517279364000089
                ],
                [
                  -6.310902472999885,
                  57.462632554000109
                ],
                [
                  -6.310902472999885,
                  57.469427802000055
                ],
                [
                  -6.31578528599988,
                  57.472805080000072
                ],
                [
                  -6.320952928999873,
                  57.479315497000144
                ],
                [
                  -6.32518469999988,
                  57.483099677
                ],
                [
                  -6.324615037999905,
                  57.496812242000104
                ],
                [
                  -6.338531053999901,
                  57.509466864000089
                ],
                [
                  -6.372954881999931,
                  57.53156159100017
                ],
                [
                  -6.389556443999879,
                  57.552476304000137
                ],
                [
                  -6.385853644999941,
                  57.562648830000072
                ],
                [
                  -6.372425910999937,
                  57.57257721600017
                ],
                [
                  -6.35985266799986,
                  57.592962958000058
                ],
                [
                  -6.371937628999973,
                  57.591864325000117
                ],
                [
                  -6.383371548999918,
                  57.592922268000066
                ],
                [
                  -6.393137173999946,
                  57.595648505000142
                ],
                [
                  -6.400257941999911,
                  57.599798895000092
                ],
                [
                  -6.395863410999937,
                  57.613470770000035
                ],
                [
                  -6.401112433999913,
                  57.621527411000145
                ],
                [
                  -6.40953528599988,
                  57.627346096000011
                ],
                [
                  -6.414540167999917,
                  57.633978583000058
                ],
                [
                  -6.415679490999935,
                  57.645819403000033
                ],
                [
                  -6.41344153599988,
                  57.64923737200003
                ],
                [
                  -6.406605597999942,
                  57.650336005000085
                ],
                [
                  -6.366566535999908,
                  57.664252020000063
                ],
                [
                  -6.35985266799986,
                  57.668117580000072
                ],
                [
                  -6.351185675999886,
                  57.680121161
                ],
                [
                  -6.345285610999923,
                  57.692206122000087
                ],
                [
                  -6.337961391999926,
                  57.699164130000085
                ],
                [
                  -6.32518469999988,
                  57.695990302000112
                ],
                [
                  -6.317494269999884,
                  57.697699286000116
                ],
                [
                  -6.314279751999919,
                  57.699164130000085
                ],
                [
                  -6.310902472999885,
                  57.702826239000117
                ]
              ]
            ],
            [
              [
                [
                  -7.170033331999974,
                  57.715155341000084
                ],
                [
                  -7.19896399599989,
                  57.707953192000147
                ],
                [
                  -7.222645636999886,
                  57.709662177000055
                ],
                [
                  -7.180165167999917,
                  57.734686591000141
                ],
                [
                  -7.161203579999921,
                  57.737005927000112
                ],
                [
                  -7.152007615999935,
                  57.726304429000024
                ],
                [
                  -7.170033331999974,
                  57.715155341000084
                ]
              ]
            ],
            [
              [
                [
                  -8.56895911399991,
                  57.807562567
                ],
                [
                  -8.590891079999949,
                  57.804754950000145
                ],
                [
                  -8.61070716099988,
                  57.81273021
                ],
                [
                  -8.621001756999874,
                  57.833197333000058
                ],
                [
                  -8.605295376999919,
                  57.82640208500014
                ],
                [
                  -8.569081183999884,
                  57.823675848000065
                ],
                [
                  -8.552235480999883,
                  57.818915106000148
                ],
                [
                  -8.56895911399991,
                  57.807562567
                ]
              ]
            ],
            [
              [
                [
                  -6.997385219999927,
                  57.915106512000094
                ],
                [
                  -6.997059699999909,
                  57.893540757
                ],
                [
                  -7.0091853509999,
                  57.889593817000033
                ],
                [
                  -7.044585740999906,
                  57.902085679000109
                ],
                [
                  -7.048085089999887,
                  57.89081452000012
                ],
                [
                  -7.05516516799986,
                  57.884182033000158
                ],
                [
                  -7.065500454999949,
                  57.881048895000092
                ],
                [
                  -7.079335089999859,
                  57.880316473000065
                ],
                [
                  -7.077056443999879,
                  57.888617255000142
                ],
                [
                  -7.076771613999938,
                  57.890692450000145
                ],
                [
                  -7.07787024599989,
                  57.891180731000063
                ],
                [
                  -7.079335089999859,
                  57.894680080000128
                ],
                [
                  -7.037749803999873,
                  57.916327216000028
                ],
                [
                  -7.015533006999931,
                  57.921942450000031
                ],
                [
                  -6.997385219999927,
                  57.915106512000094
                ]
              ]
            ],
            [
              [
                [
                  -6.861154751999948,
                  58.253363348000121
                ],
                [
                  -6.828928188999896,
                  58.233791408000158
                ],
                [
                  -6.81859290299991,
                  58.237250067000062
                ],
                [
                  -6.809641079999977,
                  58.232245184000121
                ],
                [
                  -6.801991339999859,
                  58.226141669000029
                ],
                [
                  -6.795765753999888,
                  58.218817450000031
                ],
                [
                  -6.791249152999939,
                  58.209947007000082
                ],
                [
                  -6.873280402999853,
                  58.209947007000082
                ],
                [
                  -6.873280402999853,
                  58.21678294499999
                ],
                [
                  -6.862863735999952,
                  58.216457424000069
                ],
                [
                  -6.85960852799991,
                  58.21678294499999
                ],
                [
                  -6.85960852799991,
                  58.223049221000124
                ],
                [
                  -6.872222459999904,
                  58.226792710000083
                ],
                [
                  -6.882313605999855,
                  58.236273505000085
                ],
                [
                  -6.886219855999855,
                  58.247626044000143
                ],
                [
                  -6.880034959999875,
                  58.257757880000113
                ],
                [
                  -6.861154751999948,
                  58.253363348000121
                ]
              ]
            ],
            [
              [
                [
                  -6.195546027999882,
                  58.356268622000115
                ],
                [
                  -6.182240363999881,
                  58.353664455000015
                ],
                [
                  -6.167469855999883,
                  58.353949286000145
                ],
                [
                  -6.167469855999883,
                  58.346502997000172
                ],
                [
                  -6.188832160999937,
                  58.340806382
                ],
                [
                  -6.233713344999956,
                  58.322821356000148
                ],
                [
                  -6.249989386999886,
                  58.312974351000136
                ],
                [
                  -6.244984503999945,
                  58.304144598000065
                ],
                [
                  -6.246408657999922,
                  58.297552802
                ],
                [
                  -6.253814256999903,
                  58.293361721000068
                ],
                [
                  -6.266835089999887,
                  58.291896877000013
                ],
                [
                  -6.278675910999937,
                  58.288723049000126
                ],
                [
                  -6.288238084999932,
                  58.274603583000115
                ],
                [
                  -6.317860480999883,
                  58.268296617000075
                ],
                [
                  -6.319935675999915,
                  58.260931708000086
                ],
                [
                  -6.31696529899989,
                  58.252142645
                ],
                [
                  -6.318348761999886,
                  58.244696356000034
                ],
                [
                  -6.327463344999956,
                  58.239732163999989
                ],
                [
                  -6.33849036399991,
                  58.237616278000175
                ],
                [
                  -6.366118943999908,
                  58.237250067000062
                ],
                [
                  -6.347727016999954,
                  58.221136786000088
                ],
                [
                  -6.310861782999893,
                  58.21503327
                ],
                [
                  -6.270904100999957,
                  58.216498114000061
                ],
                [
                  -6.243234829999949,
                  58.223049221000124
                ],
                [
                  -6.194813605999855,
                  58.250921942
                ],
                [
                  -6.179758266999926,
                  58.255560614000117
                ],
                [
                  -6.161122199999852,
                  58.258978583000115
                ],
                [
                  -6.15070553299995,
                  58.258368231000148
                ],
                [
                  -6.160023566999911,
                  58.250921942
                ],
                [
                  -6.160023566999911,
                  58.244696356000034
                ],
                [
                  -6.153879360999923,
                  58.244696356000034
                ],
                [
                  -6.158558722999942,
                  58.239813544000143
                ],
                [
                  -6.163319464999859,
                  58.233587958
                ],
                [
                  -6.167469855999883,
                  58.230414130000142
                ],
                [
                  -6.164865688999896,
                  58.226752020000092
                ],
                [
                  -6.160023566999911,
                  58.21678294499999
                ],
                [
                  -6.186431443999908,
                  58.20990631700009
                ],
                [
                  -6.195220506999874,
                  58.206488348000065
                ],
                [
                  -6.20213782499988,
                  58.20197174700003
                ],
                [
                  -6.211659308999856,
                  58.192287502000156
                ],
                [
                  -6.215321417999917,
                  58.189439195000105
                ],
                [
                  -6.233550584999904,
                  58.184271552000112
                ],
                [
                  -6.24742591099988,
                  58.18545156500015
                ],
                [
                  -6.276722785999908,
                  58.196275132000139
                ],
                [
                  -6.29356848899991,
                  58.199367580000043
                ],
                [
                  -6.338205532999979,
                  58.196275132000139
                ],
                [
                  -6.3548884759999,
                  58.199367580000043
                ],
                [
                  -6.384673631999931,
                  58.209702867000132
                ],
                [
                  -6.400257941999911,
                  58.209947007000082
                ],
                [
                  -6.377023891999897,
                  58.173529364
                ],
                [
                  -6.366118943999908,
                  58.162095445000048
                ],
                [
                  -6.374501105999883,
                  58.157660223000065
                ],
                [
                  -6.378041144999941,
                  58.153631903000118
                ],
                [
                  -6.377268032999922,
                  58.148627020000063
                ],
                [
                  -6.372954881999931,
                  58.141058661000116
                ],
                [
                  -6.390695766999926,
                  58.133530992000075
                ],
                [
                  -6.441232876999919,
                  58.127386786000088
                ],
                [
                  -6.474720831999889,
                  58.105210679000109
                ],
                [
                  -6.489654100999928,
                  58.100083726000022
                ],
                [
                  -6.499094204999949,
                  58.10040924700003
                ],
                [
                  -6.514393683999913,
                  58.106146552
                ],
                [
                  -6.523793097999914,
                  58.106878973000121
                ],
                [
                  -6.551096157999893,
                  58.093247788999989
                ],
                [
                  -6.603179490999935,
                  58.085638739000146
                ],
                [
                  -6.61937415299991,
                  58.086411851000079
                ],
                [
                  -6.61937415299991,
                  58.079575914000046
                ],
                [
                  -6.581288214999916,
                  58.07900625200007
                ],
                [
                  -6.451324022999899,
                  58.095689195000105
                ],
                [
                  -6.420643683999884,
                  58.10565827
                ],
                [
                  -6.407093878999916,
                  58.106878973000121
                ],
                [
                  -6.394032355999855,
                  58.101792710000026
                ],
                [
                  -6.383900519999912,
                  58.091782945000105
                ],
                [
                  -6.378570115999935,
                  58.079046942000062
                ],
                [
                  -6.379790818999936,
                  58.065985419000086
                ],
                [
                  -6.375721808999884,
                  58.064276434000178
                ],
                [
                  -6.366118943999908,
                  58.058539130000113
                ],
                [
                  -6.373687303999873,
                  58.052923895000035
                ],
                [
                  -6.381906704999949,
                  58.048895575000145
                ],
                [
                  -6.390695766999926,
                  58.046372789000131
                ],
                [
                  -6.400257941999911,
                  58.045477606000034
                ],
                [
                  -6.389475063999896,
                  58.04120514500012
                ],
                [
                  -6.377674933999856,
                  58.038763739
                ],
                [
                  -6.365101691999939,
                  58.037909247000087
                ],
                [
                  -6.352447068999879,
                  58.038641669000029
                ],
                [
                  -6.370961066999882,
                  58.02724844000015
                ],
                [
                  -6.385080532999922,
                  58.01593659100017
                ],
                [
                  -6.400868292999888,
                  58.007310289000074
                ],
                [
                  -6.424468553999901,
                  58.003892320000077
                ],
                [
                  -6.518218553999901,
                  58.012640692000119
                ],
                [
                  -6.539296027999853,
                  58.017279364000061
                ],
                [
                  -6.544911261999857,
                  58.017523505000028
                ],
                [
                  -6.550689256999903,
                  58.010077216000028
                ],
                [
                  -6.542225714999859,
                  58.005682684000064
                ],
                [
                  -6.520741339999916,
                  58.000799872000172
                ],
                [
                  -6.505116339999859,
                  57.992499091000084
                ],
                [
                  -6.469634568999965,
                  57.986883856000091
                ],
                [
                  -6.455474412999934,
                  57.97654857
                ],
                [
                  -6.455474412999934,
                  57.969712632000082
                ],
                [
                  -6.464995897999927,
                  57.965643622000115
                ],
                [
                  -6.481190558999884,
                  57.949774481000176
                ],
                [
                  -6.489654100999928,
                  57.943060614000146
                ],
                [
                  -6.50755774599989,
                  57.935980536000088
                ],
                [
                  -6.520130988999881,
                  57.936590887000037
                ],
                [
                  -6.532866990999935,
                  57.940415757000054
                ],
                [
                  -6.551096157999893,
                  57.943060614000146
                ],
                [
                  -6.551096157999893,
                  57.935614325000145
                ],
                [
                  -6.546701626999919,
                  57.933823960000083
                ],
                [
                  -6.541981574999909,
                  57.930853583000058
                ],
                [
                  -6.537464972999942,
                  57.928778387000037
                ],
                [
                  -6.537464972999942,
                  57.921332098000065
                ],
                [
                  -6.559803839999887,
                  57.915228583000086
                ],
                [
                  -6.578439907999893,
                  57.917222398000106
                ],
                [
                  -6.593861456999917,
                  57.924872137000065
                ],
                [
                  -6.606353318999908,
                  57.935614325000145
                ],
                [
                  -6.614979620999918,
                  57.949164130000113
                ],
                [
                  -6.620472785999937,
                  57.954535223000093
                ],
                [
                  -6.62987219999988,
                  57.956732489000089
                ],
                [
                  -6.634999152999882,
                  57.951605536000059
                ],
                [
                  -6.629628058999941,
                  57.940252997000087
                ],
                [
                  -6.620025193999936,
                  57.928168036000088
                ],
                [
                  -6.612538214999887,
                  57.921332098000065
                ],
                [
                  -6.61937415299991,
                  57.915106512000094
                ],
                [
                  -6.651193813999925,
                  57.92381419499999
                ],
                [
                  -6.660959438999896,
                  57.928778387000037
                ],
                [
                  -6.66616777299987,
                  57.933905341000141
                ],
                [
                  -6.672434048999918,
                  57.946193752000013
                ],
                [
                  -6.699818488999881,
                  57.976223049000069
                ],
                [
                  -6.707753058999856,
                  57.989569403000175
                ],
                [
                  -6.709380662999877,
                  58.003892320000077
                ],
                [
                  -6.694650844999899,
                  58.030096747000087
                ],
                [
                  -6.665842251999948,
                  58.044663804000109
                ],
                [
                  -6.629465298999975,
                  58.050930080000072
                ],
                [
                  -6.592030402999853,
                  58.052313544000143
                ],
                [
                  -6.592030402999853,
                  58.058539130000113
                ],
                [
                  -6.688303188999953,
                  58.058539130000113
                ],
                [
                  -6.688303188999953,
                  58.052313544000143
                ],
                [
                  -6.692697719999927,
                  58.040961005000085
                ],
                [
                  -6.716053839999916,
                  58.024969794000086
                ],
                [
                  -6.744496222999942,
                  58.010484117000132
                ],
                [
                  -6.764027472999914,
                  58.003892320000077
                ],
                [
                  -6.750884568999879,
                  57.992987372000087
                ],
                [
                  -6.730091925999886,
                  57.962958075000031
                ],
                [
                  -6.718983527999853,
                  57.956732489000089
                ],
                [
                  -6.704741990999935,
                  57.953192450000088
                ],
                [
                  -6.693226691999911,
                  57.945054429000081
                ],
                [
                  -6.683420376999891,
                  57.93573639500012
                ],
                [
                  -6.67398027299987,
                  57.928778387000037
                ],
                [
                  -6.679351365999935,
                  57.926825262000094
                ],
                [
                  -6.683461066999882,
                  57.924221096000011
                ],
                [
                  -6.688465949999909,
                  57.92206452
                ],
                [
                  -6.695668097999942,
                  57.921332098000065
                ],
                [
                  -6.688954230999912,
                  57.914943752000127
                ],
                [
                  -6.680327928999901,
                  57.912054755000113
                ],
                [
                  -6.67235266799986,
                  57.910589911000059
                ],
                [
                  -6.667795376999891,
                  57.908270575000088
                ],
                [
                  -6.665150519999912,
                  57.901556708000143
                ],
                [
                  -6.660959438999896,
                  57.880316473000065
                ],
                [
                  -6.742909308999913,
                  57.891262111000046
                ],
                [
                  -6.777658657999979,
                  57.902085679000109
                ],
                [
                  -6.787017381999903,
                  57.898830471000068
                ],
                [
                  -6.792388475999871,
                  57.893744208000058
                ],
                [
                  -6.797352667999917,
                  57.887396552000112
                ],
                [
                  -6.805572068999908,
                  57.880316473000065
                ],
                [
                  -6.794260219999927,
                  57.876206773000106
                ],
                [
                  -6.7728572259999,
                  57.871242580000157
                ],
                [
                  -6.764027472999914,
                  57.867905992000132
                ],
                [
                  -6.740712042999917,
                  57.845038153000033
                ],
                [
                  -6.736683722999942,
                  57.839422919000029
                ],
                [
                  -6.741932745999861,
                  57.831488348000065
                ],
                [
                  -6.75560462099989,
                  57.826483466000028
                ],
                [
                  -6.773508266999926,
                  57.824611721000153
                ],
                [
                  -6.791249152999939,
                  57.825751044000086
                ],
                [
                  -6.791249152999939,
                  57.818915106000148
                ],
                [
                  -6.78384355399993,
                  57.818915106000148
                ],
                [
                  -6.78384355399993,
                  57.81268952
                ],
                [
                  -6.806141730999883,
                  57.814642645000063
                ],
                [
                  -6.852691209999904,
                  57.833197333000058
                ],
                [
                  -6.85960852799991,
                  57.825751044000086
                ],
                [
                  -6.854156053999873,
                  57.823431708000115
                ],
                [
                  -6.845855272999899,
                  57.816392320000048
                ],
                [
                  -6.839100714999859,
                  57.81268952
                ],
                [
                  -6.85016842399989,
                  57.802923895000063
                ],
                [
                  -6.861154751999948,
                  57.796332098
                ],
                [
                  -6.887521938999953,
                  57.784816799000154
                ],
                [
                  -6.882720506999874,
                  57.782863674000012
                ],
                [
                  -6.877837693999879,
                  57.779852606000119
                ],
                [
                  -6.873280402999853,
                  57.777980861000131
                ],
                [
                  -6.893950975999871,
                  57.76654694200009
                ],
                [
                  -6.955148891999897,
                  57.743841864000146
                ],
                [
                  -6.973500128999945,
                  57.733343817000062
                ],
                [
                  -6.98078365799995,
                  57.735052802000084
                ],
                [
                  -7.031646287999905,
                  57.767401434000092
                ],
                [
                  -7.041371222999942,
                  57.770493882000082
                ],
                [
                  -7.10187740799995,
                  57.811468817
                ],
                [
                  -7.112782355999912,
                  57.815863348000065
                ],
                [
                  -7.117298956999889,
                  57.823065497000115
                ],
                [
                  -7.124623175999886,
                  57.830755927000112
                ],
                [
                  -7.125070766999954,
                  57.83690013200011
                ],
                [
                  -7.109445766999897,
                  57.839422919000029
                ],
                [
                  -7.096994594999956,
                  57.838039455000128
                ],
                [
                  -7.088612433999913,
                  57.833400783000016
                ],
                [
                  -7.083241339999859,
                  57.825100002000127
                ],
                [
                  -7.079335089999859,
                  57.81268952
                ],
                [
                  -6.997385219999927,
                  57.85370514500012
                ],
                [
                  -6.984852667999917,
                  57.864894924000126
                ],
                [
                  -6.962269660999937,
                  57.868841864000117
                ],
                [
                  -6.914173956999889,
                  57.867905992000132
                ],
                [
                  -6.962554490999878,
                  57.887844143000038
                ],
                [
                  -6.962554490999878,
                  57.894680080000128
                ],
                [
                  -6.911610480999883,
                  57.910589911000059
                ],
                [
                  -6.881703253999888,
                  57.91429271
                ],
                [
                  -6.851877407999893,
                  57.910589911000059
                ],
                [
                  -6.832264777999853,
                  57.902085679000109
                ],
                [
                  -6.841867641999926,
                  57.907049872000172
                ],
                [
                  -6.851551886999886,
                  57.911403713000155
                ],
                [
                  -6.85960852799991,
                  57.915228583000086
                ],
                [
                  -6.862945115999935,
                  57.918036200000031
                ],
                [
                  -6.865834113999881,
                  57.921332098000065
                ],
                [
                  -6.846994594999927,
                  57.927923895000148
                ],
                [
                  -6.839100714999859,
                  57.928778387000037
                ],
                [
                  -6.839100714999859,
                  57.935614325000145
                ],
                [
                  -6.897084113999938,
                  57.935614325000145
                ],
                [
                  -6.910796678999873,
                  57.938910223
                ],
                [
                  -6.937001105999912,
                  57.953436591000056
                ],
                [
                  -6.952056443999908,
                  57.956732489000089
                ],
                [
                  -7.009755011999857,
                  57.955267645000035
                ],
                [
                  -7.036284959999932,
                  57.960638739000061
                ],
                [
                  -7.044585740999906,
                  57.97654857
                ],
                [
                  -7.057281053999873,
                  57.970851955000015
                ],
                [
                  -7.0658259759999,
                  57.97101471600017
                ],
                [
                  -7.112782355999912,
                  57.990220445000134
                ],
                [
                  -7.096669074999852,
                  57.99746328300013
                ],
                [
                  -7.084828253999888,
                  58.005926825000088
                ],
                [
                  -7.071766730999912,
                  58.01190827
                ],
                [
                  -7.051909959999904,
                  58.011379299000126
                ],
                [
                  -7.051909959999904,
                  58.017523505000028
                ],
                [
                  -7.05492102799991,
                  58.01976146
                ],
                [
                  -7.055653449999852,
                  58.020697333000086
                ],
                [
                  -7.056141730999912,
                  58.021958725999987
                ],
                [
                  -7.058216925999943,
                  58.024969794000086
                ],
                [
                  -7.027902798999946,
                  58.027533270000092
                ],
                [
                  -6.995228644999912,
                  58.033758856000148
                ],
                [
                  -6.934641079999949,
                  58.052313544000143
                ],
                [
                  -7.028716600999871,
                  58.038397528000175
                ],
                [
                  -7.058216925999943,
                  58.038641669000029
                ],
                [
                  -7.053618943999908,
                  58.047796942
                ],
                [
                  -7.045765753999916,
                  58.052639065000093
                ],
                [
                  -7.035552537999905,
                  58.053900458
                ],
                [
                  -7.024037238999938,
                  58.052313544000143
                ],
                [
                  -7.024037238999938,
                  58.058539130000113
                ],
                [
                  -7.051909959999904,
                  58.058539130000113
                ],
                [
                  -7.042795376999919,
                  58.061835028000147
                ],
                [
                  -7.035023566999911,
                  58.066351630000028
                ],
                [
                  -7.028716600999871,
                  58.072211005000057
                ],
                [
                  -7.024037238999938,
                  58.079575914000046
                ],
                [
                  -7.067494269999912,
                  58.06273021000014
                ],
                [
                  -7.075550910999937,
                  58.062241929000052
                ],
                [
                  -7.104888475999928,
                  58.094794012000122
                ],
                [
                  -7.112782355999912,
                  58.100083726000022
                ],
                [
                  -7.107533331999917,
                  58.112005927000141
                ],
                [
                  -7.113189256999931,
                  58.116400458000115
                ],
                [
                  -7.121937628999888,
                  58.118597723000036
                ],
                [
                  -7.126454230999855,
                  58.123968817000062
                ],
                [
                  -7.123402472999942,
                  58.136664130000142
                ],
                [
                  -7.112131313999953,
                  58.145453192
                ],
                [
                  -7.112782355999912,
                  58.155340887000122
                ],
                [
                  -7.104156053999901,
                  58.157049872000115
                ],
                [
                  -7.100168423999946,
                  58.159409898000078
                ],
                [
                  -7.097645636999914,
                  58.163031317000119
                ],
                [
                  -7.093006964999887,
                  58.168402411
                ],
                [
                  -7.10024980399993,
                  58.170111395
                ],
                [
                  -7.107411261999857,
                  58.174139716000141
                ],
                [
                  -7.112782355999912,
                  58.175848700000145
                ],
                [
                  -7.112782355999912,
                  58.182033596000124
                ],
                [
                  -7.037709113999881,
                  58.184637762000037
                ],
                [
                  -7.017201300999943,
                  58.189439195000105
                ],
                [
                  -7.04344641799986,
                  58.195949611000017
                ],
                [
                  -7.053944464999944,
                  58.201361395000063
                ],
                [
                  -7.058216925999943,
                  58.213364975999987
                ],
                [
                  -7.056060350999928,
                  58.225653387000037
                ],
                [
                  -7.050160285999908,
                  58.232367255
                ],
                [
                  -7.030873175999886,
                  58.244696356000034
                ],
                [
                  -7.016102667999888,
                  58.238592841000141
                ],
                [
                  -6.977284308999884,
                  58.227362372000144
                ],
                [
                  -6.969471808999884,
                  58.226752020000092
                ],
                [
                  -6.962025519999912,
                  58.230169989
                ],
                [
                  -6.907338019999969,
                  58.21678294499999
                ],
                [
                  -6.907338019999969,
                  58.209947007000082
                ],
                [
                  -6.937082485999895,
                  58.211004950000031
                ],
                [
                  -6.930409308999913,
                  58.196844794000114
                ],
                [
                  -6.909657355999912,
                  58.179754950000145
                ],
                [
                  -6.897084113999938,
                  58.17210521000014
                ],
                [
                  -6.898345506999931,
                  58.156724350999987
                ],
                [
                  -6.888050910999937,
                  58.135891018
                ],
                [
                  -6.872873501999948,
                  58.116888739000032
                ],
                [
                  -6.85960852799991,
                  58.106878973000121
                ],
                [
                  -6.861439581999889,
                  58.115871486000131
                ],
                [
                  -6.86188717399989,
                  58.12140534100017
                ],
                [
                  -6.85960852799991,
                  58.134833075000145
                ],
                [
                  -6.8666072259999,
                  58.141180731000091
                ],
                [
                  -6.881581183999913,
                  58.158636786000145
                ],
                [
                  -6.887521938999953,
                  58.168402411
                ],
                [
                  -6.877512173999946,
                  58.172186591000113
                ],
                [
                  -6.873931443999908,
                  58.179388739000146
                ],
                [
                  -6.872670050999886,
                  58.18634674700003
                ],
                [
                  -6.869496222999914,
                  58.189439195000105
                ],
                [
                  -6.825062628999916,
                  58.195379950000145
                ],
                [
                  -6.815174933999884,
                  58.199693101000051
                ],
                [
                  -6.798451300999943,
                  58.202378648000135
                ],
                [
                  -6.772572394999941,
                  58.19550202000012
                ],
                [
                  -6.748524542999917,
                  58.182928778000033
                ],
                [
                  -6.736683722999942,
                  58.168402411
                ],
                [
                  -6.709380662999877,
                  58.189439195000105
                ],
                [
                  -6.734364386999886,
                  58.197699286000031
                ],
                [
                  -6.742909308999913,
                  58.203111070000048
                ],
                [
                  -6.746815558999913,
                  58.20921458500014
                ],
                [
                  -6.752552863999881,
                  58.22479889500012
                ],
                [
                  -6.757191535999908,
                  58.230414130000142
                ],
                [
                  -6.763050910999937,
                  58.23167552300005
                ],
                [
                  -6.777821417999945,
                  58.229478257000054
                ],
                [
                  -6.78384355399993,
                  58.230414130000142
                ],
                [
                  -6.785715298999918,
                  58.232977606000063
                ],
                [
                  -6.789540167999917,
                  58.242010809000149
                ],
                [
                  -6.791249152999939,
                  58.244696356000034
                ],
                [
                  -6.802723761999886,
                  58.253729559000035
                ],
                [
                  -6.807687954999921,
                  58.258693752000099
                ],
                [
                  -6.811838344999956,
                  58.264593817000119
                ],
                [
                  -6.806752081999946,
                  58.26654694200009
                ],
                [
                  -6.802723761999886,
                  58.268988348
                ],
                [
                  -6.798003709999875,
                  58.270982164000046
                ],
                [
                  -6.791249152999939,
                  58.27138906500015
                ],
                [
                  -6.796457485999923,
                  58.278631903000175
                ],
                [
                  -6.801177537999934,
                  58.2833519550001
                ],
                [
                  -6.807728644999912,
                  58.285467841000084
                ],
                [
                  -6.81859290299991,
                  58.285101630000085
                ],
                [
                  -6.736968553999901,
                  58.323635158000158
                ],
                [
                  -6.715565558999856,
                  58.339667059000149
                ],
                [
                  -6.703358527999882,
                  58.335882880000113
                ],
                [
                  -6.695952928999873,
                  58.338446356000034
                ],
                [
                  -6.689686652999853,
                  58.343329169000114
                ],
                [
                  -6.681385870999861,
                  58.346502997000172
                ],
                [
                  -6.647328253999945,
                  58.346502997000172
                ],
                [
                  -6.620676235999895,
                  58.350734768000095
                ],
                [
                  -6.557484503999916,
                  58.368557033000073
                ],
                [
                  -6.548491990999906,
                  58.372788804
                ],
                [
                  -6.523345506999931,
                  58.390773830000128
                ],
                [
                  -6.345611131999874,
                  58.46320221600017
                ],
                [
                  -6.296294725999871,
                  58.497259833000086
                ],
                [
                  -6.267404751999948,
                  58.51203034100017
                ],
                [
                  -6.243234829999949,
                  58.510972398000106
                ],
                [
                  -6.223052537999934,
                  58.499212958000115
                ],
                [
                  -6.205393032999922,
                  58.481268622000087
                ],
                [
                  -6.192738410999937,
                  58.462062893000123
                ],
                [
                  -6.18797766799986,
                  58.44611237200003
                ],
                [
                  -6.169992641999897,
                  58.429999091000141
                ],
                [
                  -6.166859503999916,
                  58.419501044000171
                ],
                [
                  -6.184925910999937,
                  58.414780992000075
                ],
                [
                  -6.192372199999909,
                  58.40912506700009
                ],
                [
                  -6.215321417999917,
                  58.367621161000088
                ],
                [
                  -6.206898566999968,
                  58.361151434000178
                ],
                [
                  -6.195546027999882,
                  58.356268622000115
                ]
              ]
            ],
            [
              [
                [
                  -3.34788977799991,
                  58.652044989000061
                ],
                [
                  -3.340565558999913,
                  58.648138739000061
                ],
                [
                  -3.309885219999899,
                  58.648138739000061
                ],
                [
                  -3.244252081999889,
                  58.659002997000144
                ],
                [
                  -3.20409094999988,
                  58.661118882000054
                ],
                [
                  -3.151926235999952,
                  58.64126211100016
                ],
                [
                  -3.118763800999915,
                  58.641099350999987
                ],
                [
                  -3.05288652299987,
                  58.648138739000061
                ],
                [
                  -3.019113735999895,
                  58.640326239000089
                ],
                [
                  -3.025380011999857,
                  58.622137762000179
                ],
                [
                  -3.044422980999855,
                  58.601629950000031
                ],
                [
                  -3.049183722999942,
                  58.586737372000172
                ],
                [
                  -3.060454881999931,
                  58.578436591000084
                ],
                [
                  -3.075428839999859,
                  58.560370184000178
                ],
                [
                  -3.084543423999946,
                  58.551947333000115
                ],
                [
                  -3.1107478509999,
                  58.538641669000114
                ],
                [
                  -3.118031378999888,
                  58.53204987200003
                ],
                [
                  -3.129261847999914,
                  58.512640692000119
                ],
                [
                  -3.129302537999905,
                  58.496405341000084
                ],
                [
                  -3.118723110999923,
                  58.484442450000145
                ],
                [
                  -3.097523566999939,
                  58.477484442000062
                ],
                [
                  -3.085072394999912,
                  58.478257554
                ],
                [
                  -3.07396399599989,
                  58.48167552299999
                ],
                [
                  -3.064442511999914,
                  58.482977606000091
                ],
                [
                  -3.056630011999914,
                  58.477484442000062
                ],
                [
                  -3.053334113999881,
                  58.465765692000062
                ],
                [
                  -3.057728644999941,
                  58.456854559000035
                ],
                [
                  -3.06676184799997,
                  58.451157945000048
                ],
                [
                  -3.077056443999879,
                  58.449530341000028
                ],
                [
                  -3.086333787999934,
                  58.414211330000015
                ],
                [
                  -3.129790818999879,
                  58.3692894550001
                ],
                [
                  -3.182769334999904,
                  58.328436591000141
                ],
                [
                  -3.220529751999891,
                  58.305568752000127
                ],
                [
                  -3.262277798999918,
                  58.292629299000126
                ],
                [
                  -3.349842902999853,
                  58.276109117000075
                ],
                [
                  -3.38499915299991,
                  58.264593817000119
                ],
                [
                  -3.438099738999938,
                  58.236029364000146
                ],
                [
                  -3.447010870999861,
                  58.226752020000092
                ],
                [
                  -3.454741990999878,
                  58.210150458000115
                ],
                [
                  -3.473459438999953,
                  58.193426825000088
                ],
                [
                  -3.515288865999878,
                  58.168402411
                ],
                [
                  -3.735015428999901,
                  58.072170315000065
                ],
                [
                  -3.809193488999938,
                  58.051906643000152
                ],
                [
                  -3.827504035999908,
                  58.042059637000037
                ],
                [
                  -3.836252407999893,
                  58.031439520000092
                ],
                [
                  -3.846099412999905,
                  58.011175848000065
                ],
                [
                  -3.851714647999899,
                  58.003892320000077
                ],
                [
                  -3.860585089999859,
                  57.998928127000013
                ],
                [
                  -3.885609503999945,
                  57.991400458000058
                ],
                [
                  -3.917307094999927,
                  57.987453518000066
                ],
                [
                  -3.98143469999988,
                  57.963568427
                ],
                [
                  -3.990956183999884,
                  57.960394598000121
                ],
                [
                  -3.997670050999915,
                  57.954413153000118
                ],
                [
                  -4.001372850999871,
                  57.94611237200003
                ],
                [
                  -4.001942511999857,
                  57.935614325000145
                ],
                [
                  -4.018299933999856,
                  57.940619208
                ],
                [
                  -4.023060675999943,
                  57.943060614000146
                ],
                [
                  -4.016184048999946,
                  57.949286200000088
                ],
                [
                  -4.030140753999916,
                  57.953192450000088
                ],
                [
                  -4.055775519999884,
                  57.954982815000093
                ],
                [
                  -4.084380662999877,
                  57.964178778000147
                ],
                [
                  -4.089100714999887,
                  57.960150458000086
                ],
                [
                  -4.086333787999905,
                  57.951890367000019
                ],
                [
                  -4.077626105999912,
                  57.943060614000146
                ],
                [
                  -4.062652147999899,
                  57.93695709800015
                ],
                [
                  -4.03148352799991,
                  57.936183986000131
                ],
                [
                  -4.016184048999946,
                  57.932196356000148
                ],
                [
                  -4.009429490999906,
                  57.927679755
                ],
                [
                  -3.988270636999914,
                  57.908270575000088
                ],
                [
                  -4.008941209999932,
                  57.889593817000033
                ],
                [
                  -4.013824022999899,
                  57.879339911000088
                ],
                [
                  -4.009348110999923,
                  57.867905992000132
                ],
                [
                  -4.02513587099989,
                  57.868068752000099
                ],
                [
                  -4.054839647999899,
                  57.874335028000061
                ],
                [
                  -4.070220506999931,
                  57.874172268000095
                ],
                [
                  -4.079335089999916,
                  57.870266018000095
                ],
                [
                  -4.096913214999859,
                  57.857367255000085
                ],
                [
                  -4.104969855999912,
                  57.85370514500012
                ],
                [
                  -4.132923956999917,
                  57.854152736000017
                ],
                [
                  -4.190419074999909,
                  57.870062567000119
                ],
                [
                  -4.2181697259999,
                  57.874172268000095
                ],
                [
                  -4.298898891999926,
                  57.862779039000102
                ],
                [
                  -4.320952928999901,
                  57.871039130000028
                ],
                [
                  -4.353179490999963,
                  57.895209052000112
                ],
                [
                  -4.372303839999916,
                  57.904486395000063
                ],
                [
                  -4.392404751999891,
                  57.908270575000088
                ],
                [
                  -4.33958899599989,
                  57.865708726000136
                ],
                [
                  -4.307728644999884,
                  57.851467190000122
                ],
                [
                  -4.269398566999939,
                  57.846869208
                ],
                [
                  -4.22907467399989,
                  57.857245184000092
                ],
                [
                  -4.208241339999887,
                  57.859198309000064
                ],
                [
                  -4.190581834999875,
                  57.850287177000112
                ],
                [
                  -4.173451300999943,
                  57.839016018000038
                ],
                [
                  -4.149728969999927,
                  57.829820054000052
                ],
                [
                  -4.133452928999901,
                  57.830145575000174
                ],
                [
                  -4.139068162999905,
                  57.846869208
                ],
                [
                  -4.075062628999916,
                  57.82318756700009
                ],
                [
                  -4.039906378999945,
                  57.818182684000035
                ],
                [
                  -3.983509894999912,
                  57.842352606000063
                ],
                [
                  -3.951486782999922,
                  57.838324286000088
                ],
                [
                  -3.933705206999917,
                  57.825669664000102
                ],
                [
                  -3.947336391999983,
                  57.81268952
                ],
                [
                  -3.914784308999913,
                  57.80768463700015
                ],
                [
                  -3.877674933999913,
                  57.81671784100017
                ],
                [
                  -3.841867641999897,
                  57.834906317000062
                ],
                [
                  -3.813547329999949,
                  57.857123114000117
                ],
                [
                  -3.798451300999943,
                  57.866522528000147
                ],
                [
                  -3.786040818999908,
                  57.865423895
                ],
                [
                  -3.779449022999927,
                  57.855658270000063
                ],
                [
                  -3.78221594999988,
                  57.839422919000029
                ],
                [
                  -3.79002844999988,
                  57.830715236000131
                ],
                [
                  -3.92601477799991,
                  57.734808661000116
                ],
                [
                  -3.948841925999915,
                  57.724920966000028
                ],
                [
                  -3.975209113999938,
                  57.703273830000128
                ],
                [
                  -3.988270636999914,
                  57.695990302000112
                ],
                [
                  -4.008046027999939,
                  57.693793036000116
                ],
                [
                  -4.02367102799991,
                  57.697821356000091
                ],
                [
                  -4.028635219999956,
                  57.707709052000027
                ],
                [
                  -4.016184048999946,
                  57.723334052
                ],
                [
                  -4.042958136999857,
                  57.737290757000054
                ],
                [
                  -4.077951626999948,
                  57.730292059000178
                ],
                [
                  -4.155344204999949,
                  57.69257233300003
                ],
                [
                  -4.168568488999881,
                  57.689439195000134
                ],
                [
                  -4.193999803999901,
                  57.688544012000037
                ],
                [
                  -4.259266730999883,
                  57.67869700700011
                ],
                [
                  -4.277821417999888,
                  57.68060944200009
                ],
                [
                  -4.294789191999882,
                  57.680161850999987
                ],
                [
                  -4.302154100999871,
                  57.66860586100016
                ],
                [
                  -4.30882727799991,
                  57.654852606000034
                ],
                [
                  -4.324045376999891,
                  57.648260809000149
                ],
                [
                  -4.338205532999922,
                  57.645086981000091
                ],
                [
                  -4.403187628999888,
                  57.609523830000128
                ],
                [
                  -4.412180141999897,
                  57.60297272300015
                ],
                [
                  -4.420318162999905,
                  57.592962958000058
                ],
                [
                  -4.428456183999856,
                  57.57754140800013
                ],
                [
                  -4.423451300999886,
                  57.576808986000103
                ],
                [
                  -4.409901495999918,
                  57.582464911
                ],
                [
                  -4.37987219999988,
                  57.589341539000102
                ],
                [
                  -4.365101691999911,
                  57.597235419000171
                ],
                [
                  -4.351063605999855,
                  57.607367255000113
                ],
                [
                  -4.340809699999909,
                  57.617173570000048
                ],
                [
                  -4.32872473899991,
                  57.626288153000147
                ],
                [
                  -4.283111131999874,
                  57.641424872000144
                ],
                [
                  -4.244536912999905,
                  57.663031317000147
                ],
                [
                  -4.201893683999884,
                  57.674994208000086
                ],
                [
                  -4.193755662999934,
                  57.675523179000052
                ],
                [
                  -4.18224036399991,
                  57.67279694200009
                ],
                [
                  -4.169016079999892,
                  57.663763739000089
                ],
                [
                  -4.118723110999923,
                  57.657700913999989
                ],
                [
                  -4.096791144999884,
                  57.658107815000093
                ],
                [
                  -4.080718553999901,
                  57.664984442
                ],
                [
                  -4.068104620999918,
                  57.672308661
                ],
                [
                  -4.024647589999887,
                  57.687201239000146
                ],
                [
                  -4.009348110999923,
                  57.688544012000037
                ],
                [
                  -4.004505988999938,
                  57.675970770000148
                ],
                [
                  -4.025257941999939,
                  57.655218817000147
                ],
                [
                  -4.054188605999855,
                  57.635728257000054
                ],
                [
                  -4.0834041009999,
                  57.623358466000028
                ],
                [
                  -4.118560350999871,
                  57.592962958000058
                ],
                [
                  -4.115467902999882,
                  57.587836005000142
                ],
                [
                  -4.112294074999909,
                  57.584133205000015
                ],
                [
                  -4.108876105999883,
                  57.581447658000044
                ],
                [
                  -4.104969855999912,
                  57.579291083000115
                ],
                [
                  -4.15135657499988,
                  57.576849677
                ],
                [
                  -4.170643683999913,
                  57.570746161
                ],
                [
                  -4.187489386999914,
                  57.558823960000055
                ],
                [
                  -4.178089972999885,
                  57.549546617000104
                ],
                [
                  -4.184925910999908,
                  57.548163153000033
                ],
                [
                  -4.207997199999852,
                  57.552069403000033
                ],
                [
                  -4.262603318999908,
                  57.552069403000033
                ],
                [
                  -4.262603318999908,
                  57.544582424000154
                ],
                [
                  -4.233957485999952,
                  57.54511139500012
                ],
                [
                  -4.220285610999923,
                  57.543402411000116
                ],
                [
                  -4.207997199999852,
                  57.53839752800009
                ],
                [
                  -4.226307745999918,
                  57.515448309000092
                ],
                [
                  -4.237456834999932,
                  57.50531647300015
                ],
                [
                  -4.248931443999879,
                  57.497463283000158
                ],
                [
                  -4.212798631999931,
                  57.49217357
                ],
                [
                  -4.194813605999912,
                  57.491603908000016
                ],
                [
                  -4.173898891999954,
                  57.497463283000158
                ],
                [
                  -4.1576228509999,
                  57.508490302000112
                ],
                [
                  -4.150054490999878,
                  57.515041408000101
                ],
                [
                  -4.149322068999936,
                  57.517889716000028
                ],
                [
                  -4.126779751999948,
                  57.518866278000118
                ],
                [
                  -4.116200324999909,
                  57.521795966000028
                ],
                [
                  -4.097523566999911,
                  57.536688544000086
                ],
                [
                  -4.08299719999988,
                  57.544419664000017
                ],
                [
                  -4.067290818999908,
                  57.549953518
                ],
                [
                  -4.053130662999905,
                  57.552069403000033
                ],
                [
                  -4.034982876999891,
                  57.556870835000112
                ],
                [
                  -4.046457485999923,
                  57.567857164000074
                ],
                [
                  -4.083851691999882,
                  57.586127020000148
                ],
                [
                  -4.056019660999937,
                  57.585150458000058
                ],
                [
                  -3.964344855999855,
                  57.592962958000058
                ],
                [
                  -3.868275519999884,
                  57.587876695000134
                ],
                [
                  -3.837473110999895,
                  57.592962958000058
                ],
                [
                  -3.684803839999944,
                  57.654445705000128
                ],
                [
                  -3.625152147999927,
                  57.661932684000092
                ],
                [
                  -3.632557745999918,
                  57.650946356000034
                ],
                [
                  -3.637684699999852,
                  57.646226304000137
                ],
                [
                  -3.645619269999912,
                  57.641424872000144
                ],
                [
                  -3.632476365999935,
                  57.63564687700007
                ],
                [
                  -3.619618292999917,
                  57.636216539000046
                ],
                [
                  -3.606068488999938,
                  57.639471747000087
                ],
                [
                  -3.590972459999932,
                  57.641424872000144
                ],
                [
                  -3.611561652999882,
                  57.668117580000072
                ],
                [
                  -3.57477779899989,
                  57.661118882
                ],
                [
                  -3.554921027999882,
                  57.659857489000089
                ],
                [
                  -3.535755988999938,
                  57.661932684000092
                ],
                [
                  -3.521473761999943,
                  57.667792059000035
                ],
                [
                  -3.505441860999952,
                  57.678656317000119
                ],
                [
                  -3.495961066999939,
                  57.69135163
                ],
                [
                  -3.501698370999918,
                  57.702826239000117
                ],
                [
                  -3.491851365999878,
                  57.713120835000055
                ],
                [
                  -3.482818162999877,
                  57.714016018000152
                ],
                [
                  -3.473052537999934,
                  57.71100495000006
                ],
                [
                  -3.46068274599989,
                  57.709662177000055
                ],
                [
                  -3.447865363999881,
                  57.712469794000114
                ],
                [
                  -3.421254035999937,
                  57.721380927000141
                ],
                [
                  -3.409169074999909,
                  57.723334052
                ],
                [
                  -3.284738735999923,
                  57.720445054000052
                ],
                [
                  -3.210072394999912,
                  57.693996486000074
                ],
                [
                  -3.078684048999918,
                  57.669419664000074
                ],
                [
                  -3.034901495999947,
                  57.66860586100016
                ],
                [
                  -2.994496222999885,
                  57.675523179000052
                ],
                [
                  -2.932687954999892,
                  57.699611721000068
                ],
                [
                  -2.916086391999926,
                  57.702826239000117
                ],
                [
                  -2.75804602799991,
                  57.702826239000117
                ],
                [
                  -2.751210089999887,
                  57.70062897300015
                ],
                [
                  -2.741118943999936,
                  57.690863348
                ],
                [
                  -2.731068488999938,
                  57.688544012000037
                ],
                [
                  -2.719878709999932,
                  57.690619208000058
                ],
                [
                  -2.711537238999881,
                  57.693996486000074
                ],
                [
                  -2.703521287999934,
                  57.694728908000016
                ],
                [
                  -2.69294186099998,
                  57.688544012000037
                ],
                [
                  -2.658924933999856,
                  57.697455145000092
                ],
                [
                  -2.573394334999932,
                  57.681463934000178
                ],
                [
                  -2.541981574999909,
                  57.682359117000075
                ],
                [
                  -2.526112433999884,
                  57.66860586100016
                ],
                [
                  -2.518137173999918,
                  57.670111395
                ],
                [
                  -2.511057094999956,
                  57.677801825000031
                ],
                [
                  -2.497954881999903,
                  57.682359117000075
                ],
                [
                  -2.480051235999952,
                  57.681219794000029
                ],
                [
                  -2.432850714999859,
                  57.668117580000072
                ],
                [
                  -2.425526495999861,
                  57.675726630000028
                ],
                [
                  -2.417795376999948,
                  57.674261786000145
                ],
                [
                  -2.408762173999946,
                  57.669623114000117
                ],
                [
                  -2.398060675999915,
                  57.668117580000072
                ],
                [
                  -2.386586066999882,
                  57.671576239000061
                ],
                [
                  -2.369496222999914,
                  57.680568752000099
                ],
                [
                  -2.360503709999904,
                  57.682359117000075
                ],
                [
                  -2.341053839999916,
                  57.675848700000174
                ],
                [
                  -2.328968878999916,
                  57.674058335
                ],
                [
                  -2.323597785999937,
                  57.678941148000078
                ],
                [
                  -2.320546027999853,
                  57.684556382000054
                ],
                [
                  -2.313384568999908,
                  57.689927476000108
                ],
                [
                  -2.30406653599988,
                  57.693996486000074
                ],
                [
                  -2.295643683999913,
                  57.695990302000112
                ],
                [
                  -2.274322068999936,
                  57.693833726000108
                ],
                [
                  -2.230132615999878,
                  57.679144598000036
                ],
                [
                  -2.209950324999852,
                  57.675523179000052
                ],
                [
                  -2.18407141799986,
                  57.67845286699999
                ],
                [
                  -2.124338344999956,
                  57.702826239000117
                ],
                [
                  -2.108143683999913,
                  57.704982815000122
                ],
                [
                  -1.997670050999886,
                  57.702826239000117
                ],
                [
                  -1.996937628999945,
                  57.699042059000121
                ],
                [
                  -1.990834113999966,
                  57.690375067000119
                ],
                [
                  -1.982167120999861,
                  57.681097723000065
                ],
                [
                  -1.973500128999888,
                  57.675523179000052
                ],
                [
                  -1.961293097999885,
                  57.674709377000127
                ],
                [
                  -1.944732225999928,
                  57.682562567000119
                ],
                [
                  -1.932484503999945,
                  57.682359117000075
                ],
                [
                  -1.925689256999931,
                  57.678168036000145
                ],
                [
                  -1.914214647999899,
                  57.664740302000055
                ],
                [
                  -1.829457160999908,
                  57.613470770000035
                ],
                [
                  -1.820464647999899,
                  57.596340236000074
                ],
                [
                  -1.817005988999881,
                  57.578192450000174
                ],
                [
                  -1.811390753999888,
                  57.560492255000085
                ],
                [
                  -1.796009894999941,
                  57.544582424000154
                ],
                [
                  -1.796009894999941,
                  57.53839752800009
                ],
                [
                  -1.800038214999916,
                  57.525864975999987
                ],
                [
                  -1.78954016799986,
                  57.514837958000143
                ],
                [
                  -1.761138475999928,
                  57.497463283000158
                ],
                [
                  -1.775380011999914,
                  57.496527411000088
                ],
                [
                  -1.782134568999965,
                  57.488999742000104
                ],
                [
                  -1.781239386999857,
                  57.480414130000028
                ],
                [
                  -1.771717902999882,
                  57.476263739000061
                ],
                [
                  -1.759348110999923,
                  57.47357819200009
                ],
                [
                  -1.765939907999893,
                  57.467433986000017
                ],
                [
                  -1.789173956999917,
                  57.456447658000158
                ],
                [
                  -1.830148891999954,
                  57.426174221000153
                ],
                [
                  -1.847482876999919,
                  57.408148505000113
                ],
                [
                  -1.849964972999942,
                  57.394354559000121
                ],
                [
                  -1.954497850999871,
                  57.341131903000033
                ],
                [
                  -1.980295376999891,
                  57.319281317
                ],
                [
                  -2.04466712099989,
                  57.226507880000057
                ],
                [
                  -2.068511522999899,
                  57.174627997000172
                ],
                [
                  -2.074126756999874,
                  57.154201565
                ],
                [
                  -2.071400519999912,
                  57.135565497000115
                ],
                [
                  -2.052357550999915,
                  57.127427475999987
                ],
                [
                  -2.049305792999917,
                  57.118841864000089
                ],
                [
                  -2.065256313999925,
                  57.100531317000119
                ],
                [
                  -2.0658259759999,
                  57.099839585000083
                ],
                [
                  -2.156158006999903,
                  57.020697333
                ],
                [
                  -2.186919725999871,
                  56.984686591000028
                ],
                [
                  -2.200103318999936,
                  56.948716539000046
                ],
                [
                  -2.197132941999911,
                  56.940252997000115
                ],
                [
                  -2.191232876999891,
                  56.934149481000034
                ],
                [
                  -2.186268683999941,
                  56.926743882000139
                ],
                [
                  -2.186390753999916,
                  56.914536851000079
                ],
                [
                  -2.191314256999874,
                  56.908921617000075
                ],
                [
                  -2.209706183999913,
                  56.89581940300009
                ],
                [
                  -2.213693813999896,
                  56.890692450000174
                ],
                [
                  -2.219878709999961,
                  56.872626044000143
                ],
                [
                  -2.234608527999853,
                  56.861395575000145
                ],
                [
                  -2.2689509759999,
                  56.846340236000131
                ],
                [
                  -2.295806443999879,
                  56.825262762000122
                ],
                [
                  -2.319813605999912,
                  56.801581122000115
                ],
                [
                  -2.33608964799987,
                  56.790838934000092
                ],
                [
                  -2.391835089999859,
                  56.771185614000146
                ],
                [
                  -2.40868079299986,
                  56.76292552300005
                ],
                [
                  -2.426421678999873,
                  56.751288153000061
                ],
                [
                  -2.435943162999934,
                  56.740383205000072
                ],
                [
                  -2.440744594999927,
                  56.734849351000051
                ],
                [
                  -2.451649542999917,
                  56.690985419000086
                ],
                [
                  -2.463734503999916,
                  56.678778387000122
                ],
                [
                  -2.477406378999945,
                  56.668687242000075
                ],
                [
                  -2.487456834999932,
                  56.653876044000086
                ],
                [
                  -2.487538214999916,
                  56.646063544000086
                ],
                [
                  -2.481271938999953,
                  56.632391669000143
                ],
                [
                  -2.480620897999899,
                  56.626532294000114
                ],
                [
                  -2.486195441999911,
                  56.619574286000116
                ],
                [
                  -2.504058397999899,
                  56.608832098
                ],
                [
                  -2.514556443999965,
                  56.591498114000117
                ],
                [
                  -2.530018683999884,
                  56.580755927000112
                ],
                [
                  -2.623768683999884,
                  56.543402411000059
                ],
                [
                  -2.640939907999922,
                  56.522365627000042
                ],
                [
                  -2.661366339999887,
                  56.514227606000091
                ],
                [
                  -2.69977779899989,
                  56.503648179000052
                ],
                [
                  -2.708729620999918,
                  56.495998440000122
                ],
                [
                  -2.727650519999941,
                  56.469549872000144
                ],
                [
                  -2.737294074999909,
                  56.467027085000112
                ],
                [
                  -2.744374152999882,
                  56.469549872000144
                ],
                [
                  -2.752308722999942,
                  56.473618882000025
                ],
                [
                  -2.764800584999932,
                  56.475734768
                ],
                [
                  -2.819325324999937,
                  56.471299546000139
                ],
                [
                  -3.055653449999852,
                  56.452134507000082
                ],
                [
                  -3.060617641999897,
                  56.451727606000148
                ],
                [
                  -3.099273240999935,
                  56.441880601000051
                ],
                [
                  -3.133900519999912,
                  56.426947333
                ],
                [
                  -3.238189256999903,
                  56.367743231000091
                ],
                [
                  -3.280181443999879,
                  56.357896225999987
                ],
                [
                  -3.323475714999859,
                  56.365912177000112
                ],
                [
                  -3.311512824999909,
                  56.356512762000094
                ],
                [
                  -3.294016079999977,
                  56.352769273000078
                ],
                [
                  -3.251535610999895,
                  56.352850653000147
                ],
                [
                  -3.230620897999927,
                  56.356024481000119
                ],
                [
                  -3.188384568999908,
                  56.370184637000037
                ],
                [
                  -3.149566209999904,
                  56.375555731000091
                ],
                [
                  -2.950266079999921,
                  56.431870835000055
                ],
                [
                  -2.939930792999917,
                  56.438544012000122
                ],
                [
                  -2.93065344999988,
                  56.448065497000115
                ],
                [
                  -2.909087693999936,
                  56.455715236000131
                ],
                [
                  -2.884999152999939,
                  56.45799388200011
                ],
                [
                  -2.867909308999884,
                  56.451849677000141
                ],
                [
                  -2.850087042999917,
                  56.442043361000017
                ],
                [
                  -2.814768032999893,
                  56.440415757
                ],
                [
                  -2.802805141999954,
                  56.427964585000083
                ],
                [
                  -2.800892706999889,
                  56.40892161699999
                ],
                [
                  -2.808257615999878,
                  56.391058661000031
                ],
                [
                  -2.821603969999899,
                  56.376166083000058
                ],
                [
                  -2.837554490999906,
                  56.365912177000112
                ],
                [
                  -2.812977667999888,
                  56.365912177000112
                ],
                [
                  -2.809193488999881,
                  56.362860419000029
                ],
                [
                  -2.804758266999897,
                  56.349107164000102
                ],
                [
                  -2.802805141999954,
                  56.345404364000089
                ],
                [
                  -2.79149329299986,
                  56.342474677000055
                ],
                [
                  -2.782622850999928,
                  56.341620184000149
                ],
                [
                  -2.775257941999911,
                  56.339422919000143
                ],
                [
                  -2.768625454999949,
                  56.332342841000084
                ],
                [
                  -2.677154100999928,
                  56.328436591000113
                ],
                [
                  -2.655262824999909,
                  56.32217031500015
                ],
                [
                  -2.621205206999889,
                  56.304429429000052
                ],
                [
                  -2.613189256999931,
                  56.301906643000123
                ],
                [
                  -2.576812303999958,
                  56.283921617000104
                ],
                [
                  -2.576812303999958,
                  56.277777411000116
                ],
                [
                  -2.630116339999916,
                  56.248521225999987
                ],
                [
                  -2.648345506999903,
                  56.228705145000092
                ],
                [
                  -2.672027147999927,
                  56.222398179000137
                ],
                [
                  -2.720204230999883,
                  56.216294664000046
                ],
                [
                  -2.783599412999905,
                  56.191961981000176
                ],
                [
                  -2.806141730999883,
                  56.188381252000013
                ],
                [
                  -2.830718553999901,
                  56.190741278000147
                ],
                [
                  -2.892079230999883,
                  56.208889065000065
                ],
                [
                  -2.940052863999881,
                  56.209418036000145
                ],
                [
                  -2.964344855999883,
                  56.205633856000119
                ],
                [
                  -2.974680141999954,
                  56.198309637000122
                ],
                [
                  -2.982411261999886,
                  56.189113674000126
                ],
                [
                  -3.035552537999877,
                  56.167914130000057
                ],
                [
                  -3.091053839999859,
                  56.132269598
                ],
                [
                  -3.107533331999917,
                  56.126898505000142
                ],
                [
                  -3.12755286399991,
                  56.122870184000178
                ],
                [
                  -3.138295050999915,
                  56.112209377000127
                ],
                [
                  -3.152251756999874,
                  56.078517971000124
                ],
                [
                  -3.163563605999855,
                  56.06386953300013
                ],
                [
                  -3.17837480399993,
                  56.058091539000074
                ],
                [
                  -3.248443162999905,
                  56.055975653000147
                ],
                [
                  -3.268381313999896,
                  56.050930080000043
                ],
                [
                  -3.303049282999893,
                  56.037543036000116
                ],
                [
                  -3.342681443999908,
                  56.027167059000121
                ],
                [
                  -3.381825324999852,
                  56.02338288
                ],
                [
                  -3.420969204999892,
                  56.024888414000046
                ],
                [
                  -3.58259029899989,
                  56.051743882000139
                ],
                [
                  -3.671498175999915,
                  56.05084870000006
                ],
                [
                  -3.710031704999892,
                  56.058091539000074
                ],
                [
                  -3.745432094999899,
                  56.072211005
                ],
                [
                  -3.746490037999877,
                  56.072780666000156
                ],
                [
                  -3.78221594999988,
                  56.092189846000068
                ],
                [
                  -3.803130662999934,
                  56.107123114000117
                ],
                [
                  -3.817005988999938,
                  56.112250067000119
                ],
                [
                  -3.837473110999895,
                  56.112616278000147
                ],
                [
                  -3.837473110999895,
                  56.106431382000082
                ],
                [
                  -3.777699347999942,
                  56.082831122000059
                ],
                [
                  -3.769154425999915,
                  56.075140692000119
                ],
                [
                  -3.760853644999941,
                  56.072455145000148
                ],
                [
                  -3.726429816999911,
                  56.038031317
                ],
                [
                  -3.721424933999856,
                  56.030707098
                ],
                [
                  -3.71263587099989,
                  56.028998114
                ],
                [
                  -3.693470831999917,
                  56.03115469
                ],
                [
                  -3.686634894999912,
                  56.030707098
                ],
                [
                  -3.679554816999939,
                  56.025458075000117
                ],
                [
                  -3.674794074999852,
                  56.018703518000095
                ],
                [
                  -3.66828365799995,
                  56.01276276200015
                ],
                [
                  -3.656239386999857,
                  56.010199286000145
                ],
                [
                  -3.599720831999917,
                  56.017238674000041
                ],
                [
                  -3.577381964999887,
                  56.017035223000065
                ],
                [
                  -3.405425584999904,
                  55.989732163999989
                ],
                [
                  -3.358265753999916,
                  55.989732163999989
                ],
                [
                  -3.340891079999921,
                  55.994452216000084
                ],
                [
                  -3.331044074999909,
                  55.994086005000085
                ],
                [
                  -3.320423956999946,
                  55.986029364000146
                ],
                [
                  -3.303456183999884,
                  55.977606512000094
                ],
                [
                  -3.121815558999913,
                  55.969305731000119
                ],
                [
                  -3.114735480999855,
                  55.966131903000147
                ],
                [
                  -3.096831834999904,
                  55.95197174700003
                ],
                [
                  -3.090728318999908,
                  55.948187567
                ],
                [
                  -3.078236456999917,
                  55.946844794000114
                ],
                [
                  -3.015695766999897,
                  55.950506903000147
                ],
                [
                  -2.939930792999917,
                  55.969305731000119
                ],
                [
                  -2.916656053999901,
                  55.9806175800001
                ],
                [
                  -2.900054490999935,
                  55.996161200000088
                ],
                [
                  -2.882883266999926,
                  56.008490302000141
                ],
                [
                  -2.85798092399989,
                  56.010199286000145
                ],
                [
                  -2.863636847999885,
                  56.022284247000144
                ],
                [
                  -2.866322394999941,
                  56.026760158000016
                ],
                [
                  -2.870961066999882,
                  56.030707098
                ],
                [
                  -2.852772589999887,
                  56.039780992000104
                ],
                [
                  -2.823150193999936,
                  56.059759833000086
                ],
                [
                  -2.802805141999954,
                  56.064846096000011
                ],
                [
                  -2.635121222999942,
                  56.058050848000065
                ],
                [
                  -2.615956183999884,
                  56.053168036
                ],
                [
                  -2.587554490999878,
                  56.030951239000146
                ],
                [
                  -2.569406704999949,
                  56.024481512000037
                ],
                [
                  -2.578358527999882,
                  56.008002020000063
                ],
                [
                  -2.583648240999878,
                  56.002752997000172
                ],
                [
                  -2.569569464999916,
                  55.999945380000113
                ],
                [
                  -2.544056769999941,
                  56.00267161699999
                ],
                [
                  -2.528960740999935,
                  55.996568101000108
                ],
                [
                  -2.5248103509999,
                  56.000555731000176
                ],
                [
                  -2.514556443999965,
                  56.005764065000065
                ],
                [
                  -2.507923956999889,
                  56.010199286000145
                ],
                [
                  -2.493275519999884,
                  56.001532294000143
                ],
                [
                  -2.452504035999908,
                  55.985256252000042
                ],
                [
                  -2.41437740799995,
                  55.978338934000121
                ],
                [
                  -2.350941535999908,
                  55.948187567
                ],
                [
                  -2.307769334999904,
                  55.93500397300015
                ],
                [
                  -2.146839972999942,
                  55.917303778000147
                ],
                [
                  -2.138010219999899,
                  55.914618231000148
                ],
                [
                  -2.132557745999861,
                  55.906439520000063
                ],
                [
                  -2.13109290299991,
                  55.897202867000104
                ],
                [
                  -2.128773566999939,
                  55.889797268
                ],
                [
                  -2.120961066999939,
                  55.886704820000134
                ],
                [
                  -2.099476691999911,
                  55.881781317000062
                ],
                [
                  -2.080189581999889,
                  55.86937083500014
                ],
                [
                  -2.022857225999957,
                  55.80548737200003
                ],
                [
                  -2.02285626077952,
                  55.805486299532944
                ],
                [
                  -2.009673631999903,
                  55.790838934000121
                ],
                [
                  -1.877837693999908,
                  55.694891669000029
                ],
                [
                  -1.863189256999903,
                  55.671616929000109
                ],
                [
                  -1.853098110999923,
                  55.659328518000152
                ],
                [
                  -1.831532355999912,
                  55.650702216000141
                ],
                [
                  -1.826079881999903,
                  55.643622137000179
                ],
                [
                  -1.8216853509999,
                  55.636419989000146
                ],
                [
                  -1.816477016999897,
                  55.632879950000174
                ],
                [
                  -1.807118292999888,
                  55.634507554
                ],
                [
                  -1.800770636999857,
                  55.639227606000091
                ],
                [
                  -1.796294725999871,
                  55.644232489000146
                ],
                [
                  -1.792591925999943,
                  55.646551825000117
                ],
                [
                  -1.781402147999927,
                  55.645656643
                ],
                [
                  -1.768625454999892,
                  55.641913153000175
                ],
                [
                  -1.756499803999901,
                  55.633612372000087
                ],
                [
                  -1.747670050999943,
                  55.619208075000031
                ],
                [
                  -1.767974412999934,
                  55.619208075000031
                ],
                [
                  -1.767974412999934,
                  55.612982489000089
                ],
                [
                  -1.755970831999917,
                  55.608872789000131
                ],
                [
                  -1.720855272999927,
                  55.614569403000118
                ],
                [
                  -1.699126756999874,
                  55.612982489000089
                ],
                [
                  -1.630848761999886,
                  55.585109768000123
                ],
                [
                  -1.630848761999886,
                  55.578273830000015
                ],
                [
                  -1.636341925999886,
                  55.57168203300013
                ],
                [
                  -1.634673631999874,
                  55.564398505000113
                ],
                [
                  -1.627674933999913,
                  55.557114976000108
                ],
                [
                  -1.617176886999943,
                  55.550279038999989
                ],
                [
                  -1.630848761999886,
                  55.54413483300003
                ],
                [
                  -1.630848761999886,
                  55.537298895000092
                ],
                [
                  -1.622222459999875,
                  55.534084377000127
                ],
                [
                  -1.602935350999928,
                  55.523627020000148
                ],
                [
                  -1.602935350999928,
                  55.516791083000143
                ],
                [
                  -1.611317511999886,
                  55.508042710000055
                ],
                [
                  -1.606353318999936,
                  55.503241278000175
                ],
                [
                  -1.596343553999873,
                  55.49990469000015
                ],
                [
                  -1.589344855999883,
                  55.495672919000029
                ],
                [
                  -1.58495032499988,
                  55.48371002800009
                ],
                [
                  -1.581369594999927,
                  55.416652736000017
                ],
                [
                  -1.583119269999912,
                  55.406927802000055
                ],
                [
                  -1.588286912999905,
                  55.390570380000142
                ],
                [
                  -1.589100714999916,
                  55.385199286
                ],
                [
                  -1.589344855999883,
                  55.376532294000086
                ],
                [
                  -1.583322719999956,
                  55.35472239800005
                ],
                [
                  -1.558583136999886,
                  55.328924872000115
                ],
                [
                  -1.555816209999932,
                  55.311346747000172
                ],
                [
                  -1.557036912999934,
                  55.306626695000077
                ],
                [
                  -1.558990037999905,
                  55.302069403000033
                ],
                [
                  -1.561919725999928,
                  55.297796942000119
                ],
                [
                  -1.565744594999927,
                  55.293646552000084
                ],
                [
                  -1.570057745999947,
                  55.286200262000094
                ],
                [
                  -1.568226691999968,
                  55.279608466000028
                ],
                [
                  -1.564279751999891,
                  55.273260809000092
                ],
                [
                  -1.562082485999895,
                  55.266669012000122
                ],
                [
                  -1.556467251999891,
                  55.255031643
                ],
                [
                  -1.54393469999988,
                  55.243882554
                ],
                [
                  -1.520985480999883,
                  55.229396877000127
                ],
                [
                  -1.529164191999911,
                  55.216253973000093
                ],
                [
                  -1.524077928999873,
                  55.210109768
                ],
                [
                  -1.514271613999938,
                  55.204779364000146
                ],
                [
                  -1.507964647999899,
                  55.19464752800009
                ],
                [
                  -1.510812954999949,
                  55.184759833000086
                ],
                [
                  -1.517567511999886,
                  55.176214911000059
                ],
                [
                  -1.52212480399993,
                  55.167466538999989
                ],
                [
                  -1.517933722999914,
                  55.15713125200007
                ],
                [
                  -1.500721808999884,
                  55.141791083000115
                ],
                [
                  -1.495961066999882,
                  55.134588934000178
                ],
                [
                  -1.492543097999885,
                  55.112982489000089
                ],
                [
                  -1.483754035999908,
                  55.091701565
                ],
                [
                  -1.480091925999943,
                  55.085394598000065
                ],
                [
                  -1.476226365999935,
                  55.083644924000069
                ],
                [
                  -1.463286912999934,
                  55.080308335000055
                ],
                [
                  -1.45958411399991,
                  55.078599351000051
                ],
                [
                  -1.458078579999949,
                  55.075751044000114
                ],
                [
                  -1.454701300999943,
                  55.067572333
                ],
                [
                  -1.438303188999925,
                  55.042303778000061
                ],
                [
                  -1.429188605999855,
                  55.033270575000031
                ],
                [
                  -1.42406165299991,
                  55.024359442
                ],
                [
                  -1.419504360999895,
                  55.011704820000134
                ],
                [
                  -1.412912563999896,
                  55.000311591000141
                ],
                [
                  -1.401519334999932,
                  54.99542877800009
                ],
                [
                  -1.398182745999918,
                  54.992621161000145
                ],
                [
                  -1.370228644999884,
                  54.975531317
                ],
                [
                  -1.362660285999937,
                  54.964789130000085
                ],
                [
                  -1.361724412999934,
                  54.958685614
                ],
                [
                  -1.363514777999853,
                  54.954250393000123
                ],
                [
                  -1.364003058999913,
                  54.948187567000119
                ],
                [
                  -1.362863735999895,
                  54.925930080000072
                ],
                [
                  -1.36034094999988,
                  54.917059637000037
                ],
                [
                  -1.353138800999943,
                  54.91351959800015
                ],
                [
                  -1.355824347999914,
                  54.90428294499999
                ],
                [
                  -1.296783006999874,
                  54.77993398600016
                ],
                [
                  -1.275461391999926,
                  54.748439846000153
                ],
                [
                  -1.24046790299991,
                  54.721665757000054
                ],
                [
                  -1.225087042999888,
                  54.715033270000092
                ],
                [
                  -1.172230597999914,
                  54.701239325000174
                ],
                [
                  -1.172230597999914,
                  54.693793036
                ],
                [
                  -1.192616339999887,
                  54.693793036
                ],
                [
                  -1.192453579999921,
                  54.689276434000035
                ],
                [
                  -1.190785285999908,
                  54.68618398600016
                ],
                [
                  -1.185170050999915,
                  54.680080471000068
                ],
                [
                  -1.182728644999884,
                  54.67206452000012
                ],
                [
                  -1.178822394999884,
                  54.664740302000112
                ],
                [
                  -1.172922329999949,
                  54.6583519550001
                ],
                [
                  -1.16470292899993,
                  54.652777411
                ],
                [
                  -1.172922329999949,
                  54.644191799000069
                ],
                [
                  -1.182484503999916,
                  54.639227606000034
                ],
                [
                  -1.206288214999916,
                  54.632961330000072
                ],
                [
                  -1.20372473899991,
                  54.625718492000047
                ],
                [
                  -1.198841925999943,
                  54.621568101000108
                ],
                [
                  -1.191802537999877,
                  54.619777736000046
                ],
                [
                  -1.182118292999917,
                  54.619289455000128
                ],
                [
                  -1.179351365999963,
                  54.620917059000149
                ],
                [
                  -1.178456183999856,
                  54.624212958
                ],
                [
                  -1.176991339999916,
                  54.626776434000092
                ],
                [
                  -1.172230597999914,
                  54.626125393000152
                ],
                [
                  -1.169585740999906,
                  54.623602606000034
                ],
                [
                  -1.165435350999871,
                  54.618719794000171
                ],
                [
                  -1.162953253999945,
                  54.613959052000084
                ],
                [
                  -1.16470292899993,
                  54.611802476000079
                ],
                [
                  -1.152658657999922,
                  54.61318594000015
                ],
                [
                  -1.14671790299991,
                  54.618475653000033
                ],
                [
                  -1.138050910999908,
                  54.646551825000031
                ],
                [
                  -1.120594855999855,
                  54.633002020000063
                ],
                [
                  -1.103627081999889,
                  54.624660549000097
                ],
                [
                  -1.084217902999882,
                  54.620428778000175
                ],
                [
                  -1.042062954999921,
                  54.61709219000015
                ],
                [
                  -0.993478969999956,
                  54.598130601000136
                ],
                [
                  -0.787912563999953,
                  54.560777085000083
                ],
                [
                  -0.562977667999888,
                  54.477362372000087
                ],
                [
                  -0.534657355999855,
                  54.461004950000174
                ],
                [
                  -0.5228572259999,
                  54.447088934000092
                ],
                [
                  -0.521799282999922,
                  54.438055731000176
                ],
                [
                  -0.523589647999927,
                  54.430243231000091
                ],
                [
                  -0.520415818999936,
                  54.420070705000128
                ],
                [
                  -0.509999152999853,
                  54.411566473
                ],
                [
                  -0.476796027999853,
                  54.397202867000132
                ],
                [
                  -0.462757941999882,
                  54.388983466000056
                ],
                [
                  -0.44774329299986,
                  54.3731957050001
                ],
                [
                  -0.430572068999936,
                  54.349310614000117
                ],
                [
                  -0.41844641799986,
                  54.324042059000149
                ],
                [
                  -0.418039516999926,
                  54.303941148000106
                ],
                [
                  -0.41454016799986,
                  54.297308661000059
                ],
                [
                  -0.409006313999924,
                  54.290757554000081
                ],
                [
                  -0.401193813999924,
                  54.285630601000051
                ],
                [
                  -0.390736456999946,
                  54.283514716000141
                ],
                [
                  -0.394886847999913,
                  54.273138739000146
                ],
                [
                  -0.397572394999884,
                  54.269191799000154
                ],
                [
                  -0.38927161399991,
                  54.264064846000153
                ],
                [
                  -0.370472785999937,
                  54.247707424000126
                ],
                [
                  -0.36278235599994,
                  54.242499091000056
                ],
                [
                  -0.322010870999861,
                  54.236070054000109
                ],
                [
                  -0.3119197259999,
                  54.231634833000058
                ],
                [
                  -0.300119594999927,
                  54.224676825000145
                ],
                [
                  -0.277088995999861,
                  54.217759507000054
                ],
                [
                  -0.269602016999897,
                  54.207668361000103
                ],
                [
                  -0.262562628999916,
                  54.18109772300015
                ],
                [
                  -0.260365363999938,
                  54.176988023000021
                ],
                [
                  -0.233876105999855,
                  54.160467841000028
                ],
                [
                  -0.111439581999889,
                  54.131577867000104
                ],
                [
                  -0.075510219999899,
                  54.112127997000115
                ],
                [
                  -0.163929816999939,
                  54.083400783000158
                ],
                [
                  -0.194691535999937,
                  54.062323309000035
                ],
                [
                  -0.219471808999884,
                  54.02277252800009
                ],
                [
                  -0.197417772999898,
                  53.994818427000055
                ],
                [
                  -0.168690558999856,
                  53.929348049000012
                ],
                [
                  -0.151112433999913,
                  53.899318752000156
                ],
                [
                  -0.045155402999853,
                  53.801214911000059
                ],
                [
                  0.133474155000044,
                  53.642645575000145
                ],
                [
                  0.149261915000068,
                  53.609605210000026
                ],
                [
                  0.136892123000052,
                  53.57713450700011
                ],
                [
                  0.131195509000065,
                  53.573431708000086
                ],
                [
                  0.109629754000139,
                  53.562892971000011
                ],
                [
                  0.131358269000117,
                  53.59369538
                ],
                [
                  0.135996941000144,
                  53.610663153000147
                ],
                [
                  0.120209181000092,
                  53.618109442000119
                ],
                [
                  0.099457227000102,
                  53.622300523000078
                ],
                [
                  0.056162957000112,
                  53.641262111000074
                ],
                [
                  0.034515821000127,
                  53.646063544000171
                ],
                [
                  0.014821811000076,
                  53.643255927000112
                ],
                [
                  -0.02391516799986,
                  53.628851630000057
                ],
                [
                  -0.045033331999946,
                  53.625555731000119
                ],
                [
                  -0.069406704999921,
                  53.62693919499999
                ],
                [
                  -0.092274542999917,
                  53.631048895000148
                ],
                [
                  -0.112619594999927,
                  53.637518622000144
                ],
                [
                  -0.130034959999904,
                  53.646063544000171
                ],
                [
                  -0.225331183999856,
                  53.719916083000086
                ],
                [
                  -0.260365363999938,
                  53.735419012000179
                ],
                [
                  -0.295643683999884,
                  53.738796291000099
                ],
                [
                  -0.30516516799986,
                  53.739691473
                ],
                [
                  -0.431141730999911,
                  53.714300848000065
                ],
                [
                  -0.449696417999917,
                  53.714300848000065
                ],
                [
                  -0.510487433999856,
                  53.714300848000065
                ],
                [
                  -0.544422980999883,
                  53.709458725999987
                ],
                [
                  -0.551503058999856,
                  53.71116771
                ],
                [
                  -0.576242641999926,
                  53.725653387000065
                ],
                [
                  -0.579172329999949,
                  53.727972723
                ],
                [
                  -0.63703365799995,
                  53.732001044000171
                ],
                [
                  -0.658355272999927,
                  53.727972723
                ],
                [
                  -0.726470506999874,
                  53.700628973000121
                ],
                [
                  -0.717355923999889,
                  53.698675848000093
                ],
                [
                  -0.708566860999895,
                  53.695746161000059
                ],
                [
                  -0.700184699999852,
                  53.691839911000088
                ],
                [
                  -0.692453579999921,
                  53.686997789000017
                ],
                [
                  -0.67747962099989,
                  53.702826239000117
                ],
                [
                  -0.6498103509999,
                  53.710598049000126
                ],
                [
                  -0.619536912999905,
                  53.711859442000147
                ],
                [
                  -0.596180792999917,
                  53.708075262000122
                ],
                [
                  -0.555490688999924,
                  53.690497137000179
                ],
                [
                  -0.544748501999919,
                  53.68357982
                ],
                [
                  -0.52993730399993,
                  53.677679755000057
                ],
                [
                  -0.514027472999913,
                  53.681301174000012
                ],
                [
                  -0.486317511999857,
                  53.694484768000066
                ],
                [
                  -0.307240363999881,
                  53.714260158000073
                ],
                [
                  -0.279367641999926,
                  53.70709870000006
                ],
                [
                  -0.260365363999938,
                  53.686997789000017
                ],
                [
                  -0.188628709999932,
                  53.62042877800009
                ],
                [
                  -0.144032355999855,
                  53.606634833
                ],
                [
                  -0.113189256999902,
                  53.584621486000074
                ],
                [
                  -0.095936652999882,
                  53.57713450700011
                ],
                [
                  -0.060943162999877,
                  53.573960679000052
                ],
                [
                  -0.04662024599989,
                  53.570379950000174
                ],
                [
                  0.000091993000098,
                  53.535345770000092
                ],
                [
                  0.09595787900011,
                  53.488348700000145
                ],
                [
                  0.115082227000073,
                  53.483221747000144
                ],
                [
                  0.134043816000087,
                  53.480617580000157
                ],
                [
                  0.151866082000083,
                  53.475816148000078
                ],
                [
                  0.167816602000073,
                  53.464504299000097
                ],
                [
                  0.170909050000148,
                  53.457017320000105
                ],
                [
                  0.173106316000144,
                  53.446763413999989
                ],
                [
                  0.175791863000114,
                  53.437689520000092
                ],
                [
                  0.181488477000102,
                  53.433742580000015
                ],
                [
                  0.190603061000104,
                  53.43187083500014
                ],
                [
                  0.219493035000113,
                  53.419501044000086
                ],
                [
                  0.211924675000063,
                  53.412665106000176
                ],
                [
                  0.229340040000125,
                  53.404771226000108
                ],
                [
                  0.244883660000141,
                  53.390936591000113
                ],
                [
                  0.256114129000139,
                  53.375067450000174
                ],
                [
                  0.260427280000044,
                  53.361476955000128
                ],
                [
                  0.342133009000122,
                  53.226304429000109
                ],
                [
                  0.356211785000085,
                  53.188544012000065
                ],
                [
                  0.356618686000076,
                  53.14573802300005
                ],
                [
                  0.335785352000102,
                  53.093451239000061
                ],
                [
                  0.32984459700009,
                  53.086493231000148
                ],
                [
                  0.318695509000065,
                  53.083685614000117
                ],
                [
                  0.298838738000143,
                  53.081203518000095
                ],
                [
                  0.282481316000144,
                  53.07485586100016
                ],
                [
                  0.19304446700005,
                  53.020086981000034
                ],
                [
                  0.174489780000044,
                  53.015448309000092
                ],
                [
                  0.160817905000101,
                  53.008978583
                ],
                [
                  0.082123243000098,
                  52.938666083000086
                ],
                [
                  0.061167839000063,
                  52.924994208000143
                ],
                [
                  0.037608269000117,
                  52.91917552299999
                ],
                [
                  0.022146030000101,
                  52.912583726000108
                ],
                [
                  0.008555535000141,
                  52.898627020000148
                ],
                [
                  0.010264519000145,
                  52.886460679000052
                ],
                [
                  0.040660027000115,
                  52.88507721600017
                ],
                [
                  0.092539910000085,
                  52.892523505000057
                ],
                [
                  0.105642123000081,
                  52.889349677
                ],
                [
                  0.133474155000044,
                  52.875189520000063
                ],
                [
                  0.147146030000073,
                  52.872015692
                ],
                [
                  0.170909050000148,
                  52.862127997000087
                ],
                [
                  0.222422722000147,
                  52.813666083
                ],
                [
                  0.246755405000101,
                  52.795721747000144
                ],
                [
                  0.264496290000096,
                  52.80369700700011
                ],
                [
                  0.285655144000117,
                  52.80556875200007
                ],
                [
                  0.32553144600007,
                  52.803168036000116
                ],
                [
                  0.341807488000114,
                  52.797430731000148
                ],
                [
                  0.369883660000113,
                  52.773016669000114
                ],
                [
                  0.384532097000118,
                  52.768377997000087
                ],
                [
                  0.384532097000118,
                  52.775213934000092
                ],
                [
                  0.379242384000065,
                  52.790838934000178
                ],
                [
                  0.399424675000091,
                  52.809515692000062
                ],
                [
                  0.425547722000118,
                  52.827378648000135
                ],
                [
                  0.438649936000104,
                  52.840725002000127
                ],
                [
                  0.444021030000073,
                  52.865057684000121
                ],
                [
                  0.456716342000107,
                  52.891994533000073
                ],
                [
                  0.472341342000107,
                  52.916449286000116
                ],
                [
                  0.485687696000099,
                  52.933498440000065
                ],
                [
                  0.520274285000113,
                  52.95526764500012
                ],
                [
                  0.569590691000087,
                  52.969305731000176
                ],
                [
                  0.623383009000065,
                  52.975653387000122
                ],
                [
                  0.671885613000114,
                  52.974432684000092
                ],
                [
                  0.664398634000065,
                  52.981878973000065
                ],
                [
                  0.684743686000047,
                  52.986395575000031
                ],
                [
                  0.706797722000147,
                  52.983221747000144
                ],
                [
                  0.729177280000073,
                  52.977484442
                ],
                [
                  0.750498894000117,
                  52.974432684000092
                ],
                [
                  0.835703972000118,
                  52.974432684000092
                ],
                [
                  0.875498894000089,
                  52.96816640800013
                ],
                [
                  0.921071811000047,
                  52.954657294000171
                ],
                [
                  0.968435092000107,
                  52.94749583500014
                ],
                [
                  1.013926629000082,
                  52.960150458
                ],
                [
                  1.003428582000083,
                  52.964748440000122
                ],
                [
                  0.991547071000042,
                  52.967474677000112
                ],
                [
                  0.979014519000145,
                  52.968410549000097
                ],
                [
                  0.966075066000144,
                  52.967596747000172
                ],
                [
                  0.966075066000144,
                  52.974432684000092
                ],
                [
                  1.274668816000116,
                  52.929185289000074
                ],
                [
                  1.39600670700014,
                  52.891424872000115
                ],
                [
                  1.644216342000107,
                  52.775824286000059
                ],
                [
                  1.673350457000055,
                  52.755682684000121
                ],
                [
                  1.69703209700009,
                  52.731024481000034
                ],
                [
                  1.71583092500012,
                  52.683742580000072
                ],
                [
                  1.73414147200009,
                  52.654608466000113
                ],
                [
                  1.747243686000076,
                  52.62518952000012
                ],
                [
                  1.74073326900006,
                  52.603908596000153
                ],
                [
                  1.746836785000141,
                  52.588527736000017
                ],
                [
                  1.748708530000016,
                  52.568793036000088
                ],
                [
                  1.747569207000083,
                  52.532782294000114
                ],
                [
                  1.771169467000021,
                  52.485907294000143
                ],
                [
                  1.767100457000055,
                  52.476955471000124
                ],
                [
                  1.754405144000089,
                  52.467352606000148
                ],
                [
                  1.729258660000113,
                  52.415594794000029
                ],
                [
                  1.730153842000107,
                  52.405910549000069
                ],
                [
                  1.727875196000127,
                  52.396307684000092
                ],
                [
                  1.683604363000086,
                  52.324530341000113
                ],
                [
                  1.65186608200014,
                  52.289129950000088
                ],
                [
                  1.641123894000117,
                  52.281805731000091
                ],
                [
                  1.630544467000078,
                  52.270453192000119
                ],
                [
                  1.628265821000099,
                  52.244818427000055
                ],
                [
                  1.630869988000086,
                  52.199774481000176
                ],
                [
                  1.625498894000117,
                  52.180365302000055
                ],
                [
                  1.607432488000114,
                  52.145941473000121
                ],
                [
                  1.603526238000114,
                  52.127834377000042
                ],
                [
                  1.589203321000127,
                  52.100816148000078
                ],
                [
                  1.587575717000107,
                  52.086981512000179
                ],
                [
                  1.582286004000139,
                  52.08148834800015
                ],
                [
                  1.503672722000118,
                  52.060980536
                ],
                [
                  1.486827019000117,
                  52.049017645000063
                ],
                [
                  1.47201582100007,
                  52.056219794000086
                ],
                [
                  1.466807488000143,
                  52.048000393
                ],
                [
                  1.46387780000012,
                  52.035142320000077
                ],
                [
                  1.455821160000113,
                  52.02850983300003
                ],
                [
                  1.44898522200009,
                  52.024969794000029
                ],
                [
                  1.424815300000091,
                  52.001857815000065
                ],
                [
                  1.35482832100007,
                  51.954046942000147
                ],
                [
                  1.34351647200009,
                  51.942857164000131
                ],
                [
                  1.332286004000082,
                  51.940090236000074
                ],
                [
                  1.264414910000085,
                  51.994370835000112
                ],
                [
                  1.234873894000117,
                  52.000311591000028
                ],
                [
                  1.185231967000021,
                  52.025091864
                ],
                [
                  1.15788821700005,
                  52.02850983300003
                ],
                [
                  1.15788821700005,
                  52.021673895000092
                ],
                [
                  1.193532748000109,
                  52.00079987200003
                ],
                [
                  1.214366082000083,
                  51.99144114799999
                ],
                [
                  1.260264519000145,
                  51.984808661000116
                ],
                [
                  1.270762566000116,
                  51.981512762000179
                ],
                [
                  1.275157097000118,
                  51.976996161000116
                ],
                [
                  1.274424675000091,
                  51.960882880000057
                ],
                [
                  1.271006707000083,
                  51.956447658000073
                ],
                [
                  1.250743035000056,
                  51.959621486000131
                ],
                [
                  1.238942905000101,
                  51.958644924000069
                ],
                [
                  1.217621290000125,
                  51.954331773000078
                ],
                [
                  1.205739780000073,
                  51.953436591000084
                ],
                [
                  1.193207227000073,
                  51.955511786
                ],
                [
                  1.165293816000144,
                  51.96702708500014
                ],
                [
                  1.143077019000089,
                  51.966050523000078
                ],
                [
                  1.094493035000113,
                  51.955959377000099
                ],
                [
                  1.069102410000085,
                  51.953436591000084
                ],
                [
                  1.09546959700009,
                  51.945746161000059
                ],
                [
                  1.262054884000037,
                  51.939154364000089
                ],
                [
                  1.281993035000113,
                  51.946600653000147
                ],
                [
                  1.278493686000047,
                  51.927923895000092
                ],
                [
                  1.199554884000094,
                  51.877671617000104
                ],
                [
                  1.21225019600007,
                  51.871649481000119
                ],
                [
                  1.22787519600007,
                  51.86737702
                ],
                [
                  1.264414910000085,
                  51.86399974199999
                ],
                [
                  1.274750196000099,
                  51.870306708000115
                ],
                [
                  1.282237175000063,
                  51.880560614000146
                ],
                [
                  1.28663170700014,
                  51.881659247000087
                ],
                [
                  1.288259311000076,
                  51.860581773000078
                ],
                [
                  1.27637780000012,
                  51.844794012000122
                ],
                [
                  1.219248894000145,
                  51.811835028000147
                ],
                [
                  1.167816602000045,
                  51.790228583000058
                ],
                [
                  1.135427280000044,
                  51.781724351000108
                ],
                [
                  1.065440300000148,
                  51.775295315
                ],
                [
                  1.04664147200009,
                  51.777044989
                ],
                [
                  1.037282748000052,
                  51.782171942000119
                ],
                [
                  1.021332227000045,
                  51.802557684000092
                ],
                [
                  0.988780144000089,
                  51.830267645000092
                ],
                [
                  0.97982832100007,
                  51.843573309000092
                ],
                [
                  0.977061394000089,
                  51.824611721000096
                ],
                [
                  0.962087436000076,
                  51.81378815300009
                ],
                [
                  0.925140821000099,
                  51.802557684000092
                ],
                [
                  0.894297722000147,
                  51.78461334800015
                ],
                [
                  0.886973504000139,
                  51.782131252000127
                ],
                [
                  0.886403842000078,
                  51.77667877800009
                ],
                [
                  0.883474155000073,
                  51.76471588700015
                ],
                [
                  0.878916863000114,
                  51.75275299700003
                ],
                [
                  0.873708530000016,
                  51.74730052299999
                ],
                [
                  0.861989780000044,
                  51.745550848000093
                ],
                [
                  0.845957879000139,
                  51.736761786000116
                ],
                [
                  0.835703972000118,
                  51.733710028000033
                ],
                [
                  0.823496941000144,
                  51.733832098
                ],
                [
                  0.801442905000044,
                  51.73969147300015
                ],
                [
                  0.791758660000085,
                  51.741156317
                ],
                [
                  0.767100457000083,
                  51.739447333
                ],
                [
                  0.720876498000081,
                  51.728176174000012
                ],
                [
                  0.698578321000042,
                  51.72003815300009
                ],
                [
                  0.714203321000127,
                  51.715277411
                ],
                [
                  0.732432488000114,
                  51.713771877000127
                ],
                [
                  0.749278191000116,
                  51.708482164000159
                ],
                [
                  0.760752800000148,
                  51.692694403000033
                ],
                [
                  0.789073113000114,
                  51.710150458000086
                ],
                [
                  0.853037957000112,
                  51.718898830000157
                ],
                [
                  0.883555535000141,
                  51.726874091000113
                ],
                [
                  0.912364129000082,
                  51.741522528000033
                ],
                [
                  0.930023634000094,
                  51.74359772300015
                ],
                [
                  0.945567254000082,
                  51.733710028000033
                ],
                [
                  0.947438998000052,
                  51.725246486000103
                ],
                [
                  0.944590691000116,
                  51.715480861000131
                ],
                [
                  0.940440300000063,
                  51.707993882
                ],
                [
                  0.938161655000101,
                  51.706366278000147
                ],
                [
                  0.940196160000113,
                  51.698431708
                ],
                [
                  0.944021030000044,
                  51.690578518
                ],
                [
                  0.951833530000044,
                  51.678412177000112
                ],
                [
                  0.941742384000065,
                  51.673041083000086
                ],
                [
                  0.937998894000145,
                  51.664496161000145
                ],
                [
                  0.938161655000101,
                  51.641262111000046
                ],
                [
                  0.934743686000104,
                  51.635891018000066
                ],
                [
                  0.92676842500012,
                  51.630926825000117
                ],
                [
                  0.91146894600007,
                  51.623846747000144
                ],
                [
                  0.93848717500012,
                  51.62498607
                ],
                [
                  0.948090040000096,
                  51.621527411
                ],
                [
                  0.951833530000044,
                  51.617010809000035
                ],
                [
                  0.924489780000073,
                  51.588324286000088
                ],
                [
                  0.87330162900011,
                  51.559475002000156
                ],
                [
                  0.828298373000024,
                  51.54185618700005
                ],
                [
                  0.816254102000102,
                  51.537176825000117
                ],
                [
                  0.771250847000118,
                  51.52826569200009
                ],
                [
                  0.692067905000044,
                  51.536322333000115
                ],
                [
                  0.664398634000065,
                  51.53506094
                ],
                [
                  0.663747592000107,
                  51.535549221000096
                ],
                [
                  0.650563998000052,
                  51.535793361000131
                ],
                [
                  0.646657748000052,
                  51.53534577000012
                ],
                [
                  0.644053582000055,
                  51.53506094
                ],
                [
                  0.642751498000081,
                  51.533514716000141
                ],
                [
                  0.623383009000065,
                  51.522040106000119
                ],
                [
                  0.608653191000144,
                  51.518988348000121
                ],
                [
                  0.595225457000055,
                  51.518622137000094
                ],
                [
                  0.582286004000053,
                  51.51654694200009
                ],
                [
                  0.56885826900006,
                  51.508368231000176
                ],
                [
                  0.552744988000086,
                  51.517971096000153
                ],
                [
                  0.547211134000065,
                  51.517726955000015
                ],
                [
                  0.525401238000114,
                  51.51691315300009
                ],
                [
                  0.456065300000063,
                  51.505560614000117
                ],
                [
                  0.450856967000078,
                  51.498277085000112
                ],
                [
                  0.448008660000141,
                  51.488226630000142
                ],
                [
                  0.44166100400011,
                  51.477036851000136
                ],
                [
                  0.428477410000141,
                  51.467108466000028
                ],
                [
                  0.414073113000086,
                  51.461900132000139
                ],
                [
                  0.399180535000141,
                  51.45840078300013
                ],
                [
                  0.384532097000118,
                  51.453111070000077
                ],
                [
                  0.448415561000047,
                  51.459947007
                ],
                [
                  0.45679772200009,
                  51.463120835000055
                ],
                [
                  0.461436394000117,
                  51.470160223000121
                ],
                [
                  0.464854363000143,
                  51.477240302
                ],
                [
                  0.469574415000039,
                  51.480414130000057
                ],
                [
                  0.53484134200005,
                  51.491685289000046
                ],
                [
                  0.694834832000112,
                  51.477036851000136
                ],
                [
                  0.709483269000117,
                  51.470526434000035
                ],
                [
                  0.721934441000144,
                  51.456284898000135
                ],
                [
                  0.723155144000145,
                  51.44672272300015
                ],
                [
                  0.713145379000082,
                  51.441229559000121
                ],
                [
                  0.692393425000091,
                  51.439520575000117
                ],
                [
                  0.656504754000082,
                  51.444525458000058
                ],
                [
                  0.640961134000094,
                  51.444159247000059
                ],
                [
                  0.609385613000086,
                  51.425116278000147
                ],
                [
                  0.572764519000145,
                  51.419582424000126
                ],
                [
                  0.554535352000073,
                  51.41217682500006
                ],
                [
                  0.56226647200009,
                  51.406561591000141
                ],
                [
                  0.569102410000113,
                  51.399603583000058
                ],
                [
                  0.576508009000094,
                  51.393622137000037
                ],
                [
                  0.585948113000114,
                  51.391058661000116
                ],
                [
                  0.671885613000114,
                  51.391058661000116
                ],
                [
                  0.712901238000114,
                  51.384222723
                ],
                [
                  0.704925977000073,
                  51.395982164000188
                ],
                [
                  0.700368686000047,
                  51.409816799000097
                ],
                [
                  0.705332879000082,
                  51.419501044000143
                ],
                [
                  0.726410352000102,
                  51.41901276200015
                ],
                [
                  0.728363477000045,
                  51.406236070000105
                ],
                [
                  0.73926842500012,
                  51.38792552300005
                ],
                [
                  0.75342858200014,
                  51.371527411000145
                ],
                [
                  0.764414910000113,
                  51.364406643
                ],
                [
                  0.977224155000073,
                  51.349188544000029
                ],
                [
                  1.100922071000127,
                  51.373236395000148
                ],
                [
                  1.423838738000114,
                  51.392075914000188
                ],
                [
                  1.448252800000148,
                  51.382879950000031
                ],
                [
                  1.439138217000078,
                  51.350083726000108
                ],
                [
                  1.435557488000086,
                  51.34373607
                ],
                [
                  1.430837436000076,
                  51.33779531500015
                ],
                [
                  1.425140821000099,
                  51.33295319200009
                ],
                [
                  1.418630405000101,
                  51.329657294000057
                ],
                [
                  1.382985873000052,
                  51.329779364000032
                ],
                [
                  1.377614780000101,
                  51.326239325000031
                ],
                [
                  1.38062584700009,
                  51.304754950000088
                ],
                [
                  1.387868686000047,
                  51.287909247000087
                ],
                [
                  1.404307488000114,
                  51.261379299000126
                ],
                [
                  1.413096550000091,
                  51.221747137000122
                ],
                [
                  1.404795769000117,
                  51.183539130000057
                ],
                [
                  1.384450717000107,
                  51.151678778000033
                ],
                [
                  1.357188347000118,
                  51.131008205000015
                ],
                [
                  1.290375196000099,
                  51.116522528000147
                ],
                [
                  1.262950066000144,
                  51.103257554000137
                ],
                [
                  1.25163821700005,
                  51.102525132000025
                ],
                [
                  1.229991082000055,
                  51.10370514500012
                ],
                [
                  1.218109571000099,
                  51.100978908000158
                ],
                [
                  1.208262566000087,
                  51.094671942000119
                ],
                [
                  1.19971764400006,
                  51.087591864000061
                ],
                [
                  1.192067905000044,
                  51.082586981000119
                ],
                [
                  1.172211134000122,
                  51.077378648000106
                ],
                [
                  1.106700066000087,
                  51.076361395000063
                ],
                [
                  1.087168816000116,
                  51.072984117000047
                ],
                [
                  1.066905144000117,
                  51.064398505000113
                ],
                [
                  1.02759850400011,
                  51.041652736000103
                ],
                [
                  0.976410352000045,
                  50.994452216000113
                ],
                [
                  0.96648196700005,
                  50.982733466000028
                ],
                [
                  0.969086134000037,
                  50.956854559000121
                ],
                [
                  0.97982832100007,
                  50.918158270000063
                ],
                [
                  0.945160352000073,
                  50.909369208
                ],
                [
                  0.869802280000016,
                  50.925116278000147
                ],
                [
                  0.80225670700014,
                  50.939195054000024
                ],
                [
                  0.762461785000056,
                  50.930894273000106
                ],
                [
                  0.664398634000065,
                  50.870306708000143
                ],
                [
                  0.624196811000076,
                  50.858710028000033
                ],
                [
                  0.407481316000116,
                  50.829331773000135
                ],
                [
                  0.370290561000019,
                  50.818793036000059
                ],
                [
                  0.365244988000086,
                  50.818996486000017
                ],
                [
                  0.354258660000113,
                  50.809637762000179
                ],
                [
                  0.344411655000101,
                  50.79905833500014
                ],
                [
                  0.342295769000089,
                  50.79515208500014
                ],
                [
                  0.308116082000112,
                  50.780951239000117
                ],
                [
                  0.271006707000083,
                  50.74738190300009
                ],
                [
                  0.233897332000083,
                  50.74701569200009
                ],
                [
                  0.214121941000144,
                  50.748928127000127
                ],
                [
                  0.168304884000065,
                  50.759833075000117
                ],
                [
                  0.157399936000076,
                  50.761053778000033
                ],
                [
                  0.122080925000148,
                  50.760809637000179
                ],
                [
                  0.113047722000147,
                  50.764146226000108
                ],
                [
                  0.095550977000102,
                  50.775051174000097
                ],
                [
                  0.077036980000088,
                  50.778998114000089
                ],
                [
                  0.034515821000127,
                  50.780951239000117
                ],
                [
                  0.017548048000151,
                  50.784857489000117
                ],
                [
                  -0.173166469999899,
                  50.829006252000013
                ],
                [
                  -0.206125454999892,
                  50.831040757000139
                ],
                [
                  -0.208892381999931,
                  50.83010488500004
                ],
                [
                  -0.233143683999941,
                  50.821926174000126
                ],
                [
                  -0.26968339799987,
                  50.831284898000078
                ],
                [
                  -0.397572394999884,
                  50.802069403000033
                ],
                [
                  -0.56895911399991,
                  50.802069403000033
                ],
                [
                  -0.732736782999922,
                  50.767279364000089
                ],
                [
                  -0.74156653599988,
                  50.769232489000117
                ],
                [
                  -0.749867316999939,
                  50.773871161000059
                ],
                [
                  -0.758208787999905,
                  50.777085679000109
                ],
                [
                  -0.767567511999857,
                  50.774725653000147
                ],
                [
                  -0.773101365999878,
                  50.766017971000068
                ],
                [
                  -0.766265428999873,
                  50.747137762000065
                ],
                [
                  -0.770985480999855,
                  50.736883856000119
                ],
                [
                  -0.789947068999879,
                  50.730047919000114
                ],
                [
                  -0.812814907999893,
                  50.734767971000011
                ],
                [
                  -0.904123501999948,
                  50.771877346000124
                ],
                [
                  -0.911488410999937,
                  50.777818101000051
                ],
                [
                  -0.905873175999943,
                  50.78803131700009
                ],
                [
                  -0.892486131999931,
                  50.794623114000061
                ],
                [
                  -0.863636847999913,
                  50.802069403000033
                ],
                [
                  -0.863636847999913,
                  50.808254299000012
                ],
                [
                  -0.873605923999918,
                  50.812933661000116
                ],
                [
                  -0.893137173999889,
                  50.825344143000152
                ],
                [
                  -0.904693162999905,
                  50.829331773000135
                ],
                [
                  -0.909535285999908,
                  50.825995184000092
                ],
                [
                  -0.921701626999891,
                  50.821600653000118
                ],
                [
                  -0.928944464999915,
                  50.822821356000034
                ],
                [
                  -0.919016079999892,
                  50.83616771000014
                ],
                [
                  -0.929798956999917,
                  50.839992580000157
                ],
                [
                  -0.939198370999918,
                  50.843247789000102
                ],
                [
                  -0.970773891999926,
                  50.846991278000033
                ],
                [
                  -0.994862433999856,
                  50.847072658000016
                ],
                [
                  -1.001861131999931,
                  50.847113348
                ],
                [
                  -1.020741339999859,
                  50.84365469
                ],
                [
                  -1.033558722999885,
                  50.825913804000109
                ],
                [
                  -1.042632615999906,
                  50.801906643000066
                ],
                [
                  -1.056223110999952,
                  50.783026434000035
                ],
                [
                  -1.082753058999913,
                  50.780951239000117
                ],
                [
                  -1.103016730999912,
                  50.795477606000148
                ],
                [
                  -1.093617316999911,
                  50.812933661000116
                ],
                [
                  -1.075306769999941,
                  50.830023505000057
                ],
                [
                  -1.069162563999953,
                  50.84365469
                ],
                [
                  -1.087310350999871,
                  50.849798895000092
                ],
                [
                  -1.088124152999882,
                  50.8497582050001
                ],
                [
                  -1.1498103509999,
                  50.84666575700011
                ],
                [
                  -1.16470292899993,
                  50.84365469
                ],
                [
                  -1.129709438999953,
                  50.825100002000013
                ],
                [
                  -1.123768683999913,
                  50.818793036000059
                ],
                [
                  -1.121205206999917,
                  50.799383856000148
                ],
                [
                  -1.124908006999874,
                  50.788723049000126
                ],
                [
                  -1.138050910999908,
                  50.780951239000117
                ],
                [
                  -1.151112433999884,
                  50.781398830000015
                ],
                [
                  -1.169341600999871,
                  50.78587474199999
                ],
                [
                  -1.185617641999897,
                  50.792425848000065
                ],
                [
                  -1.192616339999887,
                  50.798651434000035
                ],
                [
                  -1.199289516999926,
                  50.807928778000175
                ],
                [
                  -1.231516079999892,
                  50.818915106000034
                ],
                [
                  -1.255197719999899,
                  50.831935940000122
                ],
                [
                  -1.288156704999892,
                  50.839178778000147
                ],
                [
                  -1.301421678999901,
                  50.84365469
                ],
                [
                  -1.318592902999853,
                  50.856919664000046
                ],
                [
                  -1.338937954999921,
                  50.872707424000097
                ],
                [
                  -1.449289516999897,
                  50.912054755000085
                ],
                [
                  -1.466420050999915,
                  50.918158270000063
                ],
                [
                  -1.466420050999915,
                  50.911932684000121
                ],
                [
                  -1.456450975999928,
                  50.908758856000063
                ],
                [
                  -1.437977667999917,
                  50.901312567000062
                ],
                [
                  -1.425607876999948,
                  50.900091864000146
                ],
                [
                  -1.401112433999856,
                  50.881170966000028
                ],
                [
                  -1.323068813999896,
                  50.825751044000143
                ],
                [
                  -1.314279751999919,
                  50.812160549000012
                ],
                [
                  -1.317290818999936,
                  50.800238348000065
                ],
                [
                  -1.339833136999914,
                  50.79515208500014
                ],
                [
                  -1.403960740999878,
                  50.791571356000148
                ],
                [
                  -1.418690558999884,
                  50.78839752800009
                ],
                [
                  -1.411366339999859,
                  50.784898179000109
                ],
                [
                  -1.404937303999958,
                  50.780951239000117
                ],
                [
                  -1.404937303999958,
                  50.774725653000147
                ],
                [
                  -1.450510219999899,
                  50.769354559000092
                ],
                [
                  -1.476226365999935,
                  50.763413804
                ],
                [
                  -1.487538214999944,
                  50.75771719
                ],
                [
                  -1.491932745999918,
                  50.757269598
                ],
                [
                  -1.524728969999927,
                  50.761053778000033
                ],
                [
                  -1.557199673999918,
                  50.72329336100016
                ],
                [
                  -1.559396938999896,
                  50.719224351000108
                ],
                [
                  -1.561187303999901,
                  50.718980210000055
                ],
                [
                  -1.580718553999873,
                  50.722642320000105
                ],
                [
                  -1.602121548999918,
                  50.731756903000118
                ],
                [
                  -1.670643683999856,
                  50.740057684000178
                ],
                [
                  -1.672922329999921,
                  50.740057684000178
                ],
                [
                  -1.693023240999878,
                  50.739935614000117
                ],
                [
                  -1.715077277999882,
                  50.735785223000065
                ],
                [
                  -1.753529425999886,
                  50.722845770000063
                ],
                [
                  -1.771717902999882,
                  50.720119533000101
                ],
                [
                  -1.797434048999918,
                  50.723171291000185
                ],
                [
                  -1.835072394999912,
                  50.727687893000152
                ],
                [
                  -1.857411261999857,
                  50.726955471000039
                ],
                [
                  -1.877349412999934,
                  50.722845770000063
                ],
                [
                  -1.896351691999911,
                  50.716294664000188
                ],
                [
                  -1.896880662999905,
                  50.71605052300005
                ],
                [
                  -1.913889126999948,
                  50.707424221000124
                ],
                [
                  -1.929107225999928,
                  50.695868231000119
                ],
                [
                  -1.940012173999918,
                  50.690822658000073
                ],
                [
                  -1.944325324999909,
                  50.697658596000011
                ],
                [
                  -1.946115688999896,
                  50.707912502000127
                ],
                [
                  -1.949289516999954,
                  50.713324286000088
                ],
                [
                  -1.9877009759999,
                  50.720119533000101
                ],
                [
                  -2.01390540299991,
                  50.718939520000063
                ],
                [
                  -2.02196204299986,
                  50.720119533000101
                ],
                [
                  -2.025461391999954,
                  50.723863023000135
                ],
                [
                  -2.026193813999981,
                  50.725083726000051
                ],
                [
                  -2.033843553999901,
                  50.737127997000144
                ],
                [
                  -2.038970506999931,
                  50.739935614000117
                ],
                [
                  -2.048085089999916,
                  50.734808661
                ],
                [
                  -2.082671678999901,
                  50.698960679
                ],
                [
                  -2.069569464999859,
                  50.700100002000127
                ],
                [
                  -2.057728644999884,
                  50.702826239
                ],
                [
                  -2.046620245999861,
                  50.707261460000083
                ],
                [
                  -2.035633917999888,
                  50.713324286000088
                ],
                [
                  -2.01414954299986,
                  50.688788153000147
                ],
                [
                  -2.002512173999946,
                  50.681301174000097
                ],
                [
                  -1.984120245999918,
                  50.67853424700003
                ],
                [
                  -1.967437303999873,
                  50.678656317
                ],
                [
                  -1.952788865999878,
                  50.676581122000172
                ],
                [
                  -1.945871548999946,
                  50.66885000200007
                ],
                [
                  -1.952951626999919,
                  50.651841539000102
                ],
                [
                  -1.938221808999856,
                  50.64581940300009
                ],
                [
                  -1.932484503999945,
                  50.644435940000037
                ],
                [
                  -1.967274542999917,
                  50.61709219000015
                ],
                [
                  -1.965199347999885,
                  50.602199611000103
                ],
                [
                  -1.983713344999899,
                  50.59662506700009
                ],
                [
                  -2.065174933999856,
                  50.595526434000035
                ],
                [
                  -2.082183397999927,
                  50.59784577
                ],
                [
                  -2.157338019999912,
                  50.620510158000158
                ],
                [
                  -2.342640753999945,
                  50.633775132
                ],
                [
                  -2.377064581999889,
                  50.647528387000094
                ],
                [
                  -2.398345506999959,
                  50.64557526200015
                ],
                [
                  -2.435902472999942,
                  50.637518622000115
                ],
                [
                  -2.447621222999942,
                  50.627875067000147
                ],
                [
                  -2.460072394999884,
                  50.606512762000094
                ],
                [
                  -2.465646938999981,
                  50.585150458000143
                ],
                [
                  -2.4564509759999,
                  50.575506903000147
                ],
                [
                  -2.431223110999952,
                  50.570257880000085
                ],
                [
                  -2.428700324999937,
                  50.557562567000119
                ],
                [
                  -2.439279751999891,
                  50.541815497000144
                ],
                [
                  -2.45335852799991,
                  50.527655341000141
                ],
                [
                  -2.45954342399989,
                  50.527655341000141
                ],
                [
                  -2.4603572259999,
                  50.565497137000179
                ],
                [
                  -2.483509894999941,
                  50.590399481000119
                ],
                [
                  -2.69294186099998,
                  50.692816473000121
                ],
                [
                  -2.864816860999895,
                  50.73379140800013
                ],
                [
                  -2.887318488999881,
                  50.734361070000105
                ],
                [
                  -2.94554602799991,
                  50.72581614799999
                ],
                [
                  -2.962757941999939,
                  50.72329336100016
                ],
                [
                  -2.998199022999927,
                  50.70823802300005
                ],
                [
                  -3.021839972999942,
                  50.70648834800015
                ],
                [
                  -3.059722459999904,
                  50.713324286000088
                ],
                [
                  -3.071359829999892,
                  50.711004950000117
                ],
                [
                  -3.094146287999934,
                  50.698960679
                ],
                [
                  -3.099232550999943,
                  50.697088934000035
                ],
                [
                  -3.11583411399991,
                  50.687974351000136
                ],
                [
                  -3.125477667999888,
                  50.685288804000052
                ],
                [
                  -3.135894334999875,
                  50.685939846000011
                ],
                [
                  -3.155140753999916,
                  50.691351630000057
                ],
                [
                  -3.166493292999888,
                  50.692816473000121
                ],
                [
                  -3.185617641999954,
                  50.69074127800009
                ],
                [
                  -3.219146287999905,
                  50.680812893
                ],
                [
                  -3.259836391999897,
                  50.674546617000047
                ],
                [
                  -3.271392381999903,
                  50.664496161000088
                ],
                [
                  -3.280425584999904,
                  50.651190497000144
                ],
                [
                  -3.295562303999901,
                  50.637518622000115
                ],
                [
                  -3.368153449999909,
                  50.61709219000015
                ],
                [
                  -3.390736456999889,
                  50.617824611000074
                ],
                [
                  -3.407541469999899,
                  50.621283270000063
                ],
                [
                  -3.420969204999892,
                  50.629461981000176
                ],
                [
                  -3.433338995999918,
                  50.644435940000037
                ],
                [
                  -3.446359829999921,
                  50.668280341000084
                ],
                [
                  -3.450428839999887,
                  50.672308661000059
                ],
                [
                  -3.453277147999927,
                  50.673285223000121
                ],
                [
                  -3.455433722999914,
                  50.675441799000126
                ],
                [
                  -3.458607550999886,
                  50.677557684000149
                ],
                [
                  -3.464426235999923,
                  50.67853424700003
                ],
                [
                  -3.46776282499988,
                  50.676418361000017
                ],
                [
                  -3.468902147999899,
                  50.671698309000092
                ],
                [
                  -3.467844204999949,
                  50.666978257
                ],
                [
                  -3.455311652999853,
                  50.657904364
                ],
                [
                  -3.442046678999901,
                  50.623521226000051
                ],
                [
                  -3.433338995999918,
                  50.610256252000127
                ],
                [
                  -3.451161261999914,
                  50.599432684000035
                ],
                [
                  -3.467274542999888,
                  50.585598049000126
                ],
                [
                  -3.481760219999927,
                  50.568548895000092
                ],
                [
                  -3.494862433999884,
                  50.54816315300009
                ],
                [
                  -3.505970831999917,
                  50.520819403000033
                ],
                [
                  -3.505034959999932,
                  50.501206773000078
                ],
                [
                  -3.487456834999904,
                  50.459418036000116
                ],
                [
                  -3.509755011999857,
                  50.458482164000046
                ],
                [
                  -3.532134568999879,
                  50.454779364
                ],
                [
                  -3.549427863999881,
                  50.446519273000106
                ],
                [
                  -3.556263800999886,
                  50.432114976000051
                ],
                [
                  -3.549305792999888,
                  50.415594794000171
                ],
                [
                  -3.531971808999913,
                  50.410223700000117
                ],
                [
                  -3.487456834999904,
                  50.411566473
                ],
                [
                  -3.487456834999904,
                  50.404771225999987
                ],
                [
                  -3.4974666009999,
                  50.387355861000017
                ],
                [
                  -3.49828040299991,
                  50.383693752000156
                ],
                [
                  -3.507313605999912,
                  50.382798570000077
                ],
                [
                  -3.514963344999927,
                  50.379950262000122
                ],
                [
                  -3.520130988999938,
                  50.374823309000121
                ],
                [
                  -3.526926235999952,
                  50.349798895
                ],
                [
                  -3.538889126999891,
                  50.344427802000141
                ],
                [
                  -3.554514126999891,
                  50.347642320000105
                ],
                [
                  -3.570546027999882,
                  50.35639069200009
                ],
                [
                  -3.577788865999906,
                  50.33405182500006
                ],
                [
                  -3.599110480999883,
                  50.325832424000126
                ],
                [
                  -3.62157141799986,
                  50.321926174000154
                ],
                [
                  -3.631988084999875,
                  50.312323309000149
                ],
                [
                  -3.637359178999901,
                  50.295396225999987
                ],
                [
                  -3.647572394999941,
                  50.274562893
                ],
                [
                  -3.653309699999909,
                  50.25104401200015
                ],
                [
                  -3.645619269999912,
                  50.22601959800015
                ],
                [
                  -3.660633917999917,
                  50.221014716000113
                ],
                [
                  -3.700917120999918,
                  50.213527736000131
                ],
                [
                  -3.718006964999859,
                  50.212388414000102
                ],
                [
                  -3.74038652299987,
                  50.215887762000094
                ],
                [
                  -3.758615688999953,
                  50.221747137000037
                ],
                [
                  -3.774240688999925,
                  50.222967841000141
                ],
                [
                  -3.788970506999931,
                  50.212388414000102
                ],
                [
                  -3.826324022999899,
                  50.234198309000149
                ],
                [
                  -3.8841853509999,
                  50.280462958000143
                ],
                [
                  -3.949940558999884,
                  50.318996486000046
                ],
                [
                  -3.961008266999926,
                  50.32225169499999
                ],
                [
                  -3.970204230999883,
                  50.320746161000116
                ],
                [
                  -3.995757615999878,
                  50.31142812700007
                ],
                [
                  -4.00560462099989,
                  50.309230861000074
                ],
                [
                  -4.011341925999972,
                  50.306952216000028
                ],
                [
                  -4.024769660999965,
                  50.29718659100017
                ],
                [
                  -4.032948370999861,
                  50.294907945000105
                ],
                [
                  -4.044056769999884,
                  50.296454169000143
                ],
                [
                  -4.054351365999906,
                  50.300360419000057
                ],
                [
                  -4.070220506999931,
                  50.309230861000074
                ],
                [
                  -4.067941860999952,
                  50.312811591000141
                ],
                [
                  -4.064035610999952,
                  50.32225169499999
                ],
                [
                  -4.086008266999897,
                  50.326239325000145
                ],
                [
                  -4.108265753999945,
                  50.336615302000055
                ],
                [
                  -4.118723110999923,
                  50.351874091000028
                ],
                [
                  -4.104969855999912,
                  50.370672919000171
                ],
                [
                  -4.141753709999875,
                  50.36904531500015
                ],
                [
                  -4.152740037999934,
                  50.370672919000171
                ],
                [
                  -4.165516730999883,
                  50.376369533000158
                ],
                [
                  -4.171457485999923,
                  50.382798570000077
                ],
                [
                  -4.175770636999914,
                  50.39085521
                ],
                [
                  -4.183827277999853,
                  50.401068427000141
                ],
                [
                  -4.191477016999983,
                  50.417629299000012
                ],
                [
                  -4.183908657999922,
                  50.431708075000145
                ],
                [
                  -4.170318162999877,
                  50.445135809000035
                ],
                [
                  -4.15953528599988,
                  50.459418036000116
                ],
                [
                  -4.179432745999861,
                  50.45307038
                ],
                [
                  -4.189564581999917,
                  50.453680731000148
                ],
                [
                  -4.20055091099988,
                  50.459418036000116
                ],
                [
                  -4.203684048999946,
                  50.451402085
                ],
                [
                  -4.204741990999906,
                  50.448675848000121
                ],
                [
                  -4.212391730999855,
                  50.441473700000088
                ],
                [
                  -4.222523566999882,
                  50.437974350999987
                ],
                [
                  -4.234730597999885,
                  50.43829987200003
                ],
                [
                  -4.234730597999885,
                  50.432114976000051
                ],
                [
                  -4.22020423099994,
                  50.425848700000088
                ],
                [
                  -4.216135219999956,
                  50.415716864000146
                ],
                [
                  -4.219715949999852,
                  50.405096747000115
                ],
                [
                  -4.228505011999914,
                  50.397365627000099
                ],
                [
                  -4.241444464999916,
                  50.394680080000015
                ],
                [
                  -4.289906378999888,
                  50.397365627000099
                ],
                [
                  -4.273019985999895,
                  50.38190338700015
                ],
                [
                  -4.21617591099988,
                  50.387762762000122
                ],
                [
                  -4.193755662999934,
                  50.376898505000113
                ],
                [
                  -4.228505011999914,
                  50.370672919000171
                ],
                [
                  -4.228505011999914,
                  50.363836981000148
                ],
                [
                  -4.220122850999957,
                  50.365301825000117
                ],
                [
                  -4.20055091099988,
                  50.363836981000148
                ],
                [
                  -4.207997199999852,
                  50.35639069200009
                ],
                [
                  -4.180043097999914,
                  50.35639069200009
                ],
                [
                  -4.180043097999914,
                  50.350165106000119
                ],
                [
                  -4.191314256999903,
                  50.347560940000122
                ],
                [
                  -4.197987433999884,
                  50.342230536000059
                ],
                [
                  -4.199126756999903,
                  50.335394598000121
                ],
                [
                  -4.193755662999934,
                  50.328436591000141
                ],
                [
                  -4.193755662999934,
                  50.32225169499999
                ],
                [
                  -4.214995897999927,
                  50.32314687700007
                ],
                [
                  -4.225697394999941,
                  50.335394598000121
                ],
                [
                  -4.235096808999884,
                  50.349554755000057
                ],
                [
                  -4.252349412999905,
                  50.35639069200009
                ],
                [
                  -4.337717251999919,
                  50.370672919000171
                ],
                [
                  -4.383697068999908,
                  50.367499091000113
                ],
                [
                  -4.456206834999904,
                  50.338202216000084
                ],
                [
                  -4.495350714999859,
                  50.328436591000141
                ],
                [
                  -4.659820115999906,
                  50.32225169499999
                ],
                [
                  -4.659575975999957,
                  50.320624091000141
                ],
                [
                  -4.66270911399991,
                  50.317775783000016
                ],
                [
                  -4.667795376999948,
                  50.31533437700007
                ],
                [
                  -4.673451300999943,
                  50.315415757000054
                ],
                [
                  -4.687163865999878,
                  50.342718817000147
                ],
                [
                  -4.694325324999909,
                  50.343451239000061
                ],
                [
                  -4.700184699999852,
                  50.34088776200015
                ],
                [
                  -4.705555792999917,
                  50.337551174000126
                ],
                [
                  -4.711333787999877,
                  50.335882880000113
                ],
                [
                  -4.731556769999884,
                  50.334662177
                ],
                [
                  -4.752105272999927,
                  50.330308335000112
                ],
                [
                  -4.763295050999943,
                  50.322088934000121
                ],
                [
                  -4.755441860999952,
                  50.309230861000074
                ],
                [
                  -4.755441860999952,
                  50.30174388200011
                ],
                [
                  -4.762359178999873,
                  50.298041083000086
                ],
                [
                  -4.771636522999927,
                  50.291571356000176
                ],
                [
                  -4.779855923999918,
                  50.284328518000152
                ],
                [
                  -4.783355272999899,
                  50.277899481000034
                ],
                [
                  -4.78189042899993,
                  50.271795966000141
                ],
                [
                  -4.776519334999875,
                  50.265082098
                ],
                [
                  -4.776519334999875,
                  50.260809637000094
                ],
                [
                  -4.788441535999937,
                  50.242092190000122
                ],
                [
                  -4.790150519999941,
                  50.236558335000026
                ],
                [
                  -4.800160285999908,
                  50.229559637000037
                ],
                [
                  -4.849720831999946,
                  50.234564520000063
                ],
                [
                  -4.868723110999952,
                  50.229437567000062
                ],
                [
                  -4.887318488999938,
                  50.2149925800001
                ],
                [
                  -4.904774542999917,
                  50.208441473
                ],
                [
                  -4.947255011999886,
                  50.199367580000015
                ],
                [
                  -4.960682745999861,
                  50.19049713700015
                ],
                [
                  -5.002430792999917,
                  50.144110419000086
                ],
                [
                  -5.014556443999908,
                  50.156561591000028
                ],
                [
                  -5.020375128999945,
                  50.191961981000034
                ],
                [
                  -5.033192511999886,
                  50.199367580000015
                ],
                [
                  -5.05296790299991,
                  50.195786851000051
                ],
                [
                  -5.053618943999965,
                  50.186916408000101
                ],
                [
                  -5.051869269999969,
                  50.175523179000137
                ],
                [
                  -5.064564581999917,
                  50.164618231000148
                ],
                [
                  -5.064564581999917,
                  50.158392645
                ],
                [
                  -5.058501756999931,
                  50.155462958000086
                ],
                [
                  -5.043446417999917,
                  50.144110419000086
                ],
                [
                  -5.051869269999969,
                  50.144598700000088
                ],
                [
                  -5.058461066999939,
                  50.142726955000015
                ],
                [
                  -5.070790167999888,
                  50.137274481000176
                ],
                [
                  -5.080311652999882,
                  50.132717190000122
                ],
                [
                  -5.081613735999895,
                  50.125392971000124
                ],
                [
                  -5.080962693999936,
                  50.117173570000134
                ],
                [
                  -5.085031704999892,
                  50.109930731000119
                ],
                [
                  -5.093902147999927,
                  50.105536200000031
                ],
                [
                  -5.125965949999909,
                  50.09634023600016
                ],
                [
                  -5.114654100999928,
                  50.096625067
                ],
                [
                  -5.10606848899991,
                  50.09511953300013
                ],
                [
                  -5.091867641999897,
                  50.089504299000126
                ],
                [
                  -5.086903449999852,
                  50.089056708000143
                ],
                [
                  -5.075347459999932,
                  50.090480861000017
                ],
                [
                  -5.070790167999888,
                  50.089504299000126
                ],
                [
                  -5.068470831999917,
                  50.085150458000143
                ],
                [
                  -5.06493079299986,
                  50.071844794000029
                ],
                [
                  -5.060861782999893,
                  50.069037177000084
                ],
                [
                  -5.056507941999882,
                  50.060614325000031
                ],
                [
                  -5.069488084999875,
                  50.042181708
                ],
                [
                  -5.098052537999877,
                  50.014390367000104
                ],
                [
                  -5.107289191999939,
                  50.013006903000033
                ],
                [
                  -5.127430792999888,
                  50.015448309000178
                ],
                [
                  -5.139637824999852,
                  50.014390367000104
                ],
                [
                  -5.146473761999886,
                  50.010565497000115
                ],
                [
                  -5.176136847999914,
                  49.987941799000126
                ],
                [
                  -5.18773352799991,
                  49.964504299000069
                ],
                [
                  -5.191151495999918,
                  49.959133205000015
                ],
                [
                  -5.200103318999965,
                  49.961371161
                ],
                [
                  -5.2103572259999,
                  49.966742255000057
                ],
                [
                  -5.240386522999927,
                  49.988348700000145
                ],
                [
                  -5.245228644999912,
                  49.993109442000147
                ],
                [
                  -5.249501105999912,
                  50.000067450000031
                ],
                [
                  -5.253041144999912,
                  50.012640692000119
                ],
                [
                  -5.252268032999893,
                  50.020697333000058
                ],
                [
                  -5.252674933999884,
                  50.027777411000116
                ],
                [
                  -5.259755011999857,
                  50.037665106000034
                ],
                [
                  -5.288400844999927,
                  50.06769440300009
                ],
                [
                  -5.304351365999935,
                  50.080267645000063
                ],
                [
                  -5.32396399599989,
                  50.089504299000126
                ],
                [
                  -5.384185350999871,
                  50.107977606000148
                ],
                [
                  -5.424712693999879,
                  50.112738348000065
                ],
                [
                  -5.458119269999941,
                  50.125881252000013
                ],
                [
                  -5.474842902999882,
                  50.130438544000143
                ],
                [
                  -5.495676235999952,
                  50.129624742000047
                ],
                [
                  -5.521839972999914,
                  50.123724677000112
                ],
                [
                  -5.540923631999874,
                  50.11347077
                ],
                [
                  -5.540638800999943,
                  50.099758205000072
                ],
                [
                  -5.534657355999855,
                  50.082342841000084
                ],
                [
                  -5.545562303999901,
                  50.068915106000091
                ],
                [
                  -5.56346594999988,
                  50.059637762000065
                ],
                [
                  -5.578439907999893,
                  50.054754950000174
                ],
                [
                  -5.619455532999922,
                  50.046210028000147
                ],
                [
                  -5.667388475999928,
                  50.042873440000122
                ],
                [
                  -5.705148891999983,
                  50.052313544000143
                ],
                [
                  -5.715646938999953,
                  50.082709052000112
                ],
                [
                  -5.705962693999879,
                  50.083482164000131
                ],
                [
                  -5.698801235999952,
                  50.085394598000093
                ],
                [
                  -5.694488084999932,
                  50.089504299000126
                ],
                [
                  -5.694406704999949,
                  50.095770575000088
                ],
                [
                  -5.697092251999948,
                  50.10053131700009
                ],
                [
                  -5.700306769999912,
                  50.103216864000061
                ],
                [
                  -5.701975063999925,
                  50.103176174000069
                ],
                [
                  -5.707386847999942,
                  50.122015692000033
                ],
                [
                  -5.709217902999853,
                  50.132635809000149
                ],
                [
                  -5.705393032999922,
                  50.137274481000176
                ],
                [
                  -5.703521287999962,
                  50.140611070000105
                ],
                [
                  -5.684641079999921,
                  50.161525783000073
                ],
                [
                  -5.676747199999852,
                  50.165025132000054
                ],
                [
                  -5.647368943999936,
                  50.17206452000012
                ],
                [
                  -5.583607550999915,
                  50.195868231000034
                ],
                [
                  -5.54942786399991,
                  50.203517971000153
                ],
                [
                  -5.510975714999916,
                  50.219468492000075
                ],
                [
                  -5.489125128999888,
                  50.219794012000179
                ],
                [
                  -5.458119269999941,
                  50.200751044000086
                ],
                [
                  -5.437977667999917,
                  50.194322007
                ],
                [
                  -5.417388475999871,
                  50.20246002800009
                ],
                [
                  -5.40294348899991,
                  50.217352606000148
                ],
                [
                  -5.395863410999937,
                  50.227240302000055
                ],
                [
                  -5.39289303299995,
                  50.236558335000026
                ],
                [
                  -5.387562628999888,
                  50.240301825000031
                ],
                [
                  -5.351918097999914,
                  50.240301825000031
                ],
                [
                  -5.314849412999905,
                  50.253607489000061
                ],
                [
                  -5.200306769999912,
                  50.330755927000027
                ],
                [
                  -5.163563605999912,
                  50.347235419000086
                ],
                [
                  -5.149891730999883,
                  50.350165106000119
                ],
                [
                  -5.146473761999886,
                  50.355292059000035
                ],
                [
                  -5.145659959999875,
                  50.366888739000146
                ],
                [
                  -5.147043423999946,
                  50.379380601000051
                ],
                [
                  -5.153675910999908,
                  50.399481512000094
                ],
                [
                  -5.142404751999919,
                  50.404486395000148
                ],
                [
                  -5.127268032999922,
                  50.40521881700009
                ],
                [
                  -5.119740363999938,
                  50.404771225999987
                ],
                [
                  -5.05028235599994,
                  50.428697007000139
                ],
                [
                  -5.048166469999927,
                  50.43439362200003
                ],
                [
                  -5.038726365999906,
                  50.447902736000103
                ],
                [
                  -5.029774542999888,
                  50.486761786
                ],
                [
                  -5.028635219999927,
                  50.507025458000115
                ],
                [
                  -5.025257941999911,
                  50.52423737200003
                ],
                [
                  -5.015614386999857,
                  50.538031317000147
                ],
                [
                  -4.995594855999883,
                  50.54816315300009
                ],
                [
                  -4.975168423999918,
                  50.54816315300009
                ],
                [
                  -4.967844204999921,
                  50.551581122000115
                ],
                [
                  -4.954823370999918,
                  50.561224677000084
                ],
                [
                  -4.947255011999886,
                  50.56244538
                ],
                [
                  -4.941477016999897,
                  50.556952216000141
                ],
                [
                  -4.937123175999915,
                  50.545314846000153
                ],
                [
                  -4.934437628999945,
                  50.531642971000039
                ],
                [
                  -4.933583136999857,
                  50.520249742000047
                ],
                [
                  -4.926869269999884,
                  50.52289459800015
                ],
                [
                  -4.924305792999888,
                  50.524481512000179
                ],
                [
                  -4.920521613999966,
                  50.527655341000141
                ],
                [
                  -4.902414516999954,
                  50.520575262000179
                ],
                [
                  -4.860951300999943,
                  50.519191799000012
                ],
                [
                  -4.844838019999884,
                  50.514064846000096
                ],
                [
                  -4.855824347999942,
                  50.527411200000088
                ],
                [
                  -4.873280402999882,
                  50.534084377000156
                ],
                [
                  -4.906239386999857,
                  50.54197825700011
                ],
                [
                  -4.921864386999857,
                  50.554877020000148
                ],
                [
                  -4.920236782999922,
                  50.564154364
                ],
                [
                  -4.915191209999904,
                  50.572495835000055
                ],
                [
                  -4.920521613999966,
                  50.582953192000147
                ],
                [
                  -4.920521613999966,
                  50.58917877800009
                ],
                [
                  -4.895659959999904,
                  50.585923570000048
                ],
                [
                  -4.821197068999936,
                  50.58917877800009
                ],
                [
                  -4.792469855999883,
                  50.595200914000102
                ],
                [
                  -4.776600714999859,
                  50.609849351000108
                ],
                [
                  -4.765044725999928,
                  50.627997137000122
                ],
                [
                  -4.749256964999887,
                  50.644435940000037
                ],
                [
                  -4.755441860999952,
                  50.659369208000058
                ],
                [
                  -4.751942511999886,
                  50.670070705000072
                ],
                [
                  -4.74193274599989,
                  50.67487213700015
                ],
                [
                  -4.728138800999886,
                  50.672308661000059
                ],
                [
                  -4.657297329999892,
                  50.711127020000092
                ],
                [
                  -4.645578579999892,
                  50.723537502000013
                ],
                [
                  -4.637806769999884,
                  50.741156317000119
                ],
                [
                  -4.619007941999939,
                  50.75478750200007
                ],
                [
                  -4.577259894999912,
                  50.774725653000147
                ],
                [
                  -4.550119594999984,
                  50.809556382000025
                ],
                [
                  -4.554921027999882,
                  50.89777252800009
                ],
                [
                  -4.543771938999953,
                  50.939195054000024
                ],
                [
                  -4.536854620999861,
                  50.947577216000141
                ],
                [
                  -4.522694464999916,
                  50.97272370000006
                ],
                [
                  -4.526682094999899,
                  50.980373440000065
                ],
                [
                  -4.530425584999932,
                  50.994696356000148
                ],
                [
                  -4.531320766999926,
                  51.008693752000013
                ],
                [
                  -4.526437954999949,
                  51.014960028000147
                ],
                [
                  -4.437326626999891,
                  51.014960028000147
                ],
                [
                  -4.426421678999901,
                  51.012681382
                ],
                [
                  -4.405751105999883,
                  51.002875067000062
                ],
                [
                  -4.395741339999916,
                  51.000677802000084
                ],
                [
                  -4.337717251999919,
                  50.996649481000091
                ],
                [
                  -4.317290818999879,
                  51.000677802000084
                ],
                [
                  -4.302316860999923,
                  51.007513739
                ],
                [
                  -4.234730597999885,
                  51.055324611000046
                ],
                [
                  -4.229156053999873,
                  51.061102606000091
                ],
                [
                  -4.224680141999897,
                  51.067084052000027
                ],
                [
                  -4.218495245999918,
                  51.072455145000063
                ],
                [
                  -4.207997199999852,
                  51.076361395000063
                ],
                [
                  -4.2142634759999,
                  51.086004950000031
                ],
                [
                  -4.226307745999918,
                  51.113226630000113
                ],
                [
                  -4.228505011999914,
                  51.120428778000147
                ],
                [
                  -4.231922980999912,
                  51.126695054000109
                ],
                [
                  -4.24901282499988,
                  51.142889716000141
                ],
                [
                  -4.255767381999903,
                  51.151516018000066
                ],
                [
                  -4.222320115999935,
                  51.149725653000175
                ],
                [
                  -4.214833136999886,
                  51.151516018000066
                ],
                [
                  -4.20836341099988,
                  51.162298895000063
                ],
                [
                  -4.209828253999916,
                  51.172837632000139
                ],
                [
                  -4.217274542999917,
                  51.181382554000052
                ],
                [
                  -4.228505011999914,
                  51.186224677000141
                ],
                [
                  -4.228505011999914,
                  51.192450262000094
                ],
                [
                  -4.152333136999857,
                  51.211615302000055
                ],
                [
                  -3.969471808999856,
                  51.222398179000052
                ],
                [
                  -3.931996222999914,
                  51.231350002000099
                ],
                [
                  -3.913197394999884,
                  51.23338450700011
                ],
                [
                  -3.840891079999921,
                  51.23338450700011
                ],
                [
                  -3.818959113999881,
                  51.236070054
                ],
                [
                  -3.787098761999857,
                  51.246771552000112
                ],
                [
                  -3.769154425999915,
                  51.247707424000012
                ],
                [
                  -3.639759894999941,
                  51.226385809000035
                ],
                [
                  -3.559315558999884,
                  51.228094794000143
                ],
                [
                  -3.434193488999938,
                  51.209784247000172
                ],
                [
                  -3.404367641999926,
                  51.192043361000074
                ],
                [
                  -3.38499915299991,
                  51.186224677000141
                ],
                [
                  -3.270741339999859,
                  51.189398505
                ],
                [
                  -3.198882615999878,
                  51.203558661000116
                ],
                [
                  -3.162749803999958,
                  51.206732489000089
                ],
                [
                  -3.096750454999921,
                  51.204535223
                ],
                [
                  -3.057525193999908,
                  51.208156643000152
                ],
                [
                  -3.029286261999857,
                  51.220404364000117
                ],
                [
                  -3.021839972999942,
                  51.213568427000027
                ],
                [
                  -3.035552537999877,
                  51.199286200000117
                ],
                [
                  -3.021839972999942,
                  51.192450262000094
                ],
                [
                  -3.004790818999908,
                  51.213120835000112
                ],
                [
                  -3.001332160999908,
                  51.220404364000117
                ],
                [
                  -2.999582485999923,
                  51.233221747000144
                ],
                [
                  -3.001535610999952,
                  51.239691473000065
                ],
                [
                  -3.004994269999941,
                  51.245062567000119
                ],
                [
                  -3.008168097999914,
                  51.254543361000017
                ],
                [
                  -3.007639126999948,
                  51.291978257000054
                ],
                [
                  -3.010609503999945,
                  51.310980536000059
                ],
                [
                  -3.021839972999942,
                  51.322821356000119
                ],
                [
                  -3.00243079299986,
                  51.31907786699999
                ],
                [
                  -2.992176886999914,
                  51.321926174000126
                ],
                [
                  -2.992095506999931,
                  51.322048244000101
                ],
                [
                  -2.988392706999889,
                  51.331122137000094
                ],
                [
                  -2.987782355999855,
                  51.346665757000025
                ],
                [
                  -2.979888475999871,
                  51.355861721000068
                ],
                [
                  -2.965972459999904,
                  51.364935614000089
                ],
                [
                  -2.959584113999881,
                  51.374253648000106
                ],
                [
                  -2.974680141999954,
                  51.384222723
                ],
                [
                  -2.952951626999891,
                  51.398504950000117
                ],
                [
                  -2.921009894999884,
                  51.39443594000015
                ],
                [
                  -2.884185350999928,
                  51.416978257000139
                ],
                [
                  -2.816395636999914,
                  51.47361888200011
                ],
                [
                  -2.798573370999918,
                  51.482611395000148
                ],
                [
                  -2.780873175999915,
                  51.489081122000144
                ],
                [
                  -2.761219855999883,
                  51.492865302000084
                ],
                [
                  -2.737619594999927,
                  51.494086005
                ],
                [
                  -2.716420050999943,
                  51.499579169000114
                ],
                [
                  -2.696156378999916,
                  51.512640692
                ],
                [
                  -2.607818162999877,
                  51.607367255000085
                ],
                [
                  -2.599598761999886,
                  51.611395575000031
                ],
                [
                  -2.58922278599988,
                  51.614243882000082
                ],
                [
                  -2.580433722999914,
                  51.618638414000159
                ],
                [
                  -2.576812303999958,
                  51.627508856000119
                ],
                [
                  -2.57445227799991,
                  51.63572825700011
                ],
                [
                  -2.568959113999881,
                  51.644964911000059
                ],
                [
                  -2.562245245999918,
                  51.653387762000122
                ],
                [
                  -2.55638587099989,
                  51.65924713700015
                ],
                [
                  -2.499175584999904,
                  51.696763414000159
                ],
                [
                  -2.464995897999927,
                  51.725897528000033
                ],
                [
                  -2.447743292999917,
                  51.73187897300015
                ],
                [
                  -2.404896613999938,
                  51.741156317
                ],
                [
                  -2.388539191999911,
                  51.750433661000059
                ],
                [
                  -2.380767381999931,
                  51.76190827
                ],
                [
                  -2.383371548999918,
                  51.773260809000178
                ],
                [
                  -2.398060675999915,
                  51.782131252000127
                ],
                [
                  -2.402414516999897,
                  51.763576565000122
                ],
                [
                  -2.42039954299986,
                  51.753119208000143
                ],
                [
                  -2.443430141999926,
                  51.748439846000124
                ],
                [
                  -2.463286912999934,
                  51.74730052299999
                ],
                [
                  -2.482085740999878,
                  51.742865302000112
                ],
                [
                  -2.49583899599989,
                  51.732001044000029
                ],
                [
                  -2.507964647999899,
                  51.718573309000035
                ],
                [
                  -2.522124803999901,
                  51.706366278000147
                ],
                [
                  -2.581695115999906,
                  51.681708075000145
                ],
                [
                  -2.591135219999927,
                  51.675360419000029
                ],
                [
                  -2.600209113999938,
                  51.665594794000086
                ],
                [
                  -2.665322474518433,
                  51.617278320788856
                ],
                [
                  -2.665353969999956,
                  51.617254950000174
                ],
                [
                  -2.693755662999877,
                  51.596177476000051
                ],
                [
                  -2.71312415299991,
                  51.586615302000084
                ],
                [
                  -2.760487433999856,
                  51.579779364000061
                ],
                [
                  -2.798085089999859,
                  51.56350332200013
                ],
                [
                  -2.816395636999914,
                  51.555568752000156
                ],
                [
                  -2.858713344999899,
                  51.54612864800005
                ],
                [
                  -2.943348761999914,
                  51.542547919000171
                ],
                [
                  -2.956288214999916,
                  51.54572174700003
                ],
                [
                  -2.964100714999916,
                  51.552801825000088
                ],
                [
                  -2.969471808999884,
                  51.559881903000147
                ],
                [
                  -2.974680141999954,
                  51.562974351000051
                ],
                [
                  -2.984038865999906,
                  51.558539130000085
                ],
                [
                  -3.01024329299986,
                  51.538031317000119
                ],
                [
                  -3.015695766999897,
                  51.531642971000096
                ],
                [
                  -3.073719855999855,
                  51.508368231000176
                ],
                [
                  -3.076486782999922,
                  51.507757880000113
                ],
                [
                  -3.088937954999921,
                  51.505072333000143
                ],
                [
                  -3.10562089799987,
                  51.497219143000066
                ],
                [
                  -3.131703253999945,
                  51.480414130000057
                ],
                [
                  -3.13508053299995,
                  51.476304429000024
                ],
                [
                  -3.140939907999893,
                  51.464789130000057
                ],
                [
                  -3.145375128999888,
                  51.459947007
                ],
                [
                  -3.152414516999926,
                  51.457180080000128
                ],
                [
                  -3.16665605399993,
                  51.456000067
                ],
                [
                  -3.172393357999908,
                  51.453273830000128
                ],
                [
                  -3.172718878999945,
                  51.453111070000077
                ],
                [
                  -3.160064256999874,
                  51.431830145
                ],
                [
                  -3.167144334999932,
                  51.410467841000056
                ],
                [
                  -3.184803839999859,
                  51.397609768
                ],
                [
                  -3.204009568999908,
                  51.40159739799999
                ],
                [
                  -3.218861456999946,
                  51.402777411000116
                ],
                [
                  -3.289418097999942,
                  51.384222723
                ],
                [
                  -3.539173956999946,
                  51.398504950000117
                ],
                [
                  -3.557443813999896,
                  51.405096747000172
                ],
                [
                  -3.575306769999884,
                  51.420436916000128
                ],
                [
                  -3.604725714999859,
                  51.445705471000096
                ],
                [
                  -3.663197394999941,
                  51.476223049000041
                ],
                [
                  -3.676991339999859,
                  51.477036851000136
                ],
                [
                  -3.695423956999889,
                  51.471502997000115
                ],
                [
                  -3.717925584999875,
                  51.478583075000174
                ],
                [
                  -3.737619594999899,
                  51.490871486000131
                ],
                [
                  -3.748036261999914,
                  51.500921942
                ],
                [
                  -3.749419725999871,
                  51.505357164000159
                ],
                [
                  -3.747670050999886,
                  51.507025458
                ],
                [
                  -3.744536912999905,
                  51.507635809000149
                ],
                [
                  -3.741851365999935,
                  51.508368231000176
                ],
                [
                  -3.749338344999899,
                  51.528062242000132
                ],
                [
                  -3.751901821999894,
                  51.533067124000169
                ],
                [
                  -3.758941209999875,
                  51.546779690000093
                ],
                [
                  -3.770130988999881,
                  51.563299872000172
                ],
                [
                  -3.78221594999988,
                  51.576646225999987
                ],
                [
                  -3.790272589999916,
                  51.581976630000142
                ],
                [
                  -3.807728644999884,
                  51.589178778000175
                ],
                [
                  -3.816965298999946,
                  51.596502997000087
                ],
                [
                  -3.832671678999901,
                  51.61554596600017
                ],
                [
                  -3.841623501999948,
                  51.621527411
                ],
                [
                  -3.854888475999871,
                  51.623846747000144
                ],
                [
                  -3.886789516999897,
                  51.621405341000028
                ],
                [
                  -3.962391730999883,
                  51.615627346000153
                ],
                [
                  -3.976633266999897,
                  51.611883856000034
                ],
                [
                  -3.989979620999918,
                  51.60651276200015
                ],
                [
                  -3.998768683999884,
                  51.600287177000112
                ],
                [
                  -3.999908006999903,
                  51.590887762000179
                ],
                [
                  -3.992258266999897,
                  51.581122137000037
                ],
                [
                  -3.981800910999908,
                  51.571600653000147
                ],
                [
                  -3.974598761999886,
                  51.562974351000051
                ],
                [
                  -4.016184048999946,
                  51.562974351000051
                ],
                [
                  -4.01610266799986,
                  51.560370184000064
                ],
                [
                  -4.020822719999956,
                  51.555853583
                ],
                [
                  -4.026519334999961,
                  51.554022528000118
                ],
                [
                  -4.029204881999931,
                  51.559271552
                ],
                [
                  -4.031971808999884,
                  51.563137111000017
                ],
                [
                  -4.038563605999883,
                  51.566229559000092
                ],
                [
                  -4.046457485999923,
                  51.568426825000174
                ],
                [
                  -4.053130662999905,
                  51.569240627000099
                ],
                [
                  -4.056304490999878,
                  51.567043361000103
                ],
                [
                  -4.065581834999904,
                  51.557562567
                ],
                [
                  -4.070220506999931,
                  51.555568752000156
                ],
                [
                  -4.076812303999901,
                  51.556952216000056
                ],
                [
                  -4.087269660999908,
                  51.561916408000101
                ],
                [
                  -4.112131313999925,
                  51.565619208000115
                ],
                [
                  -4.121652798999946,
                  51.565985419000143
                ],
                [
                  -4.132191535999908,
                  51.562974351000051
                ],
                [
                  -4.14273027299987,
                  51.556952216000056
                ],
                [
                  -4.15680904899989,
                  51.546291408000016
                ],
                [
                  -4.166411912999877,
                  51.542547919000171
                ],
                [
                  -4.176503058999856,
                  51.544256903000175
                ],
                [
                  -4.187733527999853,
                  51.548773505000113
                ],
                [
                  -4.196766730999855,
                  51.549383856000091
                ],
                [
                  -4.20055091099988,
                  51.538763739000146
                ],
                [
                  -4.213368292999917,
                  51.539129950000145
                ],
                [
                  -4.272450324999852,
                  51.554754950000145
                ],
                [
                  -4.289906378999888,
                  51.555568752000156
                ],
                [
                  -4.293324347999914,
                  51.559149481000034
                ],
                [
                  -4.295155402999882,
                  51.561957098000093
                ],
                [
                  -4.297352667999888,
                  51.569240627000099
                ],
                [
                  -4.27830969999988,
                  51.578192450000031
                ],
                [
                  -4.280832485999895,
                  51.588812567000062
                ],
                [
                  -4.28970292899993,
                  51.601548570000105
                ],
                [
                  -4.289906378999888,
                  51.617010809000035
                ],
                [
                  -4.255767381999903,
                  51.623846747000144
                ],
                [
                  -4.252023891999954,
                  51.627101955000015
                ],
                [
                  -4.241281704999949,
                  51.639349677000084
                ],
                [
                  -4.234730597999885,
                  51.644964911000059
                ],
                [
                  -4.228505011999914,
                  51.637437242000104
                ],
                [
                  -4.234730597999885,
                  51.637437242000104
                ],
                [
                  -4.234730597999885,
                  51.631293036000116
                ],
                [
                  -4.227853969999956,
                  51.628119208000058
                ],
                [
                  -4.22101803299995,
                  51.623846747000144
                ],
                [
                  -4.190093553999901,
                  51.630275783000073
                ],
                [
                  -4.139027472999914,
                  51.632310289000188
                ],
                [
                  -4.091297980999855,
                  51.63987864800005
                ],
                [
                  -4.070220506999931,
                  51.662298895000063
                ],
                [
                  -4.069813605999855,
                  51.66893138200011
                ],
                [
                  -4.070383266999897,
                  51.674302475999987
                ],
                [
                  -4.070546027999882,
                  51.67597077
                ],
                [
                  -4.075428839999944,
                  51.677801825000174
                ],
                [
                  -4.087269660999908,
                  51.668850002000127
                ],
                [
                  -4.09544837099989,
                  51.665106512000094
                ],
                [
                  -4.106841600999871,
                  51.66425202
                ],
                [
                  -4.146351691999911,
                  51.66705963700015
                ],
                [
                  -4.20055091099988,
                  51.685858466000113
                ],
                [
                  -4.214955206999946,
                  51.679673570000134
                ],
                [
                  -4.293690558999913,
                  51.672267971000153
                ],
                [
                  -4.315297003999916,
                  51.677476304000052
                ],
                [
                  -4.342355923999946,
                  51.69086334800015
                ],
                [
                  -4.366444464999887,
                  51.708482164000159
                ],
                [
                  -4.379261847999914,
                  51.726874091000113
                ],
                [
                  -4.33804277299987,
                  51.723334052000141
                ],
                [
                  -4.319976365999935,
                  51.724839585
                ],
                [
                  -4.310454881999931,
                  51.733710028000033
                ],
                [
                  -4.32872473899991,
                  51.732977606000091
                ],
                [
                  -4.347157355999855,
                  51.73578522300015
                ],
                [
                  -4.362538214999887,
                  51.742865302000112
                ],
                [
                  -4.371815558999856,
                  51.754787502000156
                ],
                [
                  -4.368763800999943,
                  51.756984768000152
                ],
                [
                  -4.362904425999915,
                  51.763861395000148
                ],
                [
                  -4.358021613999938,
                  51.773138739
                ],
                [
                  -4.358225063999896,
                  51.782131252000127
                ],
                [
                  -4.365101691999911,
                  51.789048570000134
                ],
                [
                  -4.371490037999905,
                  51.785956122000059
                ],
                [
                  -4.379261847999914,
                  51.775295315
                ],
                [
                  -4.384917772999899,
                  51.771877346000011
                ],
                [
                  -4.392974412999934,
                  51.763739325000174
                ],
                [
                  -4.399159308999913,
                  51.761623440000065
                ],
                [
                  -4.409331834999875,
                  51.763169664000102
                ],
                [
                  -4.417876756999874,
                  51.767889716000028
                ],
                [
                  -4.426503058999884,
                  51.775295315
                ],
                [
                  -4.445790167999917,
                  51.773260809000178
                ],
                [
                  -4.449330206999917,
                  51.766302802
                ],
                [
                  -4.441395636999857,
                  51.756781317
                ],
                [
                  -4.426503058999884,
                  51.74730052299999
                ],
                [
                  -4.460764126999948,
                  51.73578522300015
                ],
                [
                  -4.498890753999945,
                  51.734849351000079
                ],
                [
                  -4.574208136999914,
                  51.741156317
                ],
                [
                  -4.603423631999931,
                  51.739243882000054
                ],
                [
                  -4.639230923999946,
                  51.733181057000152
                ],
                [
                  -4.645375128999945,
                  51.732123114
                ],
                [
                  -4.678212042999945,
                  51.717433986000103
                ],
                [
                  -4.680287238999938,
                  51.692694403000033
                ],
                [
                  -4.689442511999857,
                  51.691595770000092
                ],
                [
                  -4.691639777999939,
                  51.689886786000088
                ],
                [
                  -4.691639777999939,
                  51.685980536000088
                ],
                [
                  -4.693959113999881,
                  51.678412177000112
                ],
                [
                  -4.712310350999928,
                  51.650091864000089
                ],
                [
                  -4.721424933999856,
                  51.652044989000117
                ],
                [
                  -4.734934048999918,
                  51.65924713700015
                ],
                [
                  -4.741851365999906,
                  51.656073309000092
                ],
                [
                  -4.7591853509999,
                  51.644964911000059
                ],
                [
                  -4.848296678999873,
                  51.646307684000149
                ],
                [
                  -4.863514777999853,
                  51.644110419000171
                ],
                [
                  -4.878977016999954,
                  51.637437242000104
                ],
                [
                  -4.887806769999941,
                  51.629950262000037
                ],
                [
                  -4.895741339999887,
                  51.62107982000002
                ],
                [
                  -4.904774542999917,
                  51.613836981000176
                ],
                [
                  -4.923695441999911,
                  51.60862864799999
                ],
                [
                  -4.931996222999914,
                  51.599025783000101
                ],
                [
                  -4.941029425999915,
                  51.596502997000087
                ],
                [
                  -4.946034308999856,
                  51.597601630000113
                ],
                [
                  -4.956450975999928,
                  51.602769273000135
                ],
                [
                  -5.021595831999974,
                  51.616034247000144
                ],
                [
                  -5.045765753999888,
                  51.626898505000057
                ],
                [
                  -5.036610480999883,
                  51.637437242000104
                ],
                [
                  -5.051177537999934,
                  51.656927802
                ],
                [
                  -5.100493943999908,
                  51.664699611000103
                ],
                [
                  -5.119740363999938,
                  51.678412177000112
                ],
                [
                  -5.113433397999927,
                  51.685288804000137
                ],
                [
                  -5.036610480999883,
                  51.678412177000112
                ],
                [
                  -5.038726365999906,
                  51.68183014500012
                ],
                [
                  -5.041330532999893,
                  51.689398505
                ],
                [
                  -5.043446417999917,
                  51.692694403000033
                ],
                [
                  -5.028675910999937,
                  51.692938544000171
                ],
                [
                  -5.002552863999881,
                  51.68740469000015
                ],
                [
                  -4.988189256999903,
                  51.685858466000113
                ],
                [
                  -4.974598761999857,
                  51.687933661000116
                ],
                [
                  -4.941029425999915,
                  51.700140692
                ],
                [
                  -4.892648891999897,
                  51.706366278000147
                ],
                [
                  -4.868275519999941,
                  51.716782945000048
                ],
                [
                  -4.858062303999901,
                  51.718329169000086
                ],
                [
                  -4.844838019999884,
                  51.713812567000119
                ],
                [
                  -4.844838019999884,
                  51.72003815300009
                ],
                [
                  -4.87340247299997,
                  51.737738348
                ],
                [
                  -4.879017706999946,
                  51.76203034100017
                ],
                [
                  -4.862538214999887,
                  51.782375393000066
                ],
                [
                  -4.824330206999917,
                  51.788275458
                ],
                [
                  -4.824330206999917,
                  51.795721747000172
                ],
                [
                  -4.836008266999926,
                  51.790716864000146
                ],
                [
                  -4.864979620999918,
                  51.783270575000145
                ],
                [
                  -4.921294725999871,
                  51.780015367000104
                ],
                [
                  -4.933583136999857,
                  51.775295315
                ],
                [
                  -4.917225714999916,
                  51.775336005
                ],
                [
                  -4.905181443999908,
                  51.771185614000061
                ],
                [
                  -4.900542772999899,
                  51.762111721000153
                ],
                [
                  -4.906239386999857,
                  51.74730052299999
                ],
                [
                  -4.892079230999855,
                  51.739406643
                ],
                [
                  -4.895659959999904,
                  51.728176174000012
                ],
                [
                  -4.910552537999877,
                  51.718207098000121
                ],
                [
                  -4.988189256999903,
                  51.706854559000064
                ],
                [
                  -5.00991777299987,
                  51.706366278000147
                ],
                [
                  -5.149240688999925,
                  51.718085028000147
                ],
                [
                  -5.166900193999936,
                  51.713812567000119
                ],
                [
                  -5.156971808999856,
                  51.697577216000084
                ],
                [
                  -5.16860917899993,
                  51.688910223
                ],
                [
                  -5.182850714999859,
                  51.689276434000121
                ],
                [
                  -5.180653449999852,
                  51.700140692
                ],
                [
                  -5.180653449999852,
                  51.706366278000147
                ],
                [
                  -5.230132615999906,
                  51.730047919000171
                ],
                [
                  -5.249501105999912,
                  51.733710028000033
                ],
                [
                  -5.228138800999886,
                  51.733954169000171
                ],
                [
                  -5.213937954999949,
                  51.735744533000158
                ],
                [
                  -5.202870245999918,
                  51.740790106000091
                ],
                [
                  -5.191151495999918,
                  51.751044012000122
                ],
                [
                  -5.176828579999949,
                  51.759670315000122
                ],
                [
                  -5.14321855399993,
                  51.763861395000148
                ],
                [
                  -5.125965949999909,
                  51.76850006700009
                ],
                [
                  -5.110259568999936,
                  51.778509833000058
                ],
                [
                  -5.107085740999878,
                  51.788072007000054
                ],
                [
                  -5.11229407499988,
                  51.813177802000141
                ],
                [
                  -5.113392706999917,
                  51.828802802000112
                ],
                [
                  -5.117502407999979,
                  51.843695380000085
                ],
                [
                  -5.125884568999936,
                  51.856024481000034
                ],
                [
                  -5.139637824999852,
                  51.86399974199999
                ],
                [
                  -5.146473761999886,
                  51.857163804000052
                ],
                [
                  -5.164377407999922,
                  51.866766669000057
                ],
                [
                  -5.203765428999901,
                  51.870184637000065
                ],
                [
                  -5.221587693999879,
                  51.877671617000104
                ],
                [
                  -5.235829230999883,
                  51.871039130000057
                ],
                [
                  -5.291411912999934,
                  51.86399974199999
                ],
                [
                  -5.310943162999905,
                  51.86399974199999
                ],
                [
                  -5.304269985999952,
                  51.867621161000145
                ],
                [
                  -5.29735266799986,
                  51.870184637000065
                ],
                [
                  -5.29735266799986,
                  51.877671617000104
                ],
                [
                  -5.300689256999874,
                  51.88202545800003
                ],
                [
                  -5.302561001999948,
                  51.885239976000079
                ],
                [
                  -5.300160285999908,
                  51.888332424000154
                ],
                [
                  -5.290516730999855,
                  51.891994533000101
                ],
                [
                  -5.290516730999855,
                  51.898138739000089
                ],
                [
                  -5.298329230999912,
                  51.910956122000115
                ],
                [
                  -5.288929816999911,
                  51.916937567000119
                ],
                [
                  -5.252837693999936,
                  51.918646552000141
                ],
                [
                  -5.234201626999948,
                  51.923041083000115
                ],
                [
                  -5.204172329999921,
                  51.942287502000156
                ],
                [
                  -5.191151495999918,
                  51.946600653000147
                ],
                [
                  -5.160389777999853,
                  51.949448960000026
                ],
                [
                  -5.119536912999905,
                  51.958929755000113
                ],
                [
                  -5.088042772999899,
                  51.97601959800015
                ],
                [
                  -5.085031704999892,
                  52.001857815000065
                ],
                [
                  -5.070790167999888,
                  52.001857815000065
                ],
                [
                  -5.070790167999888,
                  52.00804271000014
                ],
                [
                  -5.082753058999913,
                  52.014471747000144
                ],
                [
                  -5.081206834999875,
                  52.021185614
                ],
                [
                  -5.070220506999903,
                  52.02635325700011
                ],
                [
                  -5.053700324999852,
                  52.02850983300003
                ],
                [
                  -5.026600714999916,
                  52.027411200000145
                ],
                [
                  -5.0150447259999,
                  52.025336005000142
                ],
                [
                  -4.961740688999925,
                  52.007513739000061
                ],
                [
                  -4.942534959999875,
                  52.007473049000069
                ],
                [
                  -4.913685675999943,
                  52.014837958000086
                ],
                [
                  -4.920521613999966,
                  52.02850983300003
                ],
                [
                  -4.901600714999859,
                  52.026434637000179
                ],
                [
                  -4.863189256999931,
                  52.016994533000073
                ],
                [
                  -4.841420050999972,
                  52.014837958000086
                ],
                [
                  -4.832264777999882,
                  52.018988348
                ],
                [
                  -4.833851691999911,
                  52.02875397300015
                ],
                [
                  -4.838286912999905,
                  52.040106512000122
                ],
                [
                  -4.838002081999946,
                  52.049017645000063
                ],
                [
                  -4.830393032999922,
                  52.052923895000063
                ],
                [
                  -4.796986456999946,
                  52.056463934000035
                ],
                [
                  -4.777577277999853,
                  52.064886786
                ],
                [
                  -4.763172980999883,
                  52.075873114000146
                ],
                [
                  -4.738677537999934,
                  52.100816148000078
                ],
                [
                  -4.720285610999895,
                  52.113348700000174
                ],
                [
                  -4.706532355999883,
                  52.113470770000148
                ],
                [
                  -4.673451300999943,
                  52.097398179000081
                ],
                [
                  -4.675689256999931,
                  52.126939195000134
                ],
                [
                  -4.637521938999953,
                  52.138495184000149
                ],
                [
                  -4.51382402299987,
                  52.135687567
                ],
                [
                  -4.50226803299995,
                  52.138373114000089
                ],
                [
                  -4.495757615999878,
                  52.143500067
                ],
                [
                  -4.490956183999884,
                  52.150376695000105
                ],
                [
                  -4.484283006999903,
                  52.156317450000031
                ],
                [
                  -4.454701300999943,
                  52.162054755
                ],
                [
                  -4.434803839999859,
                  52.170355536000088
                ],
                [
                  -4.415394660999965,
                  52.181545315000093
                ],
                [
                  -4.385568813999953,
                  52.203436591000028
                ],
                [
                  -4.37124589799987,
                  52.20929596600017
                ],
                [
                  -4.354725714999887,
                  52.212103583000115
                ],
                [
                  -4.334339972999914,
                  52.212836005000057
                ],
                [
                  -4.3158259759999,
                  52.216294664000046
                ],
                [
                  -4.197132941999882,
                  52.279282945000077
                ],
                [
                  -4.139068162999905,
                  52.330226955000072
                ],
                [
                  -4.10960852799991,
                  52.365301825000145
                ],
                [
                  -4.096262173999918,
                  52.387884833000143
                ],
                [
                  -4.087391730999883,
                  52.430121161000059
                ],
                [
                  -4.078968878999916,
                  52.453029690000065
                ],
                [
                  -4.067941860999952,
                  52.473618882
                ],
                [
                  -4.056548631999903,
                  52.487860419000114
                ],
                [
                  -4.061838344999984,
                  52.497056382000082
                ],
                [
                  -4.064035610999952,
                  52.509182033000073
                ],
                [
                  -4.062570766999897,
                  52.520982164000046
                ],
                [
                  -4.056548631999903,
                  52.529445705000072
                ],
                [
                  -4.048491990999878,
                  52.530462958000143
                ],
                [
                  -4.026600714999944,
                  52.523382880000085
                ],
                [
                  -4.016184048999946,
                  52.521958726000108
                ],
                [
                  -3.998768683999884,
                  52.525946356000091
                ],
                [
                  -3.947336391999983,
                  52.549261786
                ],
                [
                  -3.947336391999983,
                  52.556708075000174
                ],
                [
                  -3.974476691999911,
                  52.556545315
                ],
                [
                  -4.025868292999917,
                  52.545355536
                ],
                [
                  -4.053130662999905,
                  52.542425848000065
                ],
                [
                  -4.068470831999946,
                  52.55011627800009
                ],
                [
                  -4.114125128999888,
                  52.58860911699999
                ],
                [
                  -4.12547766799986,
                  52.603908596000153
                ],
                [
                  -4.122222459999904,
                  52.628729559000092
                ],
                [
                  -4.105946417999888,
                  52.653509833000058
                ],
                [
                  -4.084828253999945,
                  52.67267487200003
                ],
                [
                  -4.067128058999856,
                  52.680243231000176
                ],
                [
                  -4.063547329999892,
                  52.683091539000131
                ],
                [
                  -4.058827277999882,
                  52.69660065300009
                ],
                [
                  -4.056548631999903,
                  52.700669664000046
                ],
                [
                  -4.052723761999886,
                  52.702215887000094
                ],
                [
                  -4.04198157499988,
                  52.704657294000029
                ],
                [
                  -4.001088019999941,
                  52.724107164000131
                ],
                [
                  -3.988270636999914,
                  52.734279690000065
                ],
                [
                  -4.014719204999892,
                  52.732326565000122
                ],
                [
                  -4.031971808999884,
                  52.723944403000147
                ],
                [
                  -4.048817511999886,
                  52.721584377000013
                ],
                [
                  -4.125152147999927,
                  52.778306382
                ],
                [
                  -4.144357876999891,
                  52.802801825000117
                ],
                [
                  -4.14903723899991,
                  52.812079169000171
                ],
                [
                  -4.146229620999861,
                  52.820217190000093
                ],
                [
                  -4.128895636999857,
                  52.823635158000101
                ],
                [
                  -4.117339647999927,
                  52.830755927000055
                ],
                [
                  -4.119781053999873,
                  52.846258856000148
                ],
                [
                  -4.127756313999925,
                  52.861721096000096
                ],
                [
                  -4.132191535999908,
                  52.868312893000152
                ],
                [
                  -4.131988084999932,
                  52.882473049000069
                ],
                [
                  -4.129872199999852,
                  52.889227606000119
                ],
                [
                  -4.12360592399989,
                  52.893255927
                ],
                [
                  -4.064035610999952,
                  52.91917552299999
                ],
                [
                  -4.071400519999884,
                  52.921087958000143
                ],
                [
                  -4.074574347999942,
                  52.922796942000147
                ],
                [
                  -4.077626105999912,
                  52.926662502000156
                ],
                [
                  -4.089100714999887,
                  52.918850002000156
                ],
                [
                  -4.100493943999936,
                  52.914129950000145
                ],
                [
                  -4.110585089999887,
                  52.915676174000097
                ],
                [
                  -4.118560350999871,
                  52.926662502000156
                ],
                [
                  -4.144398566999882,
                  52.914780992000104
                ],
                [
                  -4.17162024599989,
                  52.913478908000016
                ],
                [
                  -4.228505011999914,
                  52.91917552299999
                ],
                [
                  -4.300689256999903,
                  52.905585028000033
                ],
                [
                  -4.317290818999879,
                  52.899359442000062
                ],
                [
                  -4.337310350999928,
                  52.892035223000065
                ],
                [
                  -4.406605597999885,
                  52.892523505000057
                ],
                [
                  -4.427235480999912,
                  52.885972398000078
                ],
                [
                  -4.446197068999936,
                  52.875921942
                ],
                [
                  -4.481678839999916,
                  52.85089752800009
                ],
                [
                  -4.4779353509999,
                  52.848334052000084
                ],
                [
                  -4.475493943999936,
                  52.844142971000153
                ],
                [
                  -4.491363084999875,
                  52.838202216000028
                ],
                [
                  -4.500965949999852,
                  52.82680898600016
                ],
                [
                  -4.50133216099988,
                  52.81391022300015
                ],
                [
                  -4.489125128999888,
                  52.803168036000116
                ],
                [
                  -4.501942511999914,
                  52.794989325000031
                ],
                [
                  -4.509185350999871,
                  52.791449286000145
                ],
                [
                  -4.516468878999973,
                  52.789496161
                ],
                [
                  -4.528553839999887,
                  52.790472723000065
                ],
                [
                  -4.542469855999855,
                  52.80068594
                ],
                [
                  -4.563954230999883,
                  52.805243231000148
                ],
                [
                  -4.583078579999949,
                  52.814642645000092
                ],
                [
                  -4.594634568999879,
                  52.816799221000068
                ],
                [
                  -4.606516079999921,
                  52.815090236000074
                ],
                [
                  -4.61351477799991,
                  52.811102606000091
                ],
                [
                  -4.619211391999897,
                  52.80654531500015
                ],
                [
                  -4.626332160999937,
                  52.803168036000116
                ],
                [
                  -4.648589647999899,
                  52.799627997000144
                ],
                [
                  -4.704497850999871,
                  52.803168036000116
                ],
                [
                  -4.719309048999918,
                  52.797512111000131
                ],
                [
                  -4.733225063999896,
                  52.787502346000153
                ],
                [
                  -4.747425910999908,
                  52.783433335
                ],
                [
                  -4.762847459999932,
                  52.789496161
                ],
                [
                  -4.752512173999946,
                  52.798773505000057
                ],
                [
                  -4.751454230999883,
                  52.803208726000108
                ],
                [
                  -4.755441860999952,
                  52.809312242000104
                ],
                [
                  -4.749256964999887,
                  52.814276434000149
                ],
                [
                  -4.734934048999918,
                  52.830471096000011
                ],
                [
                  -4.596058722999942,
                  52.928412177000055
                ],
                [
                  -4.580962693999936,
                  52.933498440000065
                ],
                [
                  -4.562082485999923,
                  52.934515692000119
                ],
                [
                  -4.543527798999918,
                  52.937933661000145
                ],
                [
                  -4.523996548999918,
                  52.944240627000099
                ],
                [
                  -4.443430141999954,
                  52.982163804000109
                ],
                [
                  -4.423695441999939,
                  53.002630927000084
                ],
                [
                  -4.358225063999896,
                  53.028469143000095
                ],
                [
                  -4.349964972999914,
                  53.041489975999987
                ],
                [
                  -4.345692511999886,
                  53.059475002000013
                ],
                [
                  -4.343861456999917,
                  53.101060289000017
                ],
                [
                  -4.340891079999892,
                  53.112738348000093
                ],
                [
                  -4.334339972999914,
                  53.116766669000143
                ],
                [
                  -4.327626105999883,
                  53.114691473000121
                ],
                [
                  -4.32469641799986,
                  53.107896226000108
                ],
                [
                  -4.320668097999885,
                  53.10150788
                ],
                [
                  -4.312245245999918,
                  53.109442450000145
                ],
                [
                  -4.304758266999954,
                  53.120998440000093
                ],
                [
                  -4.303618943999936,
                  53.125311591000084
                ],
                [
                  -4.263539191999911,
                  53.154527085000112
                ],
                [
                  -4.252349412999905,
                  53.15940989799999
                ],
                [
                  -4.234527147999927,
                  53.164007880000113
                ],
                [
                  -4.221302863999881,
                  53.175034898000078
                ],
                [
                  -4.20055091099988,
                  53.200995184000149
                ],
                [
                  -4.17796790299991,
                  53.21759674700003
                ],
                [
                  -4.151519334999932,
                  53.228094794000086
                ],
                [
                  -4.122222459999904,
                  53.23346588700015
                ],
                [
                  -4.090687628999916,
                  53.235174872000144
                ],
                [
                  -4.082346157999922,
                  53.233547268000123
                ],
                [
                  -4.074330206999889,
                  53.23065827
                ],
                [
                  -4.066883917999917,
                  53.229071356000148
                ],
                [
                  -4.054107225999871,
                  53.234361070000048
                ],
                [
                  -4.032297329999921,
                  53.240708726000079
                ],
                [
                  -4.008900519999941,
                  53.244452216000113
                ],
                [
                  -3.974598761999886,
                  53.261786200000088
                ],
                [
                  -3.865305141999954,
                  53.289129950000174
                ],
                [
                  -3.831288214999944,
                  53.289129950000174
                ],
                [
                  -3.841420050999886,
                  53.30744049700003
                ],
                [
                  -3.870757615999906,
                  53.325628973000121
                ],
                [
                  -3.87840735599994,
                  53.337591864000061
                ],
                [
                  -3.85997473899991,
                  53.336330471000153
                ],
                [
                  -3.840565558999884,
                  53.332831122000144
                ],
                [
                  -3.822987433999856,
                  53.326564846000011
                ],
                [
                  -3.810129360999923,
                  53.317084052
                ],
                [
                  -3.790516730999883,
                  53.323431708000115
                ],
                [
                  -3.768869594999984,
                  53.31915924700003
                ],
                [
                  -3.74819902299987,
                  53.307806708000143
                ],
                [
                  -3.73192298099994,
                  53.29287344
                ],
                [
                  -3.716297980999855,
                  53.286932684000178
                ],
                [
                  -3.602202928999958,
                  53.288885809000035
                ],
                [
                  -3.562326626999891,
                  53.294419664000046
                ],
                [
                  -3.372059699999909,
                  53.350897528000175
                ],
                [
                  -3.330311652999882,
                  53.351792710000083
                ],
                [
                  -3.292388475999957,
                  53.340521552000084
                ],
                [
                  -3.271311001999919,
                  53.330552475999987
                ],
                [
                  -3.26207434799997,
                  53.32050202
                ],
                [
                  -3.250803188999953,
                  53.312567450000145
                ],
                [
                  -3.122222459999932,
                  53.262274481000176
                ],
                [
                  -3.107533331999917,
                  53.251898505
                ],
                [
                  -3.0951228509999,
                  53.239325262000094
                ],
                [
                  -3.087757941999911,
                  53.23468659100017
                ],
                [
                  -3.084543423999946,
                  53.23859284100017
                ],
                [
                  -3.084543423999946,
                  53.258571682000039
                ],
                [
                  -3.084543423999946,
                  53.258577179000056
                ],
                [
                  -3.084543423999946,
                  53.275458075000031
                ],
                [
                  -3.09593665299991,
                  53.28713613500004
                ],
                [
                  -3.111195441999882,
                  53.302801825000117
                ],
                [
                  -3.135406053999873,
                  53.333807684000035
                ],
                [
                  -3.171538865999906,
                  53.362250067000147
                ],
                [
                  -3.185210740999935,
                  53.37726471600017
                ],
                [
                  -3.186350063999896,
                  53.392767645000092
                ],
                [
                  -3.17552649599989,
                  53.402736721000068
                ],
                [
                  -3.157297329999921,
                  53.408758856000176
                ],
                [
                  -3.114654100999871,
                  53.412665106000176
                ],
                [
                  -3.094227667999917,
                  53.417385158000101
                ],
                [
                  -3.058257615999935,
                  53.434759833000058
                ],
                [
                  -3.035552537999877,
                  53.433742580000015
                ],
                [
                  -3.012196417999888,
                  53.416693427000055
                ],
                [
                  -2.952951626999891,
                  53.323919989000117
                ],
                [
                  -2.935129360999923,
                  53.309475002000156
                ],
                [
                  -2.910552537999905,
                  53.296332098
                ],
                [
                  -2.88149980399993,
                  53.288397528000033
                ],
                [
                  -2.850575324999909,
                  53.289129950000174
                ],
                [
                  -2.849598761999914,
                  53.291205145000092
                ],
                [
                  -2.848378058999913,
                  53.295558986000074
                ],
                [
                  -2.844960089999887,
                  53.300116278000033
                ],
                [
                  -2.837554490999906,
                  53.302801825000117
                ],
                [
                  -2.828602667999888,
                  53.302435614
                ],
                [
                  -2.813384568999908,
                  53.29775625200007
                ],
                [
                  -2.806141730999883,
                  53.296576239000146
                ],
                [
                  -2.789784308999856,
                  53.297430731000148
                ],
                [
                  -2.775502081999974,
                  53.299872137000179
                ],
                [
                  -2.748117641999897,
                  53.309637762000122
                ],
                [
                  -2.753651495999918,
                  53.322455145000063
                ],
                [
                  -2.750884568999879,
                  53.331610419000057
                ],
                [
                  -2.743153449999852,
                  53.338527736000131
                ],
                [
                  -2.734486456999946,
                  53.344427802000084
                ],
                [
                  -2.726144985999895,
                  53.34198639500012
                ],
                [
                  -2.717437303999901,
                  53.342718817000062
                ],
                [
                  -2.708607550999943,
                  53.346136786000088
                ],
                [
                  -2.69977779899989,
                  53.351792710000083
                ],
                [
                  -2.714100714999887,
                  53.35236237200003
                ],
                [
                  -2.764393683999856,
                  53.345160223
                ],
                [
                  -2.775380011999886,
                  53.341009833000058
                ],
                [
                  -2.782378709999875,
                  53.326361395000148
                ],
                [
                  -2.799794074999852,
                  53.32103099199999
                ],
                [
                  -2.810332811999899,
                  53.321722723000121
                ],
                [
                  -2.843658006999903,
                  53.323919989000117
                ],
                [
                  -2.88646399599989,
                  53.333563544000086
                ],
                [
                  -2.924956834999875,
                  53.350002346000096
                ],
                [
                  -2.956939256999874,
                  53.370550848000121
                ],
                [
                  -2.980824347999942,
                  53.392767645000092
                ],
                [
                  -3.096587693999879,
                  53.544338283000016
                ],
                [
                  -3.101918097999914,
                  53.558050848000121
                ],
                [
                  -3.099476691999882,
                  53.572007554000109
                ],
                [
                  -3.087635870999918,
                  53.587713934000149
                ],
                [
                  -3.021839972999942,
                  53.652818101000108
                ],
                [
                  -2.968658006999874,
                  53.694037177000055
                ],
                [
                  -2.9603572259999,
                  53.697577216000141
                ],
                [
                  -2.95173092399989,
                  53.708075262000122
                ],
                [
                  -2.911447719999899,
                  53.725043036
                ],
                [
                  -2.899037238999881,
                  53.735419012000179
                ],
                [
                  -2.984852667999917,
                  53.736070054000137
                ],
                [
                  -3.021473761999857,
                  53.745794989000089
                ],
                [
                  -3.049183722999942,
                  53.76951732000002
                ],
                [
                  -3.056385870999861,
                  53.803045966000056
                ],
                [
                  -3.044911261999914,
                  53.878485419000171
                ],
                [
                  -3.056630011999914,
                  53.906154690000065
                ],
                [
                  -3.040679490999906,
                  53.923529364000061
                ],
                [
                  -3.017567511999857,
                  53.931952216000113
                ],
                [
                  -2.925689256999903,
                  53.952704169000114
                ],
                [
                  -2.909250454999921,
                  53.953843492000047
                ],
                [
                  -2.896107550999943,
                  53.947739976000051
                ],
                [
                  -2.888539191999911,
                  53.946030992000047
                ],
                [
                  -2.885365363999938,
                  53.950506903000118
                ],
                [
                  -2.881988084999932,
                  53.956529039000102
                ],
                [
                  -2.874175584999932,
                  53.961655992000132
                ],
                [
                  -2.865142381999931,
                  53.965480861000131
                ],
                [
                  -2.85798092399989,
                  53.967596747000144
                ],
                [
                  -2.869252081999889,
                  53.978827216000141
                ],
                [
                  -2.834462042999917,
                  53.999823309000092
                ],
                [
                  -2.830067511999857,
                  54.016017971000153
                ],
                [
                  -2.847523566999911,
                  54.008368231000119
                ],
                [
                  -2.864857550999886,
                  54.004299221000068
                ],
                [
                  -2.895497199999909,
                  54.002346096000011
                ],
                [
                  -2.900298631999903,
                  54.004950262000122
                ],
                [
                  -2.916086391999926,
                  54.026556708000115
                ],
                [
                  -2.918202277999853,
                  54.034328518
                ],
                [
                  -2.911284959999932,
                  54.039984442
                ],
                [
                  -2.900786912999877,
                  54.044907945000077
                ],
                [
                  -2.892079230999883,
                  54.050116278000147
                ],
                [
                  -2.872670050999886,
                  54.07160065300009
                ],
                [
                  -2.858876105999883,
                  54.081000067000033
                ],
                [
                  -2.82677161399991,
                  54.088812567
                ],
                [
                  -2.815174933999884,
                  54.098781643
                ],
                [
                  -2.795969204999921,
                  54.125189520000092
                ],
                [
                  -2.812814907999922,
                  54.13987864799999
                ],
                [
                  -2.836415167999888,
                  54.167588609000077
                ],
                [
                  -2.850941535999908,
                  54.184637762000037
                ],
                [
                  -2.854237433999856,
                  54.194077867000047
                ],
                [
                  -2.832875128999888,
                  54.199042059000092
                ],
                [
                  -2.810292120999918,
                  54.21190013200011
                ],
                [
                  -2.795236782999893,
                  54.229478257000054
                ],
                [
                  -2.795969204999921,
                  54.248724677
                ],
                [
                  -2.802805141999954,
                  54.248724677
                ],
                [
                  -2.806630011999857,
                  54.233710028000175
                ],
                [
                  -2.820871548999975,
                  54.221747137000037
                ],
                [
                  -2.850575324999909,
                  54.20774974199999
                ],
                [
                  -2.886382615999906,
                  54.196275132000139
                ],
                [
                  -2.904652472999885,
                  54.187648830000128
                ],
                [
                  -2.912668423999918,
                  54.176988023000021
                ],
                [
                  -2.920399542999945,
                  54.162054755000057
                ],
                [
                  -2.93919837099989,
                  54.155096747000144
                ],
                [
                  -2.984201626999976,
                  54.153143622000115
                ],
                [
                  -2.997710740999935,
                  54.15957265800013
                ],
                [
                  -3.011341925999886,
                  54.174139716000141
                ],
                [
                  -3.017323370999918,
                  54.19009023600016
                ],
                [
                  -3.008168097999914,
                  54.200344143000095
                ],
                [
                  -3.015370245999861,
                  54.21190013200011
                ],
                [
                  -3.024484829999949,
                  54.22158437700007
                ],
                [
                  -3.035755988999938,
                  54.225978908000158
                ],
                [
                  -3.049183722999942,
                  54.222072658000158
                ],
                [
                  -3.04466712099989,
                  54.208319403000147
                ],
                [
                  -3.047840949999852,
                  54.194322007
                ],
                [
                  -3.053537563999925,
                  54.181301174000012
                ],
                [
                  -3.056630011999914,
                  54.170233466000141
                ],
                [
                  -3.061024542999888,
                  54.161932684000178
                ],
                [
                  -3.090728318999908,
                  54.139471747000172
                ],
                [
                  -3.10765540299991,
                  54.118557033000016
                ],
                [
                  -3.117909308999913,
                  54.108832098000065
                ],
                [
                  -3.145253058999913,
                  54.100043036
                ],
                [
                  -3.14745032499988,
                  54.08869049700003
                ],
                [
                  -3.144398566999911,
                  54.075140692000062
                ],
                [
                  -3.145375128999888,
                  54.06378815300009
                ],
                [
                  -3.180531378999945,
                  54.09284088700015
                ],
                [
                  -3.189768032999893,
                  54.097886460000026
                ],
                [
                  -3.205718553999901,
                  54.098537502000156
                ],
                [
                  -3.219553188999896,
                  54.100775458000143
                ],
                [
                  -3.23110917899993,
                  54.105129299000126
                ],
                [
                  -3.240956183999856,
                  54.112127997000115
                ],
                [
                  -3.238107876999919,
                  54.127590236000131
                ],
                [
                  -3.232533331999889,
                  54.144680080000072
                ],
                [
                  -3.233143683999856,
                  54.15916575700011
                ],
                [
                  -3.248402472999914,
                  54.166815497000144
                ],
                [
                  -3.248402472999914,
                  54.173651434000149
                ],
                [
                  -3.215199347999914,
                  54.179836330000128
                ],
                [
                  -3.206776495999861,
                  54.208929755000028
                ],
                [
                  -3.209055141999926,
                  54.242743231000176
                ],
                [
                  -3.207386847999914,
                  54.26300690300009
                ],
                [
                  -3.223133917999888,
                  54.257635809000035
                ],
                [
                  -3.231353318999879,
                  54.247219143000152
                ],
                [
                  -3.240956183999856,
                  54.222072658000158
                ],
                [
                  -3.23216712099989,
                  54.202541408000073
                ],
                [
                  -3.247141079999921,
                  54.197943427000055
                ],
                [
                  -3.27013098899991,
                  54.199123440000065
                ],
                [
                  -3.286000128999916,
                  54.197211005000113
                ],
                [
                  -3.306792772999927,
                  54.191880601000051
                ],
                [
                  -3.328521287999877,
                  54.204738674000069
                ],
                [
                  -3.364491339999859,
                  54.242499091000056
                ],
                [
                  -3.394195115999878,
                  54.264390367000075
                ],
                [
                  -3.407378709999932,
                  54.277736721000096
                ],
                [
                  -3.412912563999953,
                  54.293768622000172
                ],
                [
                  -3.410389777999853,
                  54.301459052
                ],
                [
                  -3.405995245999861,
                  54.309637762000094
                ],
                [
                  -3.404123501999891,
                  54.31854889500012
                ],
                [
                  -3.411447719999899,
                  54.332749742000047
                ],
                [
                  -3.413441535999937,
                  54.342962958
                ],
                [
                  -3.41633053299995,
                  54.344916083000143
                ],
                [
                  -3.440174933999856,
                  54.351752020000148
                ],
                [
                  -3.474273240999963,
                  54.393500067
                ],
                [
                  -3.497710740999935,
                  54.405829169000057
                ],
                [
                  -3.591867641999926,
                  54.483099677000055
                ],
                [
                  -3.608143683999884,
                  54.488267320000077
                ],
                [
                  -3.613189256999903,
                  54.491644598000093
                ],
                [
                  -3.623687303999873,
                  54.50608958500014
                ],
                [
                  -3.634185350999957,
                  54.512884833000058
                ],
                [
                  -3.626820441999939,
                  54.520412502000042
                ],
                [
                  -3.616200324999909,
                  54.527573960000055
                ],
                [
                  -3.611561652999882,
                  54.529933986000017
                ],
                [
                  -3.590321417999888,
                  54.564642645000092
                ],
                [
                  -3.563832160999937,
                  54.642767645
                ],
                [
                  -3.530140753999916,
                  54.688055731000034
                ],
                [
                  -3.516021287999905,
                  54.71287669499999
                ],
                [
                  -3.509185350999871,
                  54.721665757000054
                ],
                [
                  -3.500721808999856,
                  54.72597890800013
                ],
                [
                  -3.478871222999885,
                  54.730902411000031
                ],
                [
                  -3.46812903599988,
                  54.735296942
                ],
                [
                  -3.455433722999914,
                  54.745021877000127
                ],
                [
                  -3.439564581999889,
                  54.761460679000137
                ],
                [
                  -3.430978969999956,
                  54.780462958000143
                ],
                [
                  -3.440174933999856,
                  54.797430731000119
                ],
                [
                  -3.407541469999899,
                  54.856024481000148
                ],
                [
                  -3.387928839999859,
                  54.883368231000034
                ],
                [
                  -3.364491339999859,
                  54.899807033000016
                ],
                [
                  -3.344960089999887,
                  54.902533270000092
                ],
                [
                  -3.33336341099988,
                  54.897284247000115
                ],
                [
                  -3.322743292999917,
                  54.889878648000106
                ],
                [
                  -3.306467251999891,
                  54.886175848000065
                ],
                [
                  -3.295725063999981,
                  54.88690827
                ],
                [
                  -3.254628058999884,
                  54.899807033000016
                ],
                [
                  -3.267323370999861,
                  54.905503648000106
                ],
                [
                  -3.317290818999879,
                  54.920314846000068
                ],
                [
                  -3.29149329299986,
                  54.936672268000095
                ],
                [
                  -3.276519334999932,
                  54.943426825000031
                ],
                [
                  -3.213612433999884,
                  54.954413153000175
                ],
                [
                  -3.201039191999882,
                  54.952215887000094
                ],
                [
                  -3.193674282999893,
                  54.948635158000016
                ],
                [
                  -3.187977667999917,
                  54.944484768000095
                ],
                [
                  -3.180165167999917,
                  54.94082265800013
                ],
                [
                  -3.142811652999882,
                  54.933539130000113
                ],
                [
                  -3.12279212099989,
                  54.932684637000122
                ],
                [
                  -3.03954016799986,
                  54.947170315000065
                ],
                [
                  -3.021839972999942,
                  54.954413153000175
                ],
                [
                  -3.090728318999908,
                  54.954413153000175
                ],
                [
                  -3.090728318999908,
                  54.961249091000113
                ],
                [
                  -3.071522589999859,
                  54.963120835000083
                ],
                [
                  -3.056223110999895,
                  54.968817450000145
                ],
                [
                  -3.040923631999931,
                  54.972479559000092
                ],
                [
                  -3.021839972999942,
                  54.968085028000118
                ],
                [
                  -3.021839972999942,
                  54.975531317
                ],
                [
                  -3.0462947259999,
                  54.982123114000061
                ],
                [
                  -3.050282355999883,
                  54.981512762000122
                ],
                [
                  -3.050291125459182,
                  54.981511378672437
                ],
                [
                  -3.135406053999873,
                  54.968085028000118
                ],
                [
                  -3.453846808999884,
                  54.981756903000147
                ],
                [
                  -3.470692511999886,
                  54.984442450000031
                ],
                [
                  -3.486236131999903,
                  54.989488023000078
                ],
                [
                  -3.501047329999949,
                  54.99249909100017
                ],
                [
                  -3.515288865999878,
                  54.989203192000119
                ],
                [
                  -3.51235917899993,
                  54.987127997000115
                ],
                [
                  -3.511463995999861,
                  54.986883856000148
                ],
                [
                  -3.510894334999875,
                  54.985988674000069
                ],
                [
                  -3.509185350999871,
                  54.981756903000147
                ],
                [
                  -3.526031053999873,
                  54.977118231000034
                ],
                [
                  -3.541859503999916,
                  54.98065827
                ],
                [
                  -3.570546027999882,
                  54.99542877800009
                ],
                [
                  -3.583607550999943,
                  54.968085028000118
                ],
                [
                  -3.575672980999883,
                  54.957342841000113
                ],
                [
                  -3.57062740799995,
                  54.937567450000174
                ],
                [
                  -3.568755662999905,
                  54.916001695000077
                ],
                [
                  -3.570546027999882,
                  54.899807033000016
                ],
                [
                  -3.581695115999906,
                  54.883612372000172
                ],
                [
                  -3.598378058999856,
                  54.87799713700015
                ],
                [
                  -3.691761847999914,
                  54.883205471000068
                ],
                [
                  -3.717640753999945,
                  54.880845445000105
                ],
                [
                  -3.739247199999852,
                  54.859808661000088
                ],
                [
                  -3.810129360999923,
                  54.866278387000179
                ],
                [
                  -3.807850714999859,
                  54.861070054
                ],
                [
                  -3.806792772999899,
                  54.860907294000029
                ],
                [
                  -3.80333411399991,
                  54.858872789000017
                ],
                [
                  -3.812367316999911,
                  54.855169989000146
                ],
                [
                  -3.819813605999883,
                  54.855902411000088
                ],
                [
                  -3.826079881999931,
                  54.859930731000148
                ],
                [
                  -3.831288214999944,
                  54.866278387000179
                ],
                [
                  -3.819976365999935,
                  54.878566799000126
                ],
                [
                  -3.815052863999881,
                  54.877142645000063
                ],
                [
                  -3.810129360999923,
                  54.872503973000121
                ],
                [
                  -3.811634894999884,
                  54.880031643
                ],
                [
                  -3.813221808999913,
                  54.883124091000084
                ],
                [
                  -3.816965298999946,
                  54.886175848000065
                ],
                [
                  -3.828846808999913,
                  54.874986070000077
                ],
                [
                  -3.844309048999918,
                  54.866278387000179
                ],
                [
                  -3.839751756999874,
                  54.855902411000088
                ],
                [
                  -3.837473110999895,
                  54.851996161000088
                ],
                [
                  -3.844105597999885,
                  54.850978908000016
                ],
                [
                  -3.857899542999888,
                  54.844549872000115
                ],
                [
                  -3.823841925999943,
                  54.824693101000108
                ],
                [
                  -3.833607550999886,
                  54.820054429000081
                ],
                [
                  -3.885731574999852,
                  54.806463934000121
                ],
                [
                  -3.964182094999984,
                  54.771918036000116
                ],
                [
                  -4.011708136999886,
                  54.768215236000074
                ],
                [
                  -4.042876756999874,
                  54.769476630000085
                ],
                [
                  -4.042876756999874,
                  54.776922919000143
                ],
                [
                  -4.046783006999874,
                  54.778021552000027
                ],
                [
                  -4.050200975999871,
                  54.77855052299999
                ],
                [
                  -4.053334113999938,
                  54.779974677000055
                ],
                [
                  -4.055775519999884,
                  54.782538153000147
                ],
                [
                  -4.052967902999853,
                  54.785467841000084
                ],
                [
                  -4.05016028599988,
                  54.789007880000057
                ],
                [
                  -4.049712693999879,
                  54.789984442000119
                ],
                [
                  -4.051747199999909,
                  54.800034898000106
                ],
                [
                  -4.047718878999945,
                  54.813055731000091
                ],
                [
                  -4.049956834999932,
                  54.823228257000139
                ],
                [
                  -4.063588019999884,
                  54.826849677000027
                ],
                [
                  -4.064035610999952,
                  54.831529039000131
                ],
                [
                  -4.078602667999888,
                  54.824123440000122
                ],
                [
                  -4.090077277999853,
                  54.809759833000058
                ],
                [
                  -4.093495245999861,
                  54.792669989000117
                ],
                [
                  -4.083851691999882,
                  54.776922919000143
                ],
                [
                  -4.122954881999931,
                  54.773016669000143
                ],
                [
                  -4.173939581999946,
                  54.79230377800009
                ],
                [
                  -4.209136522999899,
                  54.826239325000145
                ],
                [
                  -4.20055091099988,
                  54.866278387000179
                ],
                [
                  -4.215402798999946,
                  54.861029364
                ],
                [
                  -4.239735480999912,
                  54.843003648000078
                ],
                [
                  -4.255767381999903,
                  54.838324286000145
                ],
                [
                  -4.270741339999944,
                  54.839422919000086
                ],
                [
                  -4.345285610999895,
                  54.860174872000087
                ],
                [
                  -4.356922980999883,
                  54.865545966000141
                ],
                [
                  -4.365630662999877,
                  54.872503973000121
                ],
                [
                  -4.37515214799987,
                  54.88690827
                ],
                [
                  -4.37987219999988,
                  54.897894598000065
                ],
                [
                  -4.386789516999983,
                  54.904771226000079
                ],
                [
                  -4.402902798999946,
                  54.907294012000179
                ],
                [
                  -4.409006313999925,
                  54.903021552000084
                ],
                [
                  -4.416818813999925,
                  54.89280833500014
                ],
                [
                  -4.423573370999861,
                  54.880357164000131
                ],
                [
                  -4.426503058999884,
                  54.869452216000141
                ],
                [
                  -4.417225714999944,
                  54.845933335
                ],
                [
                  -4.409413214999859,
                  54.831244208
                ],
                [
                  -4.402902798999946,
                  54.824693101000108
                ],
                [
                  -4.386708136999886,
                  54.824164130000113
                ],
                [
                  -4.372425910999908,
                  54.821844794000143
                ],
                [
                  -4.359608527999882,
                  54.816636460000083
                ],
                [
                  -4.347645636999857,
                  54.807318427000112
                ],
                [
                  -4.344471808999884,
                  54.794501044000086
                ],
                [
                  -4.353179490999963,
                  54.783107815000122
                ],
                [
                  -4.358143683999913,
                  54.770982164000131
                ],
                [
                  -4.343861456999917,
                  54.756415106000091
                ],
                [
                  -4.356516079999892,
                  54.741888739000061
                ],
                [
                  -4.353260870999947,
                  54.72089264500012
                ],
                [
                  -4.348133917999917,
                  54.701971747000115
                ],
                [
                  -4.354725714999887,
                  54.693793036
                ],
                [
                  -4.360340949999909,
                  54.69159577
                ],
                [
                  -4.365305141999954,
                  54.686957098000093
                ],
                [
                  -4.371896938999925,
                  54.68227773600016
                ],
                [
                  -4.382394985999895,
                  54.680080471000068
                ],
                [
                  -4.405262824999909,
                  54.682074286000031
                ],
                [
                  -4.426503058999884,
                  54.687567450000031
                ],
                [
                  -4.45181230399993,
                  54.698797919000057
                ],
                [
                  -4.461171027999882,
                  54.701239325000174
                ],
                [
                  -4.49673417899993,
                  54.700628973000036
                ],
                [
                  -4.50560462099989,
                  54.704657294000086
                ],
                [
                  -4.563628709999961,
                  54.756415106000091
                ],
                [
                  -4.596669074999909,
                  54.775295315000122
                ],
                [
                  -4.714466925999943,
                  54.817857163999989
                ],
                [
                  -4.759592251999891,
                  54.825344143000152
                ],
                [
                  -4.781076626999919,
                  54.83307526200015
                ],
                [
                  -4.799631313999925,
                  54.861273505000142
                ],
                [
                  -4.821034308999884,
                  54.866644598
                ],
                [
                  -4.859120245999861,
                  54.866278387000179
                ],
                [
                  -4.883046027999853,
                  54.860093492000104
                ],
                [
                  -4.905873175999943,
                  54.849798895
                ],
                [
                  -4.925770636999857,
                  54.837388414000074
                ],
                [
                  -4.941029425999915,
                  54.824693101000108
                ],
                [
                  -4.949615037999934,
                  54.815822658000158
                ],
                [
                  -4.95368404899989,
                  54.810003973
                ],
                [
                  -4.954823370999918,
                  54.804754950000117
                ],
                [
                  -4.954701300999943,
                  54.797430731000119
                ],
                [
                  -4.95287024599989,
                  54.788967190000065
                ],
                [
                  -4.94790605399993,
                  54.777329820000077
                ],
                [
                  -4.940256313999896,
                  54.76703522300015
                ],
                [
                  -4.930165167999917,
                  54.762640692000062
                ],
                [
                  -4.923247850999928,
                  54.751857815000065
                ],
                [
                  -4.911936001999948,
                  54.728216864000117
                ],
                [
                  -4.895985480999855,
                  54.704535223
                ],
                [
                  -4.867258266999897,
                  54.690130927000141
                ],
                [
                  -4.866932745999861,
                  54.681463934000149
                ],
                [
                  -4.872141079999949,
                  54.66331614800005
                ],
                [
                  -4.87242591099988,
                  54.654038804
                ],
                [
                  -4.87205969999988,
                  54.649237372000115
                ],
                [
                  -4.859120245999861,
                  54.632961330000072
                ],
                [
                  -4.88060462099989,
                  54.636216539000131
                ],
                [
                  -4.923491990999878,
                  54.64972565300009
                ],
                [
                  -4.944081183999913,
                  54.652777411
                ],
                [
                  -4.95368404899989,
                  54.659735419000171
                ],
                [
                  -4.959868943999936,
                  54.675523179000109
                ],
                [
                  -4.958973761999857,
                  54.691961981000119
                ],
                [
                  -4.947255011999886,
                  54.701239325000174
                ],
                [
                  -4.954823370999918,
                  54.707464911000116
                ],
                [
                  -4.958892381999874,
                  54.71405670800003
                ],
                [
                  -4.959055141999926,
                  54.720933335000112
                ],
                [
                  -4.954701300999943,
                  54.728501695000077
                ],
                [
                  -4.973378058999913,
                  54.72972239799999
                ],
                [
                  -4.981556769999941,
                  54.731634833000143
                ],
                [
                  -4.988189256999903,
                  54.735296942
                ],
                [
                  -4.99266516799986,
                  54.744330145
                ],
                [
                  -4.997059699999852,
                  54.758368231000148
                ],
                [
                  -5.003285285999908,
                  54.771307684000149
                ],
                [
                  -5.013010219999956,
                  54.776922919000143
                ],
                [
                  -5.033192511999886,
                  54.782416083
                ],
                [
                  -5.128244594999899,
                  54.84894440300009
                ],
                [
                  -5.157134568999908,
                  54.879095770000035
                ],
                [
                  -5.175526495999861,
                  54.914618231000091
                ],
                [
                  -5.180653449999852,
                  54.954413153000175
                ],
                [
                  -5.177601691999882,
                  54.990545966000028
                ],
                [
                  -5.170806443999936,
                  55.008693752000042
                ],
                [
                  -5.156727667999888,
                  55.016546942
                ],
                [
                  -5.135609503999888,
                  55.015855210000055
                ],
                [
                  -5.124582485999923,
                  55.016791083000143
                ],
                [
                  -5.119740363999938,
                  55.019924221000124
                ],
                [
                  -5.115142381999931,
                  55.031561591000028
                ],
                [
                  -5.105213995999918,
                  55.026190497000172
                ],
                [
                  -5.095529751999948,
                  55.01508209800015
                ],
                [
                  -5.091867641999897,
                  55.009711005
                ],
                [
                  -5.076893683999884,
                  54.995550848000065
                ],
                [
                  -5.069488084999875,
                  54.986029364000061
                ],
                [
                  -5.064564581999917,
                  54.975531317
                ],
                [
                  -5.063791469999899,
                  54.964585679000137
                ],
                [
                  -5.065256313999953,
                  54.940334377000127
                ],
                [
                  -5.060861782999893,
                  54.931138414000074
                ],
                [
                  -5.047515428999873,
                  54.920314846000068
                ],
                [
                  -5.03099524599989,
                  54.911322333000058
                ],
                [
                  -5.013091600999928,
                  54.90961334800015
                ],
                [
                  -4.995594855999883,
                  54.920314846000068
                ],
                [
                  -4.992298956999946,
                  54.924261786000059
                ],
                [
                  -4.988189256999903,
                  54.927720445000077
                ],
                [
                  -4.988189256999903,
                  54.934556382000082
                ],
                [
                  -5.024077928999901,
                  54.976385809000092
                ],
                [
                  -5.029774542999888,
                  54.985500393000095
                ],
                [
                  -5.03250077999985,
                  54.993719794000086
                ],
                [
                  -5.033029751999919,
                  54.995266018000123
                ],
                [
                  -5.047027147999899,
                  55.01508209800015
                ],
                [
                  -5.05028235599994,
                  55.026800848000121
                ],
                [
                  -5.049672003999888,
                  55.0489769550001
                ],
                [
                  -5.047596808999856,
                  55.055731512000037
                ],
                [
                  -5.043446417999917,
                  55.064276434000149
                ],
                [
                  -5.025786912999905,
                  55.088690497000115
                ],
                [
                  -5.018950975999871,
                  55.102240302000084
                ],
                [
                  -5.016184048999918,
                  55.122626044000143
                ],
                [
                  -5.007801886999857,
                  55.141180731000148
                ],
                [
                  -4.988270636999886,
                  55.152655341000113
                ],
                [
                  -4.947255011999886,
                  55.167914130000085
                ],
                [
                  -4.882394985999895,
                  55.218573309000149
                ],
                [
                  -4.87755286399991,
                  55.220892645000035
                ],
                [
                  -4.867258266999897,
                  55.222479559000064
                ],
                [
                  -4.865305141999926,
                  55.225653387000122
                ],
                [
                  -4.865589972999885,
                  55.236314195000048
                ],
                [
                  -4.864816860999952,
                  55.241359768000066
                ],
                [
                  -4.841949022999927,
                  55.275091864000061
                ],
                [
                  -4.838002081999946,
                  55.284002997000115
                ],
                [
                  -4.837228969999927,
                  55.293850002000127
                ],
                [
                  -4.839751756999959,
                  55.315578518
                ],
                [
                  -4.838002081999946,
                  55.325018622000115
                ],
                [
                  -4.832508917999917,
                  55.331122137000094
                ],
                [
                  -4.799224412999934,
                  55.35472239800005
                ],
                [
                  -4.781076626999919,
                  55.363511460000112
                ],
                [
                  -4.773101365999878,
                  55.369370835000055
                ],
                [
                  -4.767160610999952,
                  55.379055080000015
                ],
                [
                  -4.75877844999988,
                  55.402289130000142
                ],
                [
                  -4.749256964999887,
                  55.413763739000089
                ],
                [
                  -4.717030402999853,
                  55.430487372000115
                ],
                [
                  -4.650502081999946,
                  55.44847239800005
                ],
                [
                  -4.626332160999937,
                  55.468410549000126
                ],
                [
                  -4.61778723899991,
                  55.495591539000046
                ],
                [
                  -4.626779751999948,
                  55.519720770000063
                ],
                [
                  -4.650786912999877,
                  55.537054755000142
                ],
                [
                  -4.687163865999878,
                  55.54413483300003
                ],
                [
                  -4.66624915299991,
                  55.562201239000117
                ],
                [
                  -4.66649329299986,
                  55.563299872000172
                ],
                [
                  -4.671131964999887,
                  55.584418036000088
                ],
                [
                  -4.69273841099988,
                  55.605210679000081
                ],
                [
                  -4.721994594999899,
                  55.619208075000031
                ],
                [
                  -4.776519334999875,
                  55.632879950000174
                ],
                [
                  -4.808745897999927,
                  55.633612372000087
                ],
                [
                  -4.818104620999861,
                  55.637193101000079
                ],
                [
                  -4.810617641999897,
                  55.646551825000117
                ],
                [
                  -4.810617641999897,
                  55.653998114000089
                ],
                [
                  -4.8685603509999,
                  55.675604559000178
                ],
                [
                  -4.900990363999881,
                  55.692328192000033
                ],
                [
                  -4.920521613999966,
                  55.708563544000143
                ],
                [
                  -4.87633216099988,
                  55.73525625200007
                ],
                [
                  -4.861073370999918,
                  55.756740627000013
                ],
                [
                  -4.865305141999926,
                  55.790472723
                ],
                [
                  -4.871734178999958,
                  55.802435614000117
                ],
                [
                  -4.877797003999945,
                  55.811021226000051
                ],
                [
                  -4.882720506999903,
                  55.82135651200015
                ],
                [
                  -4.888661261999943,
                  55.864528713000155
                ],
                [
                  -4.888824022999899,
                  55.865301825000174
                ],
                [
                  -4.892648891999897,
                  55.892889716000084
                ],
                [
                  -4.886463995999861,
                  55.919663804000024
                ],
                [
                  -4.872141079999949,
                  55.937201239000146
                ],
                [
                  -4.849354620999918,
                  55.948228257
                ],
                [
                  -4.818104620999861,
                  55.955633856000176
                ],
                [
                  -4.79938717399989,
                  55.957912502000156
                ],
                [
                  -4.78579667899993,
                  55.956976630000057
                ],
                [
                  -4.722320115999935,
                  55.940090236000074
                ],
                [
                  -4.705433722999942,
                  55.938462632000054
                ],
                [
                  -4.693959113999881,
                  55.941351630000085
                ],
                [
                  -4.672515428999873,
                  55.93378327000012
                ],
                [
                  -4.505970831999889,
                  55.919094143000123
                ],
                [
                  -4.481678839999916,
                  55.928290106000091
                ],
                [
                  -4.590606248999904,
                  55.941514390000137
                ],
                [
                  -4.630034959999875,
                  55.946275132000139
                ],
                [
                  -4.673451300999943,
                  55.961859442000119
                ],
                [
                  -4.724517381999931,
                  55.998358466000084
                ],
                [
                  -4.765044725999928,
                  56.007066148000078
                ],
                [
                  -4.783436652999882,
                  56.017645575000031
                ],
                [
                  -4.799224412999934,
                  56.030951239000146
                ],
                [
                  -4.810617641999897,
                  56.043768622000172
                ],
                [
                  -4.823719855999855,
                  56.073675848000065
                ],
                [
                  -4.824330206999917,
                  56.078517971000124
                ],
                [
                  -4.839182094999899,
                  56.080633856000148
                ],
                [
                  -4.84430904899989,
                  56.072984117000104
                ],
                [
                  -4.843739386999914,
                  56.062974351000136
                ],
                [
                  -4.837554490999878,
                  56.050604559000092
                ],
                [
                  -4.790150519999941,
                  56.010199286000145
                ],
                [
                  -4.778920050999915,
                  55.992092190000122
                ],
                [
                  -4.78530839799987,
                  55.984035549000012
                ],
                [
                  -4.803618943999908,
                  55.982082424000154
                ],
                [
                  -4.828033006999874,
                  55.982326565
                ],
                [
                  -4.851551886999914,
                  55.988023179
                ],
                [
                  -4.862294074999852,
                  56.002142645000035
                ],
                [
                  -4.865386522999927,
                  56.020209052000141
                ],
                [
                  -4.866851365999878,
                  56.058335679000109
                ],
                [
                  -4.865386522999927,
                  56.06671784100017
                ],
                [
                  -4.82632402299987,
                  56.124212958000058
                ],
                [
                  -4.755441860999952,
                  56.188381252000013
                ],
                [
                  -4.750884568999908,
                  56.202704169000086
                ],
                [
                  -4.755523240999935,
                  56.206529039000102
                ],
                [
                  -4.766265428999873,
                  56.202093817000147
                ],
                [
                  -4.779937303999901,
                  56.191473700000088
                ],
                [
                  -4.837269660999937,
                  56.124416408000016
                ],
                [
                  -4.851673956999889,
                  56.112616278000147
                ],
                [
                  -4.873117641999926,
                  56.112005927
                ],
                [
                  -4.88060462099989,
                  56.119859117000075
                ],
                [
                  -4.878977016999954,
                  56.150539455000072
                ],
                [
                  -4.883168097999914,
                  56.164007880000057
                ],
                [
                  -4.893544074999909,
                  56.174261786000088
                ],
                [
                  -4.907093878999973,
                  56.177069403000033
                ],
                [
                  -4.920521613999966,
                  56.167914130000057
                ],
                [
                  -4.909087693999908,
                  56.149969794000114
                ],
                [
                  -4.895253058999913,
                  56.114732164000074
                ],
                [
                  -4.886219855999912,
                  56.080389716000113
                ],
                [
                  -4.889149542999917,
                  56.064846096000011
                ],
                [
                  -4.901926235999952,
                  56.061916408000073
                ],
                [
                  -4.904367641999897,
                  56.054348049000126
                ],
                [
                  -4.900054490999906,
                  56.034125067000033
                ],
                [
                  -4.900054490999906,
                  56.014593817000119
                ],
                [
                  -4.898019985999952,
                  56.001166083000143
                ],
                [
                  -4.892648891999897,
                  55.989732163999989
                ],
                [
                  -4.906402147999927,
                  55.985744533000016
                ],
                [
                  -4.921457485999952,
                  55.988674221000124
                ],
                [
                  -4.937489386999943,
                  55.993841864000117
                ],
                [
                  -4.954701300999943,
                  55.996568101000108
                ],
                [
                  -4.954701300999943,
                  55.989732163999989
                ],
                [
                  -4.942005988999881,
                  55.98631419499999
                ],
                [
                  -4.928863084999932,
                  55.981146552000084
                ],
                [
                  -4.91844641799986,
                  55.973334052000084
                ],
                [
                  -4.913685675999943,
                  55.961859442000119
                ],
                [
                  -4.9173884759999,
                  55.947455145000063
                ],
                [
                  -4.927235480999912,
                  55.93768952000012
                ],
                [
                  -4.938710089999859,
                  55.92963288
                ],
                [
                  -4.947255011999886,
                  55.920843817000119
                ],
                [
                  -4.952137824999852,
                  55.909125067000147
                ],
                [
                  -4.954986131999874,
                  55.899359442
                ],
                [
                  -4.95921790299991,
                  55.890122789000046
                ],
                [
                  -4.968983527999853,
                  55.87986888200011
                ],
                [
                  -4.983143683999884,
                  55.871039130000057
                ],
                [
                  -4.994740363999881,
                  55.869818427000141
                ],
                [
                  -5.02635657499988,
                  55.873724677000141
                ],
                [
                  -5.042469855999855,
                  55.88475169499999
                ],
                [
                  -5.056752081999917,
                  55.910305080000072
                ],
                [
                  -5.066802537999905,
                  55.938788153000175
                ],
                [
                  -5.070790167999888,
                  55.958685614000061
                ],
                [
                  -5.110829230999912,
                  55.988959052000055
                ],
                [
                  -5.116037563999925,
                  56.001695054000109
                ],
                [
                  -5.123605923999946,
                  56.009914455000015
                ],
                [
                  -5.139637824999852,
                  56.002752997000172
                ],
                [
                  -5.123768683999913,
                  55.98631419499999
                ],
                [
                  -5.085682745999947,
                  55.931870835000083
                ],
                [
                  -5.078236456999946,
                  55.910956122000115
                ],
                [
                  -5.086537238999938,
                  55.901271877000156
                ],
                [
                  -5.105620897999927,
                  55.904974677
                ],
                [
                  -5.171538865999878,
                  55.935532945000134
                ],
                [
                  -5.180653449999852,
                  55.948431708000143
                ],
                [
                  -5.180653449999852,
                  55.969305731000119
                ],
                [
                  -5.1908259759999,
                  55.961737372000144
                ],
                [
                  -5.199615037999877,
                  55.948553778000118
                ],
                [
                  -5.205718553999873,
                  55.934515692000062
                ],
                [
                  -5.207915818999936,
                  55.924627997000144
                ],
                [
                  -5.212635870999861,
                  55.917141018000095
                ],
                [
                  -5.242054816999939,
                  55.892889716000084
                ],
                [
                  -5.21812903599988,
                  55.864691473000121
                ],
                [
                  -5.208159959999904,
                  55.849269924000097
                ],
                [
                  -5.201079881999931,
                  55.831488348
                ],
                [
                  -5.219390428999901,
                  55.831447658000016
                ],
                [
                  -5.263172980999855,
                  55.845770575000088
                ],
                [
                  -5.296701626999891,
                  55.852687893
                ],
                [
                  -5.307118292999888,
                  55.860419012000122
                ],
                [
                  -5.313384568999936,
                  55.885443427000112
                ],
                [
                  -5.31932532499988,
                  55.889105536000088
                ],
                [
                  -5.327219204999949,
                  55.891546942
                ],
                [
                  -5.334828253999888,
                  55.89667389500012
                ],
                [
                  -5.338286912999877,
                  55.903753973000093
                ],
                [
                  -5.339100714999887,
                  55.913031317000119
                ],
                [
                  -5.338286912999877,
                  55.931382554
                ],
                [
                  -5.336089647999899,
                  55.939195054
                ],
                [
                  -5.326161261999886,
                  55.950262762000122
                ],
                [
                  -5.32396399599989,
                  55.958685614000061
                ],
                [
                  -5.325754360999895,
                  55.967230536
                ],
                [
                  -5.338286912999877,
                  55.996568101000108
                ],
                [
                  -5.313628709999875,
                  56.012355861000131
                ],
                [
                  -5.204497850999928,
                  56.11945221600017
                ],
                [
                  -5.146473761999886,
                  56.133124091000113
                ],
                [
                  -5.104603644999941,
                  56.151516018000152
                ],
                [
                  -5.094960089999887,
                  56.157375393000095
                ],
                [
                  -5.059437628999916,
                  56.203111070000105
                ],
                [
                  -5.043446417999917,
                  56.216294664000046
                ],
                [
                  -5.013295050999886,
                  56.227606512000037
                ],
                [
                  -4.974964972999942,
                  56.237005927000055
                ],
                [
                  -4.94009355399993,
                  56.251410223000121
                ],
                [
                  -4.920521613999966,
                  56.277777411000116
                ],
                [
                  -4.938099738999881,
                  56.270982164000102
                ],
                [
                  -4.975087042999917,
                  56.247992255000113
                ],
                [
                  -4.991932745999918,
                  56.242987372000172
                ],
                [
                  -5.032704230999912,
                  56.241156317
                ],
                [
                  -5.049549933999913,
                  56.237046617000047
                ],
                [
                  -5.064564581999917,
                  56.229315497000059
                ],
                [
                  -5.075428839999916,
                  56.216986395
                ],
                [
                  -5.099436001999948,
                  56.181952216000113
                ],
                [
                  -5.108876105999883,
                  56.17470937700007
                ],
                [
                  -5.228138800999886,
                  56.129217841000113
                ],
                [
                  -5.310943162999905,
                  56.058050848000065
                ],
                [
                  -5.319935675999915,
                  56.05491771
                ],
                [
                  -5.338042772999927,
                  56.054103908000101
                ],
                [
                  -5.345692511999857,
                  56.051214911000059
                ],
                [
                  -5.345285610999952,
                  56.046128648000135
                ],
                [
                  -5.35020911399991,
                  56.031927802000112
                ],
                [
                  -5.356353318999908,
                  56.01976146000014
                ],
                [
                  -5.359364386999914,
                  56.020738023000106
                ],
                [
                  -5.368641730999855,
                  56.009426174000126
                ],
                [
                  -5.390288865999935,
                  56.005682684000092
                ],
                [
                  -5.415028449999909,
                  56.006903387000122
                ],
                [
                  -5.433827277999882,
                  56.010199286000145
                ],
                [
                  -5.434559699999909,
                  56.014960028000147
                ],
                [
                  -5.434722459999875,
                  56.023627020000148
                ],
                [
                  -5.437123175999915,
                  56.030015367000075
                ],
                [
                  -5.444406704999921,
                  56.027573960000112
                ],
                [
                  -5.447906053999901,
                  56.022284247000144
                ],
                [
                  -5.448231574999852,
                  56.016058661
                ],
                [
                  -5.447621222999885,
                  56.009426174000126
                ],
                [
                  -5.454986131999874,
                  55.955633856000176
                ],
                [
                  -5.45140540299991,
                  55.953436591000084
                ],
                [
                  -5.436431443999879,
                  55.948960679000109
                ],
                [
                  -5.430775519999884,
                  55.948187567
                ],
                [
                  -5.420806443999879,
                  55.928290106000091
                ],
                [
                  -5.416737433999913,
                  55.916815497000144
                ],
                [
                  -5.416005011999886,
                  55.907416083000143
                ],
                [
                  -5.412505662999905,
                  55.899603583000143
                ],
                [
                  -5.400380011999914,
                  55.892889716000084
                ],
                [
                  -5.400380011999914,
                  55.886704820000134
                ],
                [
                  -5.407215949999937,
                  55.886704820000134
                ],
                [
                  -5.407215949999937,
                  55.87986888200011
                ],
                [
                  -5.40294348899991,
                  55.878729559000178
                ],
                [
                  -5.39289303299995,
                  55.873724677000141
                ],
                [
                  -5.397694464999916,
                  55.871568101000136
                ],
                [
                  -5.402495897999927,
                  55.868353583000086
                ],
                [
                  -5.407215949999937,
                  55.86627838700015
                ],
                [
                  -5.351796027999853,
                  55.832424221000096
                ],
                [
                  -5.326771613999938,
                  55.808579820000105
                ],
                [
                  -5.317779100999928,
                  55.783026434000121
                ],
                [
                  -5.324574347999942,
                  55.769232489000117
                ],
                [
                  -5.33853105399993,
                  55.762640692000147
                ],
                [
                  -5.37242591099988,
                  55.756415106000176
                ],
                [
                  -5.387562628999888,
                  55.750311591000084
                ],
                [
                  -5.433461066999939,
                  55.72101471600017
                ],
                [
                  -5.444569464999887,
                  55.711615302000055
                ],
                [
                  -5.453968878999916,
                  55.700588283000101
                ],
                [
                  -5.461171027999853,
                  55.688137111000074
                ],
                [
                  -5.463612433999884,
                  55.679836330000015
                ],
                [
                  -5.46617591099988,
                  55.662176825000088
                ],
                [
                  -5.468617316999911,
                  55.653998114000089
                ],
                [
                  -5.490101691999939,
                  55.644598700000145
                ],
                [
                  -5.488270636999886,
                  55.640326239000146
                ],
                [
                  -5.484283006999903,
                  55.63572825700011
                ],
                [
                  -5.482289191999939,
                  55.632879950000174
                ],
                [
                  -5.483876105999883,
                  55.610052802000055
                ],
                [
                  -5.474761522999899,
                  55.603949286000059
                ],
                [
                  -5.46263587099989,
                  55.602036851000108
                ],
                [
                  -5.454986131999874,
                  55.591945705000128
                ],
                [
                  -5.46108964799987,
                  55.578802802
                ],
                [
                  -5.476918097999885,
                  55.574896552
                ],
                [
                  -5.48875891799986,
                  55.569077867000132
                ],
                [
                  -5.482289191999939,
                  55.550279038999989
                ],
                [
                  -5.503529425999943,
                  55.526516018000095
                ],
                [
                  -5.509632941999911,
                  55.516791083000143
                ],
                [
                  -5.510609503999888,
                  55.511460679000081
                ],
                [
                  -5.509632941999911,
                  55.492580471000124
                ],
                [
                  -5.510975714999916,
                  55.484442450000031
                ],
                [
                  -5.514271613999938,
                  55.483872789000046
                ],
                [
                  -5.518788214999916,
                  55.485174872000144
                ],
                [
                  -5.523264126999976,
                  55.48265208500014
                ],
                [
                  -5.54552161399991,
                  55.44916413
                ],
                [
                  -5.561512824999909,
                  55.435532945000048
                ],
                [
                  -5.584624803999873,
                  55.427435614000117
                ],
                [
                  -5.584624803999873,
                  55.421210028000147
                ],
                [
                  -5.572132941999968,
                  55.422308661
                ],
                [
                  -5.562082485999895,
                  55.419867255000057
                ],
                [
                  -5.553089972999885,
                  55.414536851000022
                ],
                [
                  -5.543690558999856,
                  55.406927802000055
                ],
                [
                  -5.527455206999889,
                  55.384344794000086
                ],
                [
                  -5.526682094999984,
                  55.38027578300013
                ],
                [
                  -5.514963344999899,
                  55.37368398600016
                ],
                [
                  -5.525054490999963,
                  55.358628648000135
                ],
                [
                  -5.557972785999937,
                  55.331854559000035
                ],
                [
                  -5.574370897999927,
                  55.322007554000109
                ],
                [
                  -5.594105597999885,
                  55.31313711100016
                ],
                [
                  -5.616281704999949,
                  55.306586005000085
                ],
                [
                  -5.639963344999956,
                  55.303900458
                ],
                [
                  -5.649525519999941,
                  55.305161851000108
                ],
                [
                  -5.669097459999932,
                  55.310858466000084
                ],
                [
                  -5.680897589999887,
                  55.311346747000172
                ],
                [
                  -5.691395636999857,
                  55.308579820000105
                ],
                [
                  -5.714019334999932,
                  55.299139716000113
                ],
                [
                  -5.725575324999852,
                  55.297064520000092
                ],
                [
                  -5.75454667899993,
                  55.297349351000108
                ],
                [
                  -5.772287563999925,
                  55.301255601000108
                ],
                [
                  -5.782866990999906,
                  55.31354401200015
                ],
                [
                  -5.794667120999861,
                  55.356390692000062
                ],
                [
                  -5.796701626999891,
                  55.37909577
                ],
                [
                  -5.791411912999905,
                  55.398627020000092
                ],
                [
                  -5.76341712099989,
                  55.412054755000085
                ],
                [
                  -5.725412563999896,
                  55.437567450000174
                ],
                [
                  -5.715646938999953,
                  55.447902736000074
                ],
                [
                  -5.715240037999934,
                  55.468898830000015
                ],
                [
                  -5.7201228509999,
                  55.491522528000175
                ],
                [
                  -5.721913214999887,
                  55.513861395000035
                ],
                [
                  -5.707753058999884,
                  55.543361721000096
                ],
                [
                  -5.712066209999875,
                  55.550726630000085
                ],
                [
                  -5.718861456999917,
                  55.557318427000055
                ],
                [
                  -5.721831834999904,
                  55.564601955000072
                ],
                [
                  -5.71812903599988,
                  55.575751044000086
                ],
                [
                  -5.694488084999932,
                  55.605536200000088
                ],
                [
                  -5.673329230999855,
                  55.64061107
                ],
                [
                  -5.669422980999855,
                  55.660711981000034
                ],
                [
                  -5.680897589999887,
                  55.674465236000131
                ],
                [
                  -5.626535610999952,
                  55.700628973000093
                ],
                [
                  -5.619455532999922,
                  55.71198151200015
                ],
                [
                  -5.613189256999874,
                  55.725775458000086
                ],
                [
                  -5.598296678999901,
                  55.742987372000087
                ],
                [
                  -5.581206834999875,
                  55.757635809000092
                ],
                [
                  -5.567860480999855,
                  55.763861395000063
                ],
                [
                  -5.539173956999889,
                  55.770941473000121
                ],
                [
                  -5.504628058999884,
                  55.789374091000141
                ],
                [
                  -5.473500128999888,
                  55.815659898000078
                ],
                [
                  -5.454986131999874,
                  55.845770575000088
                ],
                [
                  -5.55174719999988,
                  55.783636786000088
                ],
                [
                  -5.587473110999923,
                  55.767157294000086
                ],
                [
                  -5.599436001999948,
                  55.764227606000176
                ],
                [
                  -5.612619594999899,
                  55.763861395000063
                ],
                [
                  -5.605783657999979,
                  55.776841539000046
                ],
                [
                  -5.633208787999934,
                  55.782782294000171
                ],
                [
                  -5.64671790299991,
                  55.787502346000096
                ],
                [
                  -5.660389777999853,
                  55.797349351000108
                ],
                [
                  -5.667958136999886,
                  55.811021226000051
                ],
                [
                  -5.669016079999949,
                  55.837836005000142
                ],
                [
                  -5.674061652999882,
                  55.845770575000088
                ],
                [
                  -5.631988084999904,
                  55.881781317000062
                ],
                [
                  -5.625599738999881,
                  55.889837958
                ],
                [
                  -5.619374152999939,
                  55.90314362200003
                ],
                [
                  -5.604359503999916,
                  55.913641669000086
                ],
                [
                  -5.586293097999885,
                  55.923325914000046
                ],
                [
                  -5.571034308999913,
                  55.934515692000062
                ],
                [
                  -5.593495245999918,
                  55.927964585000083
                ],
                [
                  -5.62759355399993,
                  55.905340887000122
                ],
                [
                  -5.653797980999855,
                  55.897609768
                ],
                [
                  -5.671701626999919,
                  55.886908270000092
                ],
                [
                  -5.680897589999887,
                  55.886704820000134
                ],
                [
                  -5.68797766799986,
                  55.893377997000087
                ],
                [
                  -5.694162563999925,
                  55.904974677
                ],
                [
                  -5.696400519999912,
                  55.915961005000057
                ],
                [
                  -5.586822068999879,
                  56.012030341000028
                ],
                [
                  -5.578439907999893,
                  56.024481512000037
                ],
                [
                  -5.58267167899993,
                  56.028957424000012
                ],
                [
                  -5.576649542999917,
                  56.032538153000175
                ],
                [
                  -5.571034308999913,
                  56.037543036000116
                ],
                [
                  -5.583892381999931,
                  56.040716864000089
                ],
                [
                  -5.596424933999856,
                  56.036810614
                ],
                [
                  -5.609852667999917,
                  56.030015367000075
                ],
                [
                  -5.625599738999881,
                  56.024481512000037
                ],
                [
                  -5.631703253999888,
                  56.005926825000031
                ],
                [
                  -5.674875454999892,
                  55.977728583000058
                ],
                [
                  -5.674061652999882,
                  55.955633856000176
                ],
                [
                  -5.690785285999908,
                  55.937648830000128
                ],
                [
                  -5.694488084999932,
                  55.934515692000062
                ],
                [
                  -5.704497850999928,
                  55.93675364800005
                ],
                [
                  -5.707508917999917,
                  55.942572333
                ],
                [
                  -5.705881313999896,
                  55.949652411000059
                ],
                [
                  -5.701975063999925,
                  55.955633856000176
                ],
                [
                  -5.696441209999904,
                  55.982163804000137
                ],
                [
                  -5.659901495999861,
                  56.023260809000035
                ],
                [
                  -5.584624803999873,
                  56.084662177000112
                ],
                [
                  -5.581532355999883,
                  56.088283596000068
                ],
                [
                  -5.580067511999914,
                  56.092922268
                ],
                [
                  -5.577463344999927,
                  56.096991278000147
                ],
                [
                  -5.571034308999913,
                  56.099025783000101
                ],
                [
                  -5.564605272999899,
                  56.098089911000031
                ],
                [
                  -5.556548631999874,
                  56.09589264500012
                ],
                [
                  -5.550689256999931,
                  56.093491929000081
                ],
                [
                  -5.550526495999861,
                  56.092189846000068
                ],
                [
                  -5.54784094999988,
                  56.090033270000063
                ],
                [
                  -5.539458787999934,
                  56.086859442
                ],
                [
                  -5.531605597999942,
                  56.086330471000124
                ],
                [
                  -5.530100063999896,
                  56.092189846000068
                ],
                [
                  -5.534738735999923,
                  56.098537502000013
                ],
                [
                  -5.541411912999877,
                  56.102484442
                ],
                [
                  -5.547515428999873,
                  56.10488515800013
                ],
                [
                  -5.550526495999861,
                  56.106431382000082
                ],
                [
                  -5.556955532999979,
                  56.122219143000123
                ],
                [
                  -5.558705206999974,
                  56.130804755000142
                ],
                [
                  -5.554676886999914,
                  56.137396552000112
                ],
                [
                  -5.522531704999949,
                  56.165757554000052
                ],
                [
                  -5.515736456999917,
                  56.17470937700007
                ],
                [
                  -5.509632941999911,
                  56.188381252000013
                ],
                [
                  -5.539906378999916,
                  56.183417059000149
                ],
                [
                  -5.562489386999886,
                  56.167914130000057
                ],
                [
                  -5.58267167899993,
                  56.150580145000063
                ],
                [
                  -5.605783657999979,
                  56.139960028000118
                ],
                [
                  -5.599354620999861,
                  56.160589911000145
                ],
                [
                  -5.58641516799986,
                  56.181138413999989
                ],
                [
                  -5.569406704999892,
                  56.20026276200015
                ],
                [
                  -5.550526495999861,
                  56.216294664000046
                ],
                [
                  -5.559437628999888,
                  56.229559637000179
                ],
                [
                  -5.547230597999914,
                  56.240179755000113
                ],
                [
                  -5.52562415299991,
                  56.247259833
                ],
                [
                  -5.506174282999922,
                  56.249823309000092
                ],
                [
                  -5.494740363999881,
                  56.253119208000115
                ],
                [
                  -5.492827928999901,
                  56.260402736000131
                ],
                [
                  -5.499256964999916,
                  56.267645575000174
                ],
                [
                  -5.512684699999909,
                  56.270941473
                ],
                [
                  -5.554269985999895,
                  56.263495184000035
                ],
                [
                  -5.56314042899993,
                  56.260321356000148
                ],
                [
                  -5.572621222999942,
                  56.253851630000057
                ],
                [
                  -5.582346157999893,
                  56.248765367000047
                ],
                [
                  -5.592152472999914,
                  56.249823309000092
                ],
                [
                  -5.598052537999877,
                  56.258612372000144
                ],
                [
                  -5.595570441999939,
                  56.269924221000124
                ],
                [
                  -5.584624803999873,
                  56.290757554000109
                ],
                [
                  -5.57258053299995,
                  56.32807038
                ],
                [
                  -5.562733527999853,
                  56.34105052299999
                ],
                [
                  -5.543690558999856,
                  56.352850653000147
                ],
                [
                  -5.525217251999919,
                  56.346625067
                ],
                [
                  -5.49819902299987,
                  56.348334052
                ],
                [
                  -5.448109503999945,
                  56.35968659100017
                ],
                [
                  -5.448109503999945,
                  56.365912177000112
                ],
                [
                  -5.472157355999912,
                  56.364935614000061
                ],
                [
                  -5.51537024599989,
                  56.35683828300013
                ],
                [
                  -5.537505662999877,
                  56.35968659100017
                ],
                [
                  -5.517323370999861,
                  56.392767645000035
                ],
                [
                  -5.509632941999911,
                  56.400620835
                ],
                [
                  -5.498931443999908,
                  56.404730536000145
                ],
                [
                  -5.48607337099989,
                  56.408107815000065
                ],
                [
                  -5.478016730999855,
                  56.412909247000144
                ],
                [
                  -5.482289191999939,
                  56.42112864800005
                ],
                [
                  -5.457020636999914,
                  56.440863348000093
                ],
                [
                  -5.423573370999861,
                  56.450018622000144
                ],
                [
                  -5.322865363999938,
                  56.454982815000037
                ],
                [
                  -5.242054816999939,
                  56.442206122000172
                ],
                [
                  -5.208729620999861,
                  56.446844794000086
                ],
                [
                  -5.181874152999882,
                  56.459662177000141
                ],
                [
                  -5.118519660999937,
                  56.50775788
                ],
                [
                  -5.085682745999947,
                  56.548773505000113
                ],
                [
                  -5.064564581999917,
                  56.565130927000112
                ],
                [
                  -5.086537238999938,
                  56.558498440000065
                ],
                [
                  -5.099598761999914,
                  56.543646552
                ],
                [
                  -5.110585089999887,
                  56.525864976000108
                ],
                [
                  -5.125965949999909,
                  56.510484117000075
                ],
                [
                  -5.166900193999936,
                  56.490057684000092
                ],
                [
                  -5.190174933999856,
                  56.46865469000015
                ],
                [
                  -5.201079881999931,
                  56.462103583000058
                ],
                [
                  -5.243763800999943,
                  56.45921458500014
                ],
                [
                  -5.350168423999918,
                  56.472967841000141
                ],
                [
                  -5.378081834999875,
                  56.45897044499999
                ],
                [
                  -5.394276495999918,
                  56.465480861000074
                ],
                [
                  -5.410552537999962,
                  56.503648179000052
                ],
                [
                  -5.424143032999922,
                  56.500067450000174
                ],
                [
                  -5.435943162999877,
                  56.491156317000147
                ],
                [
                  -5.454986131999874,
                  56.469549872000144
                ],
                [
                  -5.468617316999911,
                  56.475734768
                ],
                [
                  -5.43333899599989,
                  56.52362702000012
                ],
                [
                  -5.427642381999903,
                  56.537827867000047
                ],
                [
                  -5.403797980999912,
                  56.524603583
                ],
                [
                  -5.379261847999885,
                  56.519191799000154
                ],
                [
                  -5.356678839999916,
                  56.519680080000128
                ],
                [
                  -5.338286912999877,
                  56.524155992000104
                ],
                [
                  -5.290516730999855,
                  56.544663804000052
                ],
                [
                  -5.265044725999928,
                  56.551214911000145
                ],
                [
                  -5.25255286399991,
                  56.556341864000061
                ],
                [
                  -5.242054816999939,
                  56.565130927000112
                ],
                [
                  -5.275624152999882,
                  56.553615627000099
                ],
                [
                  -5.286773240999906,
                  56.552069403000147
                ],
                [
                  -5.30679277299987,
                  56.552801825000174
                ],
                [
                  -5.310943162999905,
                  56.552069403000147
                ],
                [
                  -5.327707485999923,
                  56.544663804000052
                ],
                [
                  -5.338693813999896,
                  56.542303778000118
                ],
                [
                  -5.36034094999988,
                  56.532212632000139
                ],
                [
                  -5.37242591099988,
                  56.530340887000179
                ],
                [
                  -5.384348110999923,
                  56.533433335000055
                ],
                [
                  -5.400502081999889,
                  56.543646552
                ],
                [
                  -5.413929816999882,
                  56.544663804000052
                ],
                [
                  -5.410878058999884,
                  56.552069403000147
                ],
                [
                  -5.407297329999921,
                  56.555324611000103
                ],
                [
                  -5.402699347999885,
                  56.557440497000115
                ],
                [
                  -5.39663652299987,
                  56.561712958000115
                ],
                [
                  -5.392689581999889,
                  56.566473700000117
                ],
                [
                  -5.389312303999873,
                  56.574896552000055
                ],
                [
                  -5.386626756999903,
                  56.578802802000055
                ],
                [
                  -5.36070716099988,
                  56.606268622000115
                ],
                [
                  -5.351918097999914,
                  56.612941799000154
                ],
                [
                  -5.310861782999922,
                  56.633612372000172
                ],
                [
                  -5.304514126999891,
                  56.640163479000151
                ],
                [
                  -5.298451300999886,
                  56.646429755000113
                ],
                [
                  -5.317779100999928,
                  56.653876044000086
                ],
                [
                  -5.317779100999928,
                  56.661322333000058
                ],
                [
                  -5.30907141799986,
                  56.664252020000092
                ],
                [
                  -5.286773240999906,
                  56.674994208
                ],
                [
                  -5.261463995999861,
                  56.673325913999989
                ],
                [
                  -5.248199022999927,
                  56.674058335000112
                ],
                [
                  -5.218902147999899,
                  56.688666083000143
                ],
                [
                  -5.196441209999904,
                  56.688666083000143
                ],
                [
                  -5.15330969999988,
                  56.681219794000143
                ],
                [
                  -5.132639126999976,
                  56.684515692
                ],
                [
                  -5.093373175999943,
                  56.699042059000035
                ],
                [
                  -5.012806769999912,
                  56.709295966000141
                ],
                [
                  -4.995594855999883,
                  56.715969143000038
                ],
                [
                  -5.160552537999905,
                  56.695868231000148
                ],
                [
                  -5.238270636999914,
                  56.716620184000149
                ],
                [
                  -5.238514777999882,
                  56.722560940000093
                ],
                [
                  -5.228423631999903,
                  56.736476955000072
                ],
                [
                  -5.222075975999871,
                  56.74152252800009
                ],
                [
                  -5.154652472999885,
                  56.78229401200015
                ],
                [
                  -5.136382615999906,
                  56.798773505000057
                ],
                [
                  -5.119740363999938,
                  56.818426825000117
                ],
                [
                  -5.179066535999937,
                  56.789252020000063
                ],
                [
                  -5.187489386999886,
                  56.781154690000122
                ],
                [
                  -5.191761847999885,
                  56.774644273000135
                ],
                [
                  -5.202259894999941,
                  56.769110419000029
                ],
                [
                  -5.214670376999891,
                  56.765204169000029
                ],
                [
                  -5.224964972999914,
                  56.763739325000145
                ],
                [
                  -5.233469204999921,
                  56.760687567000062
                ],
                [
                  -5.237049933999913,
                  56.753363348000065
                ],
                [
                  -5.238921678999873,
                  56.744452216000028
                ],
                [
                  -5.242054816999939,
                  56.736476955000072
                ],
                [
                  -5.255238410999908,
                  56.721584377000013
                ],
                [
                  -5.268462693999936,
                  56.713080145000092
                ],
                [
                  -5.283355272999899,
                  56.709377346000124
                ],
                [
                  -5.30101477799991,
                  56.708563544000029
                ],
                [
                  -5.309803839999887,
                  56.706488348
                ],
                [
                  -5.319162563999896,
                  56.697495835
                ],
                [
                  -5.34015865799995,
                  56.693060614000117
                ],
                [
                  -5.348378058999856,
                  56.687201239000089
                ],
                [
                  -5.359364386999914,
                  56.674994208
                ],
                [
                  -5.38805091099988,
                  56.65521881700009
                ],
                [
                  -5.403879360999895,
                  56.649237372000144
                ],
                [
                  -5.424224412999905,
                  56.647040106000148
                ],
                [
                  -5.434396938999925,
                  56.642889716000028
                ],
                [
                  -5.448719855999912,
                  56.624579169000171
                ],
                [
                  -5.458119269999941,
                  56.62034739800005
                ],
                [
                  -5.470773891999926,
                  56.618394273000021
                ],
                [
                  -5.482574022999899,
                  56.61326732
                ],
                [
                  -5.493316209999904,
                  56.60639069200009
                ],
                [
                  -5.53343665299991,
                  56.572902736000046
                ],
                [
                  -5.599598761999914,
                  56.529038804000081
                ],
                [
                  -5.667388475999928,
                  56.498480536000145
                ],
                [
                  -5.674061652999882,
                  56.496893622000115
                ],
                [
                  -5.6830134759999,
                  56.500637111000131
                ],
                [
                  -5.694691535999908,
                  56.513861395000092
                ],
                [
                  -5.705393032999922,
                  56.516669012000037
                ],
                [
                  -5.721791144999912,
                  56.518500067000119
                ],
                [
                  -5.74083411399991,
                  56.523260809000121
                ],
                [
                  -5.758208787999905,
                  56.529974677000055
                ],
                [
                  -5.770253058999913,
                  56.537827867000047
                ],
                [
                  -5.755197719999899,
                  56.55402252800009
                ],
                [
                  -5.751047329999949,
                  56.561997789000046
                ],
                [
                  -5.749134894999912,
                  56.571966864000146
                ],
                [
                  -5.756662563999953,
                  56.571966864000146
                ],
                [
                  -5.793853318999936,
                  56.543280341000084
                ],
                [
                  -5.854359503999945,
                  56.550482489000117
                ],
                [
                  -6.003407355999855,
                  56.618719794000029
                ],
                [
                  -6.009836391999954,
                  56.626532294000114
                ],
                [
                  -6.008168097999942,
                  56.642279364000061
                ],
                [
                  -5.998036261999886,
                  56.649888414000102
                ],
                [
                  -5.983509894999941,
                  56.652818101000136
                ],
                [
                  -5.933583136999914,
                  56.654730536
                ],
                [
                  -5.89903723899991,
                  56.650824286
                ],
                [
                  -5.866851365999963,
                  56.641546942000147
                ],
                [
                  -5.839182094999956,
                  56.626532294000114
                ],
                [
                  -5.831695115999906,
                  56.633978583
                ],
                [
                  -5.85562089799987,
                  56.64472077
                ],
                [
                  -5.865589972999942,
                  56.65143463700015
                ],
                [
                  -5.865834113999881,
                  56.661322333000058
                ],
                [
                  -5.759999152999882,
                  56.700751044000057
                ],
                [
                  -5.735503709999961,
                  56.702337958000086
                ],
                [
                  -5.672596808999913,
                  56.684149481000176
                ],
                [
                  -5.647368943999936,
                  56.681219794000143
                ],
                [
                  -5.594146287999877,
                  56.683335679000081
                ],
                [
                  -5.564808722999942,
                  56.687648830000072
                ],
                [
                  -5.543690558999856,
                  56.695461330000157
                ],
                [
                  -5.636545376999948,
                  56.688666083000143
                ],
                [
                  -5.658558722999942,
                  56.690741278000147
                ],
                [
                  -5.708851691999911,
                  56.708563544000029
                ],
                [
                  -5.749989386999914,
                  56.714544989000146
                ],
                [
                  -5.859038865999878,
                  56.681219794000143
                ],
                [
                  -5.896799282999922,
                  56.675116278000175
                ],
                [
                  -5.907378709999875,
                  56.674994208
                ],
                [
                  -5.920318162999877,
                  56.677964585000112
                ],
                [
                  -5.942738410999908,
                  56.68675364799999
                ],
                [
                  -5.955555792999917,
                  56.688666083000143
                ],
                [
                  -6.024891730999883,
                  56.685695705000043
                ],
                [
                  -6.098622199999909,
                  56.696966864000117
                ],
                [
                  -6.123850063999896,
                  56.695624091000028
                ],
                [
                  -6.143544074999909,
                  56.684881903000118
                ],
                [
                  -6.161732550999915,
                  56.678208726000051
                ],
                [
                  -6.186594204999949,
                  56.681097723000093
                ],
                [
                  -6.20962480399993,
                  56.688462632
                ],
                [
                  -6.222767706999889,
                  56.695461330000157
                ],
                [
                  -6.228179490999935,
                  56.701076565000065
                ],
                [
                  -6.232533331999917,
                  56.706529039000102
                ],
                [
                  -6.23534094999988,
                  56.712388414000046
                ],
                [
                  -6.236398891999926,
                  56.719061591000113
                ],
                [
                  -6.234486456999889,
                  56.728583075000088
                ],
                [
                  -6.229562954999921,
                  56.729071356000176
                ],
                [
                  -6.222767706999889,
                  56.727199611000017
                ],
                [
                  -6.215321417999917,
                  56.729641018000152
                ],
                [
                  -6.193470831999974,
                  56.748521225999987
                ],
                [
                  -6.180531378999945,
                  56.754624742000075
                ],
                [
                  -6.026966925999915,
                  56.763739325000145
                ],
                [
                  -6.014881964999887,
                  56.767035223
                ],
                [
                  -5.9798884759999,
                  56.781561591000056
                ],
                [
                  -5.965199347999885,
                  56.784857489000089
                ],
                [
                  -5.948231574999909,
                  56.782538153000118
                ],
                [
                  -5.937977667999888,
                  56.776922919000114
                ],
                [
                  -5.928537563999896,
                  56.769964911000116
                ],
                [
                  -5.913644985999923,
                  56.763739325000145
                ],
                [
                  -5.860910610999923,
                  56.750799872000144
                ],
                [
                  -5.85220292899993,
                  56.746975002000127
                ],
                [
                  -5.853342251999891,
                  56.757879950000117
                ],
                [
                  -5.858143683999884,
                  56.76845937700007
                ],
                [
                  -5.868397589999887,
                  56.775864976000051
                ],
                [
                  -5.886341925999943,
                  56.777411200000088
                ],
                [
                  -5.886341925999943,
                  56.784857489000089
                ],
                [
                  -5.874012824999909,
                  56.785711981000176
                ],
                [
                  -5.861805792999917,
                  56.785101630000113
                ],
                [
                  -5.850087042999945,
                  56.782456773000135
                ],
                [
                  -5.839182094999956,
                  56.777411200000088
                ],
                [
                  -5.824615037999934,
                  56.787583726000051
                ],
                [
                  -5.802072719999956,
                  56.791815497000144
                ],
                [
                  -5.776600714999859,
                  56.787990627000156
                ],
                [
                  -5.756662563999953,
                  56.784857489000089
                ],
                [
                  -5.831695115999906,
                  56.805365302000112
                ],
                [
                  -5.850819464999859,
                  56.818019924000012
                ],
                [
                  -5.851185675999886,
                  56.828924872000172
                ],
                [
                  -5.837473110999952,
                  56.836615302
                ],
                [
                  -5.73387610599994,
                  56.844794012000094
                ],
                [
                  -5.692738410999937,
                  56.854925848000065
                ],
                [
                  -5.660389777999853,
                  56.872992255000085
                ],
                [
                  -5.67357337099989,
                  56.876532294000143
                ],
                [
                  -5.69200598899991,
                  56.875311591000141
                ],
                [
                  -5.708485480999912,
                  56.87055084800015
                ],
                [
                  -5.724354620999918,
                  56.853827216000113
                ],
                [
                  -5.744496222999885,
                  56.854152736000131
                ],
                [
                  -5.783924933999856,
                  56.859930731000091
                ],
                [
                  -5.775380011999914,
                  56.869940497000087
                ],
                [
                  -5.735503709999961,
                  56.894110419000086
                ],
                [
                  -5.780588344999927,
                  56.898749091000028
                ],
                [
                  -5.874867316999911,
                  56.887152411
                ],
                [
                  -5.921131964999887,
                  56.894110419000086
                ],
                [
                  -5.887562628999945,
                  56.899115302000141
                ],
                [
                  -5.85220292899993,
                  56.900336005000057
                ],
                [
                  -5.85220292899993,
                  56.907700914000046
                ],
                [
                  -5.859852667999888,
                  56.910549221000096
                ],
                [
                  -5.880116339999887,
                  56.922023830000128
                ],
                [
                  -5.862538214999859,
                  56.933742580000015
                ],
                [
                  -5.851429816999911,
                  56.954250393000066
                ],
                [
                  -5.842518683999884,
                  56.977443752000013
                ],
                [
                  -5.831695115999906,
                  56.997137762000065
                ],
                [
                  -5.814116990999878,
                  57.009507554
                ],
                [
                  -5.786040818999965,
                  57.020575262000122
                ],
                [
                  -5.75523841099988,
                  57.026556708000143
                ],
                [
                  -5.729318813999896,
                  57.023830471000068
                ],
                [
                  -5.719878709999875,
                  57.017564195000105
                ],
                [
                  -5.699940558999884,
                  56.998114325000031
                ],
                [
                  -5.688303188999981,
                  56.989691473000065
                ],
                [
                  -5.674061652999882,
                  56.983587958000086
                ],
                [
                  -5.658558722999942,
                  56.979478257000139
                ],
                [
                  -5.625599738999881,
                  56.976629950000088
                ],
                [
                  -5.571278449999852,
                  56.983832098000121
                ],
                [
                  -5.523264126999976,
                  56.997137762000065
                ],
                [
                  -5.523264126999976,
                  57.003973700000145
                ],
                [
                  -5.5404353509999,
                  57.001166083000115
                ],
                [
                  -5.556507941999882,
                  56.99607982
                ],
                [
                  -5.571278449999852,
                  56.993312893000123
                ],
                [
                  -5.584624803999873,
                  56.997137762000065
                ],
                [
                  -5.607085740999878,
                  56.98851146000014
                ],
                [
                  -5.628814256999931,
                  56.991888739000061
                ],
                [
                  -5.649891730999883,
                  56.999660549000069
                ],
                [
                  -5.670318162999934,
                  57.003973700000145
                ],
                [
                  -5.685536261999914,
                  57.009588934000149
                ],
                [
                  -5.681711391999897,
                  57.022406317
                ],
                [
                  -5.680043097999885,
                  57.036200262000094
                ],
                [
                  -5.701975063999925,
                  57.04490794499999
                ],
                [
                  -5.710926886999857,
                  57.044175523000078
                ],
                [
                  -5.731353318999908,
                  57.039007880000057
                ],
                [
                  -5.74233964799987,
                  57.038072007000082
                ],
                [
                  -5.75255286399991,
                  57.040594794000086
                ],
                [
                  -5.769602016999954,
                  57.049750067000062
                ],
                [
                  -5.780181443999908,
                  57.05174388200011
                ],
                [
                  -5.791127081999889,
                  57.059271552000084
                ],
                [
                  -5.776193813999925,
                  57.075832424000126
                ],
                [
                  -5.734486456999889,
                  57.10541413
                ],
                [
                  -5.722645636999914,
                  57.116441148000135
                ],
                [
                  -5.715646938999953,
                  57.120062567
                ],
                [
                  -5.703277147999899,
                  57.120754299000126
                ],
                [
                  -5.673695441999939,
                  57.119045315000122
                ],
                [
                  -5.663482225999928,
                  57.123724677000055
                ],
                [
                  -5.645863410999908,
                  57.129461981000034
                ],
                [
                  -5.62083899599989,
                  57.12409088700015
                ],
                [
                  -5.578439907999893,
                  57.106390692000062
                ],
                [
                  -5.558257615999878,
                  57.100409247000144
                ],
                [
                  -5.459828253999945,
                  57.099798895000092
                ],
                [
                  -5.454986131999874,
                  57.10297272300015
                ],
                [
                  -5.447417772999927,
                  57.110174872000087
                ],
                [
                  -5.430775519999884,
                  57.110744533000158
                ],
                [
                  -5.414296027999882,
                  57.108221747000059
                ],
                [
                  -5.407215949999937,
                  57.106390692000062
                ],
                [
                  -5.400380011999914,
                  57.106390692000062
                ],
                [
                  -5.400380011999914,
                  57.113836981000034
                ],
                [
                  -5.420033331999946,
                  57.120672919000143
                ],
                [
                  -5.503895636999857,
                  57.112697658000016
                ],
                [
                  -5.527414516999897,
                  57.107489325000117
                ],
                [
                  -5.540638800999943,
                  57.106390692000062
                ],
                [
                  -5.547718878999916,
                  57.110093492000104
                ],
                [
                  -5.573312954999892,
                  57.127875067
                ],
                [
                  -5.584624803999873,
                  57.133693752000127
                ],
                [
                  -5.668446417999888,
                  57.147650458000115
                ],
                [
                  -5.680897589999887,
                  57.157904364000146
                ],
                [
                  -5.673817511999914,
                  57.174994208
                ],
                [
                  -5.638824022999927,
                  57.20237864800005
                ],
                [
                  -5.625599738999881,
                  57.216253973000121
                ],
                [
                  -5.644154425999886,
                  57.233221747000115
                ],
                [
                  -5.620106574999852,
                  57.25214264500012
                ],
                [
                  -5.578236456999946,
                  57.266750393000152
                ],
                [
                  -5.543690558999856,
                  57.270900783000101
                ],
                [
                  -5.511586066999882,
                  57.257635809000149
                ],
                [
                  -5.480091925999943,
                  57.237005927000141
                ],
                [
                  -5.44627844999988,
                  57.223049221000068
                ],
                [
                  -5.407215949999937,
                  57.229925848000065
                ],
                [
                  -5.407215949999937,
                  57.236721096000011
                ],
                [
                  -5.448841925999886,
                  57.242092190000065
                ],
                [
                  -5.458119269999941,
                  57.246649481000091
                ],
                [
                  -5.472889777999939,
                  57.261216539000131
                ],
                [
                  -5.482899542999917,
                  57.268011786000059
                ],
                [
                  -5.492502407999893,
                  57.270900783000101
                ],
                [
                  -5.501942511999914,
                  57.277655341000028
                ],
                [
                  -5.48892167899993,
                  57.292425848
                ],
                [
                  -5.464833136999886,
                  57.306626695000134
                ],
                [
                  -5.440663214999887,
                  57.311835028000118
                ],
                [
                  -5.440663214999887,
                  57.319281317
                ],
                [
                  -5.46499589799987,
                  57.32493724199999
                ],
                [
                  -5.481760219999956,
                  57.316717841000084
                ],
                [
                  -5.49429277299987,
                  57.304429429000137
                ],
                [
                  -5.506174282999922,
                  57.298163153000175
                ],
                [
                  -5.523426886999943,
                  57.295152085000083
                ],
                [
                  -5.558461066999911,
                  57.281439520000148
                ],
                [
                  -5.578439907999893,
                  57.277655341000028
                ],
                [
                  -5.599436001999948,
                  57.279242255000057
                ],
                [
                  -5.637440558999856,
                  57.28900788
                ],
                [
                  -5.656971808999913,
                  57.29132721600017
                ],
                [
                  -5.700062628999945,
                  57.283596096000153
                ],
                [
                  -5.720570441999911,
                  57.284491278000147
                ],
                [
                  -5.729318813999896,
                  57.298163153000175
                ],
                [
                  -5.72524980399993,
                  57.301581122000087
                ],
                [
                  -5.701975063999925,
                  57.33234284100017
                ],
                [
                  -5.693755662999905,
                  57.337103583000086
                ],
                [
                  -5.671986456999946,
                  57.344427802000084
                ],
                [
                  -5.663482225999928,
                  57.349676825000145
                ],
                [
                  -5.654367641999926,
                  57.353949286000088
                ],
                [
                  -5.647206183999884,
                  57.349920966000113
                ],
                [
                  -5.641468878999916,
                  57.343207098000065
                ],
                [
                  -5.636545376999948,
                  57.339789130000057
                ],
                [
                  -5.613189256999874,
                  57.341986395000148
                ],
                [
                  -5.501291469999956,
                  57.370998440000122
                ],
                [
                  -5.456654425999886,
                  57.39354075700011
                ],
                [
                  -5.448109503999945,
                  57.421698309000092
                ],
                [
                  -5.465077277999853,
                  57.423895575000088
                ],
                [
                  -5.492054816999882,
                  57.408758856000091
                ],
                [
                  -5.537505662999877,
                  57.373928127000156
                ],
                [
                  -5.56346594999988,
                  57.363104559000149
                ],
                [
                  -5.586659308999913,
                  57.365057684000092
                ],
                [
                  -5.610910610999895,
                  57.371405341000028
                ],
                [
                  -5.639963344999956,
                  57.373928127000156
                ],
                [
                  -5.615589972999914,
                  57.382473049000069
                ],
                [
                  -5.607085740999878,
                  57.389105536000145
                ],
                [
                  -5.609201626999891,
                  57.397772528000033
                ],
                [
                  -5.617746548999918,
                  57.410101630000085
                ],
                [
                  -5.619618292999888,
                  57.416693427000055
                ],
                [
                  -5.624012824999852,
                  57.416408596000039
                ],
                [
                  -5.639963344999956,
                  57.408026434000149
                ],
                [
                  -5.707183397999899,
                  57.359767971000124
                ],
                [
                  -5.732411261999886,
                  57.35276927300005
                ],
                [
                  -5.7845759759999,
                  57.348578192000119
                ],
                [
                  -5.807769334999932,
                  57.35492584800015
                ],
                [
                  -5.824859178999873,
                  57.394354559000121
                ],
                [
                  -5.822255011999886,
                  57.393500067000119
                ],
                [
                  -5.817372199999909,
                  57.395209052000112
                ],
                [
                  -5.812855597999942,
                  57.398098049000154
                ],
                [
                  -5.81118730399993,
                  57.401190497000059
                ],
                [
                  -5.813872850999928,
                  57.404527085000083
                ],
                [
                  -5.823109503999888,
                  57.412339585000055
                ],
                [
                  -5.824859178999873,
                  57.415472723000121
                ],
                [
                  -5.825266079999892,
                  57.428900458000115
                ],
                [
                  -5.821888800999943,
                  57.43553294499999
                ],
                [
                  -5.81118730399993,
                  57.442206122000144
                ],
                [
                  -5.821522589999859,
                  57.4454613300001
                ],
                [
                  -5.85252844999988,
                  57.450384833000058
                ],
                [
                  -5.859038865999878,
                  57.452704169000029
                ],
                [
                  -5.861195441999882,
                  57.463446356000034
                ],
                [
                  -5.8705134759999,
                  57.480780341000028
                ],
                [
                  -5.872670050999915,
                  57.493719794000029
                ],
                [
                  -5.86969967399989,
                  57.50088125200007
                ],
                [
                  -5.856068488999938,
                  57.517808335000055
                ],
                [
                  -5.85220292899993,
                  57.524115302
                ],
                [
                  -5.851063605999912,
                  57.53839752800009
                ],
                [
                  -5.851470506999903,
                  57.551092841000141
                ],
                [
                  -5.847075975999928,
                  57.558905341000141
                ],
                [
                  -5.831695115999906,
                  57.558823960000055
                ],
                [
                  -5.833851691999882,
                  57.563381252000013
                ],
                [
                  -5.837025519999941,
                  57.574774481000148
                ],
                [
                  -5.839182094999956,
                  57.579291083000115
                ],
                [
                  -5.821400519999884,
                  57.583197333000115
                ],
                [
                  -5.803618943999879,
                  57.581366278000061
                ],
                [
                  -5.786366339999887,
                  57.575181382000082
                ],
                [
                  -5.732574022999927,
                  57.545233466000113
                ],
                [
                  -5.715646938999953,
                  57.53839752800009
                ],
                [
                  -5.707020636999857,
                  57.542303778000175
                ],
                [
                  -5.689768032999922,
                  57.527899481000119
                ],
                [
                  -5.680897589999887,
                  57.524115302
                ],
                [
                  -5.65086829299986,
                  57.512640692000147
                ],
                [
                  -5.639963344999956,
                  57.511053778000118
                ],
                [
                  -5.645334438999925,
                  57.516669012000122
                ],
                [
                  -5.648304816999939,
                  57.521877346000011
                ],
                [
                  -5.650542772999927,
                  57.526800848000065
                ],
                [
                  -5.653553839999916,
                  57.53156159100017
                ],
                [
                  -5.581532355999883,
                  57.53839752800009
                ],
                [
                  -5.540272589999944,
                  57.53449127800009
                ],
                [
                  -5.516835089999859,
                  57.534857489
                ],
                [
                  -5.512684699999909,
                  57.541489976000079
                ],
                [
                  -5.54312089799987,
                  57.555365302000055
                ],
                [
                  -5.588368292999917,
                  57.561021226000051
                ],
                [
                  -5.632720506999931,
                  57.557684637000122
                ],
                [
                  -5.660389777999853,
                  57.544582424000154
                ],
                [
                  -5.694488084999932,
                  57.566310940000122
                ],
                [
                  -5.689198370999861,
                  57.569403387000122
                ],
                [
                  -5.680897589999887,
                  57.579291083000115
                ],
                [
                  -5.71422278599988,
                  57.582709052000141
                ],
                [
                  -5.731678839999859,
                  57.598293361000046
                ],
                [
                  -5.744252081999917,
                  57.617987372000172
                ],
                [
                  -5.762806769999941,
                  57.633978583000058
                ],
                [
                  -5.778146938999896,
                  57.637437242000075
                ],
                [
                  -5.793609178999901,
                  57.638576565
                ],
                [
                  -5.805897589999859,
                  57.642645575000145
                ],
                [
                  -5.81118730399993,
                  57.655096747000172
                ],
                [
                  -5.805409308999884,
                  57.667181708000086
                ],
                [
                  -5.785023566999882,
                  57.679510809000035
                ],
                [
                  -5.790760870999861,
                  57.688544012000037
                ],
                [
                  -5.790760870999861,
                  57.695990302000112
                ],
                [
                  -5.753570115999878,
                  57.707464911000059
                ],
                [
                  -5.734486456999889,
                  57.707953192000147
                ],
                [
                  -5.704986131999903,
                  57.690130927000084
                ],
                [
                  -5.692494269999912,
                  57.691066799000154
                ],
                [
                  -5.68195553299995,
                  57.698716538999989
                ],
                [
                  -5.674061652999882,
                  57.709662177000055
                ],
                [
                  -5.685170050999915,
                  57.711411851000051
                ],
                [
                  -5.692290818999936,
                  57.716498114000061
                ],
                [
                  -5.698841925999943,
                  57.723089911000145
                ],
                [
                  -5.708851691999911,
                  57.729559637000065
                ],
                [
                  -5.720529751999919,
                  57.733384507000054
                ],
                [
                  -5.803822394999941,
                  57.743841864000146
                ],
                [
                  -5.806955532999922,
                  57.754624742000047
                ],
                [
                  -5.802072719999956,
                  57.780585028000033
                ],
                [
                  -5.803822394999941,
                  57.79222239800005
                ],
                [
                  -5.801258917999945,
                  57.800441799000126
                ],
                [
                  -5.809925910999937,
                  57.82062409100017
                ],
                [
                  -5.81118730399993,
                  57.833197333000058
                ],
                [
                  -5.807362433999913,
                  57.843939520000092
                ],
                [
                  -5.799956834999932,
                  57.85370514500012
                ],
                [
                  -5.78954016799986,
                  57.862005927
                ],
                [
                  -5.776519334999875,
                  57.867905992000132
                ],
                [
                  -5.751128709999932,
                  57.87335846600017
                ],
                [
                  -5.724761522999927,
                  57.873521226000136
                ],
                [
                  -5.6986384759999,
                  57.869086005000057
                ],
                [
                  -5.674061652999882,
                  57.860500393000152
                ],
                [
                  -5.677886522999899,
                  57.84690989799999
                ],
                [
                  -5.674794074999909,
                  57.82709381700009
                ],
                [
                  -5.667958136999886,
                  57.806952216000056
                ],
                [
                  -5.660389777999853,
                  57.79222239800005
                ],
                [
                  -5.650542772999927,
                  57.781805731000148
                ],
                [
                  -5.637359178999873,
                  57.774237372000115
                ],
                [
                  -5.622141079999892,
                  57.770209052000141
                ],
                [
                  -5.605783657999979,
                  57.770493882000082
                ],
                [
                  -5.613270636999857,
                  57.775213934000178
                ],
                [
                  -5.617909308999884,
                  57.780218817000119
                ],
                [
                  -5.625599738999881,
                  57.79222239800005
                ],
                [
                  -5.61302649599989,
                  57.792629299000154
                ],
                [
                  -5.603260870999861,
                  57.791083075000117
                ],
                [
                  -5.584624803999873,
                  57.784816799000154
                ],
                [
                  -5.591175910999937,
                  57.804429429000109
                ],
                [
                  -5.587025519999912,
                  57.81858958500014
                ],
                [
                  -5.585275844999927,
                  57.831447658000073
                ],
                [
                  -5.598988410999937,
                  57.846869208
                ],
                [
                  -5.637562628999916,
                  57.866359768000095
                ],
                [
                  -5.650380011999857,
                  57.877752997000144
                ],
                [
                  -5.639963344999956,
                  57.887844143000038
                ],
                [
                  -5.647694464999887,
                  57.888983466000141
                ],
                [
                  -5.650786912999877,
                  57.89081452000012
                ],
                [
                  -5.653553839999916,
                  57.894680080000128
                ],
                [
                  -5.643950975999928,
                  57.904201565000122
                ],
                [
                  -5.620757615999906,
                  57.920884507000082
                ],
                [
                  -5.612619594999899,
                  57.928778387000037
                ],
                [
                  -5.598215298999918,
                  57.919012762000094
                ],
                [
                  -5.587310350999957,
                  57.915106512000094
                ],
                [
                  -5.550526495999861,
                  57.915106512000094
                ],
                [
                  -5.556263800999943,
                  57.887762762000037
                ],
                [
                  -5.52790279899989,
                  57.867580471000011
                ],
                [
                  -5.487049933999856,
                  57.855861721000039
                ],
                [
                  -5.454986131999874,
                  57.85370514500012
                ],
                [
                  -5.461171027999853,
                  57.860500393000152
                ],
                [
                  -5.449045376999948,
                  57.869126695000048
                ],
                [
                  -5.437123175999915,
                  57.897650458000143
                ],
                [
                  -5.427642381999903,
                  57.908270575000088
                ],
                [
                  -5.414906378999945,
                  57.908148505000113
                ],
                [
                  -5.369496222999942,
                  57.897528387000179
                ],
                [
                  -5.35562089799987,
                  57.891262111000046
                ],
                [
                  -5.32750403599988,
                  57.873277085
                ],
                [
                  -5.293853318999879,
                  57.86204661699999
                ],
                [
                  -5.221587693999879,
                  57.846869208
                ],
                [
                  -5.236317511999886,
                  57.860785223000093
                ],
                [
                  -5.247547980999883,
                  57.867010809000035
                ],
                [
                  -5.276763475999928,
                  57.874172268000095
                ],
                [
                  -5.320668097999942,
                  57.898504950000145
                ],
                [
                  -5.384917772999899,
                  57.914129950000031
                ],
                [
                  -5.39289303299995,
                  57.91819896
                ],
                [
                  -5.394398566999882,
                  57.923895575000174
                ],
                [
                  -5.396839972999914,
                  57.926214911000145
                ],
                [
                  -5.397328253999916,
                  57.928900458000115
                ],
                [
                  -5.39289303299995,
                  57.935614325000145
                ],
                [
                  -5.386545376999919,
                  57.93642812700007
                ],
                [
                  -5.378977016999954,
                  57.93183014500012
                ],
                [
                  -5.37173417899993,
                  57.931057033000016
                ],
                [
                  -5.366200324999909,
                  57.943060614000146
                ],
                [
                  -5.347157355999912,
                  57.93671295800003
                ],
                [
                  -5.319162563999896,
                  57.914740302
                ],
                [
                  -5.29735266799986,
                  57.908270575000088
                ],
                [
                  -5.286000128999888,
                  57.908758856000176
                ],
                [
                  -5.26695716099988,
                  57.914007880000057
                ],
                [
                  -5.256255662999877,
                  57.915106512000094
                ],
                [
                  -5.243641730999883,
                  57.912909247000115
                ],
                [
                  -5.221018032999922,
                  57.904038804000081
                ],
                [
                  -5.211293097999885,
                  57.902085679000109
                ],
                [
                  -5.198801235999952,
                  57.897772528000118
                ],
                [
                  -5.162261522999927,
                  57.878485419000086
                ],
                [
                  -5.119984503999888,
                  57.867987372000115
                ],
                [
                  -5.091135219999956,
                  57.840318101000108
                ],
                [
                  -5.070790167999888,
                  57.833197333000058
                ],
                [
                  -5.07648678299995,
                  57.838527736000131
                ],
                [
                  -5.083404100999871,
                  57.847560940000122
                ],
                [
                  -5.089344855999883,
                  57.857245184000092
                ],
                [
                  -5.091867641999897,
                  57.86420319200009
                ],
                [
                  -5.097157355999883,
                  57.870917059000035
                ],
                [
                  -5.197255011999914,
                  57.917873440000065
                ],
                [
                  -5.221587693999879,
                  57.921332098000065
                ],
                [
                  -5.221587693999879,
                  57.928778387000037
                ],
                [
                  -5.201893683999856,
                  57.928656317000062
                ],
                [
                  -5.193959113999881,
                  57.935980536000088
                ],
                [
                  -5.19554602799991,
                  57.947658596000068
                ],
                [
                  -5.204497850999928,
                  57.960150458000086
                ],
                [
                  -5.216704881999903,
                  57.96588776200015
                ],
                [
                  -5.248890753999973,
                  57.969387111000131
                ],
                [
                  -5.263172980999855,
                  57.97654857
                ],
                [
                  -5.292632615999935,
                  57.980617580000128
                ],
                [
                  -5.333892381999903,
                  58.00853099199999
                ],
                [
                  -5.359364386999914,
                  58.011379299000126
                ],
                [
                  -5.357167120999918,
                  58.014064846000011
                ],
                [
                  -5.356678839999916,
                  58.014878648000106
                ],
                [
                  -5.351918097999914,
                  58.017523505000028
                ],
                [
                  -5.366932745999861,
                  58.028876044000171
                ],
                [
                  -5.386586066999911,
                  58.032538153000033
                ],
                [
                  -5.427642381999903,
                  58.031195380000142
                ],
                [
                  -5.424305792999888,
                  58.035549221000124
                ],
                [
                  -5.422352667999917,
                  58.03896719000015
                ],
                [
                  -5.419585740999878,
                  58.042059637000037
                ],
                [
                  -5.413929816999882,
                  58.045477606000034
                ],
                [
                  -5.413929816999882,
                  58.052313544000143
                ],
                [
                  -5.447010870999918,
                  58.084377346000124
                ],
                [
                  -5.428089972999885,
                  58.097967841000084
                ],
                [
                  -5.3900447259999,
                  58.092189846000124
                ],
                [
                  -5.366200324999909,
                  58.065985419000086
                ],
                [
                  -5.34430904899989,
                  58.07550690300009
                ],
                [
                  -5.322865363999938,
                  58.071722723000065
                ],
                [
                  -5.300770636999857,
                  58.070135809000035
                ],
                [
                  -5.276763475999928,
                  58.086411851000079
                ],
                [
                  -5.283070441999939,
                  58.086411851000079
                ],
                [
                  -5.278065558999913,
                  58.096258856000176
                ],
                [
                  -5.278797980999855,
                  58.105373440000065
                ],
                [
                  -5.283558722999942,
                  58.11347077
                ],
                [
                  -5.290516730999855,
                  58.120550848000065
                ],
                [
                  -5.276763475999928,
                  58.120550848000065
                ],
                [
                  -5.276763475999928,
                  58.127386786000088
                ],
                [
                  -5.29735266799986,
                  58.134833075000145
                ],
                [
                  -5.284087693999908,
                  58.14008209800015
                ],
                [
                  -5.255523240999935,
                  58.14378489799999
                ],
                [
                  -5.242054816999939,
                  58.147894598000121
                ],
                [
                  -5.242054816999939,
                  58.155340887000122
                ],
                [
                  -5.275054490999906,
                  58.154527085
                ],
                [
                  -5.290842251999948,
                  58.156317450000088
                ],
                [
                  -5.304798956999917,
                  58.162095445000048
                ],
                [
                  -5.29735266799986,
                  58.168402411
                ],
                [
                  -5.304798956999917,
                  58.173325914000046
                ],
                [
                  -5.313059048999918,
                  58.177313544000029
                ],
                [
                  -5.321888800999886,
                  58.180243231000148
                ],
                [
                  -5.331450975999871,
                  58.182033596000124
                ],
                [
                  -5.329335089999859,
                  58.186712958000058
                ],
                [
                  -5.326161261999886,
                  58.198431708000143
                ],
                [
                  -5.32396399599989,
                  58.203111070000048
                ],
                [
                  -5.336822068999908,
                  58.203192450000031
                ],
                [
                  -5.346791144999912,
                  58.206854559000092
                ],
                [
                  -5.39289303299995,
                  58.244696356000034
                ],
                [
                  -5.39207923099994,
                  58.261379299000069
                ],
                [
                  -5.375884568999879,
                  58.264227606000119
                ],
                [
                  -5.352894660999908,
                  58.258937893000123
                ],
                [
                  -5.310780402999853,
                  58.243394273000135
                ],
                [
                  -5.293853318999879,
                  58.240912177000112
                ],
                [
                  -5.276966925999886,
                  58.243394273000135
                ],
                [
                  -5.237294074999852,
                  58.257635809000035
                ],
                [
                  -5.216053839999859,
                  58.261419989000061
                ],
                [
                  -5.194325324999909,
                  58.259995835
                ],
                [
                  -5.17320716099988,
                  58.250921942
                ],
                [
                  -5.165638800999943,
                  58.258246161
                ],
                [
                  -5.152251756999931,
                  58.264837958000086
                ],
                [
                  -5.138335740999935,
                  58.269598700000174
                ],
                [
                  -5.129383917999917,
                  58.27138906500015
                ],
                [
                  -5.111561652999853,
                  58.268255927000084
                ],
                [
                  -5.081288214999859,
                  58.254095770000063
                ],
                [
                  -5.067697719999899,
                  58.250921942
                ],
                [
                  -5.01773027299987,
                  58.253241278000147
                ],
                [
                  -5.002430792999917,
                  58.250921942
                ],
                [
                  -4.933583136999857,
                  58.223049221000124
                ],
                [
                  -4.943430141999954,
                  58.233587958
                ],
                [
                  -4.954823370999918,
                  58.239813544000143
                ],
                [
                  -4.982004360999923,
                  58.250921942
                ],
                [
                  -4.968861456999889,
                  58.256781317000119
                ],
                [
                  -4.940337693999879,
                  58.259466864000117
                ],
                [
                  -4.926747199999909,
                  58.264593817000119
                ],
                [
                  -4.990223761999914,
                  58.271429755000142
                ],
                [
                  -5.00991777299987,
                  58.27138906500015
                ],
                [
                  -5.018055792999888,
                  58.268622137000094
                ],
                [
                  -5.029367641999954,
                  58.259711005000057
                ],
                [
                  -5.040028449999909,
                  58.257757880000113
                ],
                [
                  -5.050119594999956,
                  58.259914455000015
                ],
                [
                  -5.070708787999905,
                  58.269232489000061
                ],
                [
                  -5.081654425999886,
                  58.27138906500015
                ],
                [
                  -5.096424933999856,
                  58.276760158000016
                ],
                [
                  -5.125965949999909,
                  58.300197658000101
                ],
                [
                  -5.136219855999855,
                  58.305568752000127
                ],
                [
                  -5.137440558999856,
                  58.309271552
                ],
                [
                  -5.156361456999889,
                  58.324611721000124
                ],
                [
                  -5.160145636999914,
                  58.326605536000088
                ],
                [
                  -5.167795376999919,
                  58.33926015800013
                ],
                [
                  -5.171009894999884,
                  58.346665757000139
                ],
                [
                  -5.17320716099988,
                  58.353949286000145
                ],
                [
                  -5.15330969999988,
                  58.353949286000145
                ],
                [
                  -5.163400844999956,
                  58.36456940300009
                ],
                [
                  -5.162912563999953,
                  58.374497789000017
                ],
                [
                  -5.155913865999878,
                  58.384466864000089
                ],
                [
                  -5.146473761999886,
                  58.394964911000059
                ],
                [
                  -5.145497199999909,
                  58.400051174000069
                ],
                [
                  -5.14671790299991,
                  58.406642971000153
                ],
                [
                  -5.146839972999885,
                  58.412420966000028
                ],
                [
                  -5.14305579299986,
                  58.414780992000075
                ],
                [
                  -5.135487433999913,
                  58.413763739
                ],
                [
                  -5.122222459999875,
                  58.409572658000073
                ],
                [
                  -5.116037563999925,
                  58.408596096000011
                ],
                [
                  -5.057972785999937,
                  58.387274481000034
                ],
                [
                  -5.016184048999918,
                  58.388128973000121
                ],
                [
                  -5.043934699999909,
                  58.400091864000061
                ],
                [
                  -5.053374803999901,
                  58.406642971000153
                ],
                [
                  -5.05028235599994,
                  58.414780992000075
                ],
                [
                  -5.057036912999877,
                  58.422186591000141
                ],
                [
                  -5.066151495999861,
                  58.417141018000123
                ],
                [
                  -5.076161261999857,
                  58.414496161000145
                ],
                [
                  -5.086822068999879,
                  58.413885809000178
                ],
                [
                  -5.098052537999877,
                  58.414780992000075
                ],
                [
                  -5.098052537999877,
                  58.422186591000141
                ],
                [
                  -5.088124152999882,
                  58.421942450000117
                ],
                [
                  -5.085031704999892,
                  58.422186591000141
                ],
                [
                  -5.085031704999892,
                  58.429022528000175
                ],
                [
                  -5.091786261999914,
                  58.429754950000117
                ],
                [
                  -5.09601803299995,
                  58.431463934000121
                ],
                [
                  -5.105539516999926,
                  58.436509507000139
                ],
                [
                  -5.050119594999956,
                  58.453802802000141
                ],
                [
                  -5.02554277299987,
                  58.447699286000059
                ],
                [
                  -4.995594855999883,
                  58.436509507000139
                ],
                [
                  -5.105539516999926,
                  58.48737213700015
                ],
                [
                  -5.105620897999927,
                  58.505560614000061
                ],
                [
                  -5.10366777299987,
                  58.514227606000148
                ],
                [
                  -5.095855272999899,
                  58.518866278000175
                ],
                [
                  -5.042795376999948,
                  58.535467841000141
                ],
                [
                  -5.027984178999901,
                  58.544094143000152
                ],
                [
                  -5.016184048999918,
                  58.559393622000115
                ],
                [
                  -5.022938605999855,
                  58.559393622000115
                ],
                [
                  -5.015207485999952,
                  58.580064195000105
                ],
                [
                  -5.011586066999882,
                  58.600572007000082
                ],
                [
                  -5.004953579999921,
                  58.617743231000091
                ],
                [
                  -4.988189256999903,
                  58.628322658000158
                ],
                [
                  -4.859486456999889,
                  58.613226630000142
                ],
                [
                  -4.835926886999857,
                  58.605047919000057
                ],
                [
                  -4.818104620999861,
                  58.592922268000152
                ],
                [
                  -4.817941860999895,
                  58.587591864000089
                ],
                [
                  -4.812814907999893,
                  58.571966864
                ],
                [
                  -4.806752081999889,
                  58.558417059000035
                ],
                [
                  -4.803822394999884,
                  58.559393622000115
                ],
                [
                  -4.804595506999903,
                  58.548325914000074
                ],
                [
                  -4.807240363999881,
                  58.539618231000176
                ],
                [
                  -4.811634894999941,
                  58.53204987200003
                ],
                [
                  -4.818104620999861,
                  58.52464427300005
                ],
                [
                  -4.799794074999909,
                  58.532456773000135
                ],
                [
                  -4.791818813999953,
                  58.541652736000017
                ],
                [
                  -4.789906378999888,
                  58.551743882000082
                ],
                [
                  -4.790150519999941,
                  58.56248607
                ],
                [
                  -4.785755988999938,
                  58.577053127000013
                ],
                [
                  -4.777088995999861,
                  58.583319403000147
                ],
                [
                  -4.771595831999917,
                  58.590399481000034
                ],
                [
                  -4.776519334999875,
                  58.607163804000052
                ],
                [
                  -4.758859829999977,
                  58.599107164000102
                ],
                [
                  -4.728016730999912,
                  58.577460028000033
                ],
                [
                  -4.711333787999877,
                  58.573065497000059
                ],
                [
                  -4.683257615999878,
                  58.56150950700011
                ],
                [
                  -4.67039954299986,
                  58.559393622000115
                ],
                [
                  -4.660023566999939,
                  58.555853583000115
                ],
                [
                  -4.659291144999912,
                  58.547552802000141
                ],
                [
                  -4.663238084999904,
                  58.538397528000147
                ],
                [
                  -4.667307094999956,
                  58.53204987200003
                ],
                [
                  -4.679025844999956,
                  58.523911851000108
                ],
                [
                  -4.714466925999943,
                  58.505601304000052
                ],
                [
                  -4.732411261999886,
                  58.480454820000077
                ],
                [
                  -4.751535610999952,
                  58.461615302000141
                ],
                [
                  -4.760975714999887,
                  58.44798411699999
                ],
                [
                  -4.742421027999882,
                  58.449530341000028
                ],
                [
                  -4.682972785999937,
                  58.48456452000012
                ],
                [
                  -4.673451300999943,
                  58.48737213700015
                ],
                [
                  -4.666859503999945,
                  58.502915757000082
                ],
                [
                  -4.650502081999946,
                  58.509955145000148
                ],
                [
                  -4.630441860999895,
                  58.51496002800009
                ],
                [
                  -4.612131313999925,
                  58.52464427300005
                ],
                [
                  -4.601063605999883,
                  58.541937567000147
                ],
                [
                  -4.595122850999871,
                  58.560003973000065
                ],
                [
                  -4.584950324999909,
                  58.57416413
                ],
                [
                  -4.560536261999886,
                  58.579901434000149
                ],
                [
                  -4.517486131999931,
                  58.575506903000175
                ],
                [
                  -4.475493943999936,
                  58.565619208000058
                ],
                [
                  -4.426503058999884,
                  58.546372789000102
                ],
                [
                  -4.426503058999884,
                  58.538885809000149
                ],
                [
                  -4.42788652299987,
                  58.535305080000072
                ],
                [
                  -4.42870032499988,
                  58.534735419000114
                ],
                [
                  -4.426503058999884,
                  58.52464427300005
                ],
                [
                  -4.449940558999856,
                  58.510199286
                ],
                [
                  -4.464751756999931,
                  58.492010809000092
                ],
                [
                  -4.477650519999941,
                  58.471340236000074
                ],
                [
                  -4.495350714999859,
                  58.449530341000028
                ],
                [
                  -4.478098110999952,
                  58.453558661
                ],
                [
                  -4.461171027999882,
                  58.462469794000029
                ],
                [
                  -4.433908657999979,
                  58.483628648000135
                ],
                [
                  -4.432728644999941,
                  58.487616278000118
                ],
                [
                  -4.433990037999962,
                  58.492377020000035
                ],
                [
                  -4.434234178999901,
                  58.49628327
                ],
                [
                  -4.43016516799986,
                  58.497992255000113
                ],
                [
                  -4.425933397999927,
                  58.49909088700015
                ],
                [
                  -4.38536536399991,
                  58.522406317000062
                ],
                [
                  -4.382394985999895,
                  58.52464427300005
                ],
                [
                  -4.343861456999917,
                  58.538885809000149
                ],
                [
                  -4.317005988999938,
                  58.545721747000172
                ],
                [
                  -4.306996222999942,
                  58.546372789000102
                ],
                [
                  -4.287180141999926,
                  58.542914130000113
                ],
                [
                  -4.257313605999855,
                  58.527980861000074
                ],
                [
                  -4.234730597999885,
                  58.52464427300005
                ],
                [
                  -4.248931443999879,
                  58.53204987200003
                ],
                [
                  -4.238189256999874,
                  58.536444403000118
                ],
                [
                  -4.232248501999948,
                  58.542425848000121
                ],
                [
                  -4.227691209999904,
                  58.54816315300009
                ],
                [
                  -4.22101803299995,
                  58.551947333000115
                ],
                [
                  -4.209706183999856,
                  58.552923895
                ],
                [
                  -4.190785285999937,
                  58.547837632000082
                ],
                [
                  -4.176991339999916,
                  58.546372789000102
                ],
                [
                  -4.168202277999882,
                  58.549383856000119
                ],
                [
                  -4.160552537999934,
                  58.562567450000174
                ],
                [
                  -4.149322068999936,
                  58.565619208000058
                ],
                [
                  -4.111195441999939,
                  58.565619208000058
                ],
                [
                  -4.090240037999905,
                  58.562079169000086
                ],
                [
                  -4.081450975999928,
                  58.561835028000033
                ],
                [
                  -4.070220506999931,
                  58.565619208000058
                ],
                [
                  -4.061512824999852,
                  58.572821356000091
                ],
                [
                  -4.048817511999886,
                  58.589585679000109
                ],
                [
                  -4.039784308999884,
                  58.592922268000152
                ],
                [
                  -4.030629035999908,
                  58.594061591000084
                ],
                [
                  -4.029042120999861,
                  58.595160223000121
                ],
                [
                  -4.02782141799986,
                  58.592718817
                ],
                [
                  -4.009266730999855,
                  58.573309637000179
                ],
                [
                  -4.003773566999911,
                  58.570624091000113
                ],
                [
                  -3.98143469999988,
                  58.573065497000059
                ],
                [
                  -3.895741339999916,
                  58.565619208000058
                ],
                [
                  -3.810129360999923,
                  58.573065497000059
                ],
                [
                  -3.766957160999908,
                  58.583726304000081
                ],
                [
                  -3.698353644999912,
                  58.611151434000035
                ],
                [
                  -3.65990149599989,
                  58.620835679
                ],
                [
                  -3.597564256999931,
                  58.62714264500012
                ],
                [
                  -3.565500454999949,
                  58.626613674000154
                ],
                [
                  -3.542591925999943,
                  58.620835679
                ],
                [
                  -3.552479620999861,
                  58.615464585000112
                ],
                [
                  -3.556263800999886,
                  58.613999742000075
                ],
                [
                  -3.532053188999896,
                  58.602118231000119
                ],
                [
                  -3.504017706999889,
                  58.603338934000035
                ],
                [
                  -3.447010870999861,
                  58.613999742000075
                ],
                [
                  -3.391468878999916,
                  58.60065338700015
                ],
                [
                  -3.364084438999953,
                  58.600816148000106
                ],
                [
                  -3.350819464999916,
                  58.620835679
                ],
                [
                  -3.367746548999918,
                  58.624701239
                ],
                [
                  -3.386057094999956,
                  58.631740627000156
                ],
                [
                  -3.402251756999931,
                  58.642035223000093
                ],
                [
                  -3.412912563999953,
                  58.655585028000061
                ],
                [
                  -3.390044725999957,
                  58.67177969
                ],
                [
                  -3.374867316999968,
                  58.677069403000175
                ],
                [
                  -3.358265753999916,
                  58.675482489000146
                ],
                [
                  -3.354359503999916,
                  58.670152085000083
                ],
                [
                  -3.35179602799991,
                  58.660834052000112
                ],
                [
                  -3.34788977799991,
                  58.652044989000061
                ]
              ]
            ]


            
          ]
        }
      }
    ]
  }